import React from "react";
import { Alert, Badge, Button, Col, Form, InputGroup, Modal, Row } from "react-bootstrap";
import Fontstyling, {
  clientListDrpDwnStyles,
} from "../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { Field, FieldArray, Formik } from "formik";
import * as Yup from "yup";
import CustomButton from "../../../components/common/CustomButton";
import DeleteModal from "../../../components/common/Modal/DeleteModal";
import CustomMaterialTable from "../../../components/common/CustomMaterialTable";
import toastFile from "../../../Service/ToastFile";
import CustomInputField from "../../../components/common/CustomInputField";
import Required from "../../../components/Required";
import {
  GetAllEmpoweRxDrugDiscountWithPagination,
  GetPBMList,
  getClientsDatabyPaginationbySearch,
} from "../../../api/User/commonApi";
import { useSelector } from "react-redux";
import {
  CreateOrUpdateEmpoweRxDrugDiscount,
  DeleteEmpoweRxDrugDiscount,
  DrugDiscountFileUpload,
  CheckBidFileRecordbyClientName,
  GetPresignedDrugFileURL
} from "../../../api/EmpowRxApi";
import editIcon from "../../../assets/icon/pencil-fill.svg";
import editIconWhite from "../../../assets/icon/pencil-fill-white.svg";
import deletIcon from "../../../assets/icon/trash-solid.svg";
import deletIconWhite from "../../../assets/icon/trash-solid-white.svg";
import showmore from "../../../assets/icon/showmore.svg";
import ReactTooltip from "react-tooltip";
import { IoEyeOutline } from "react-icons/io5";
import {
  AWPDiscounts,
  AWPPercentage,
  dollerIcon,
  DrugfileType,
} from "../../../Utils/constants";
import { AsyncPaginate } from "react-select-async-paginate";
import { useLocation } from "react-router-dom";
import { CSVLink } from "react-csv";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import Select from "react-select";
import { GetStates } from "../../../api/ClinicalIntake/ClinicalIntakeApi";
import moment from "moment";
import { Loader } from "rsuite";
import { FaRegClone } from "react-icons/fa";
import theme from "../../../Utils/theme";

const schema = Yup.object().shape({
  PBM: Yup.string().trim().required("Please select PBM Name"),
  client_Name: Yup.object().required("Please select Client Name"),
  ContractTermDate: Yup.date().required(
    "Please enter Current Contract Termination Date"
  ),
  NumberOfMembers: Yup.number()
    .positive("Number must be a valid  positive number.")
    .integer("Please enter a integer number.")
    .typeError("Please enter a valid number.")
    .required("Please enter number of members"),
  NumberOfEmployees: Yup.number()
    .positive("Number must be a valid  positive number.")
    .integer("Please enter a integer number.")
    .typeError("Please enter a valid number.")
    .required("Please enter number of employees"),
  Retail30Network: Yup.string()
    .trim()
    .required("Please enter Retail 30 Network"),
  Retail90Network: Yup.string()
    .trim()
    .required("Please enter Retail 90 Network"),
  MailProg: Yup.string().trim().required("Please enter Mail Program"),
  SpecialProg: Yup.string().trim().required("Please enter Specialty Program"),
  ClinicProg: Yup.string().trim().required("Please enter Clinical Programs"),
  FormularyStrategy: Yup.string()
    .trim()
    .required("Please enter Formulary Strategy"),
  SpecCopayCard: Yup.string()
    .trim()
    .required("Please enter Specialty Copay Card"),
  AlternateFund: Yup.string()
    .trim()
    .required("Please enter Alternative Funding"),
  AccumulatorProgram: Yup.string()
    .trim()
    .required("Please enter Accumulator Adjustment Program"),
  NonSp_MailBrands_AWPDiscounts: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
  // .required("Please enter AWP Discounts"),
  NonSp_MailBrands_DispensingFees: Yup.number()
    .moreThan(-0.001, "Number must be a valid  positive number.")
    .typeError("Please enter a valid number."),
  // .required("Please enter AWP Discounts"),
  NonSp_MailBrands_Rebates: Yup.number()
    .moreThan(-0.001, "Number must be a valid  positive number.")
    .typeError("Please enter a valid number."),
  // .required("Please enter Rebates"),
  NonSp_MailGenerics_AWPDiscounts: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
  // .required("Please enter AWP Discounts"),
  NonSp_MailGenerics_DispensingFees: Yup.number()
    .moreThan(-0.001, "Number must be a valid  positive number.")
    .typeError("Please enter a valid number."),
  // .required("Please enter AWP Discounts"),
  NonSp_Retail30Brands_Rebates: Yup.number()
    .moreThan(-0.001, "Number must be a valid  positive number.")
    .typeError("Please enter a valid number."),
  // .required("Please enter Rebates"),
  NonSp_Retail30Brands_AWPDiscounts: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
  // .required("Please enter AWP Discounts"),
  NonSp_Retail30Brands_DispensingFees: Yup.number()
    .moreThan(-0.001, "Number must be a valid  positive number.")
    .typeError("Please enter a valid number."),
  // .required("Please enter AWP Discounts"),
  NonSp_Retail90Brands_Rebates: Yup.number()
    .moreThan(-0.001, "Number must be a valid  positive number.")
    .typeError("Please enter a valid number."),
  // .required("Please enter Rebates"),
  NonSp_Retail30Generics_AWPDiscounts: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
  // .required("Please enter AWP Discounts"),
  NonSp_Retail30Generics_DispensingFees: Yup.number()
    .moreThan(-0.001, "Number must be a valid  positive number.")
    .typeError("Please enter a valid number."),
  // .required("Please enter AWP Discounts"),
  NonSp_Retail90Brands_AWPDiscounts: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
  // .required("Please enter AWP Discounts"),
  NonSp_Retail90Brands_DispensingFees: Yup.number()
    .moreThan(-0.001, "Number must be a valid  positive number.")
    .typeError("Please enter a valid number."),
  // .required("Please enter AWP Discounts"),
  NonSp_Retail90Generics_AWPDiscounts: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
  // .required("Please enter AWP Discounts"),
  NonSp_Retail90Generics_DispensingFees: Yup.number()
    .moreThan(-0.001, "Number must be a valid  positive number.")
    .typeError("Please enter a valid number."),
  // .required("Please enter AWP Discounts"),
  nonSpltdiscountDispensingFeeGuarantees: Yup.string()
    .trim()
    .required("This field is required"),
  nonSplState: Yup.string().trim().required("This field is required"),
  nonSpltdiscountDispensingFeeGuaranteesComment: Yup.string().test(
    "match-Fee-Guarantees",
    "This field is required",
    function (value) {
      const { nonSpltdiscountDispensingFeeGuarantees } = this.parent;
      if (
        nonSpltdiscountDispensingFeeGuarantees &&
        nonSpltdiscountDispensingFeeGuarantees.includes("Other - list all exclusions in the text box provided") &&
        (value === undefined || value === "")
      ) {
        return false;
      } else {
        return true;
      }
    }
  ),
  nonSpltRebatediscountDispensingFeeGuarantees: Yup.string()
    .trim()
    .required("This field is required"),
  nonRebateSplState: Yup.string().trim().required("This field is required"),
  nonSpltRebatediscountDispensingFeeGuaranteesComment: Yup.string().test(
    "match-Fee-Guarantees",
    "This field is required",
    function (value) {
      const { nonSpltRebatediscountDispensingFeeGuarantees } = this.parent;
      if (
        nonSpltRebatediscountDispensingFeeGuarantees &&
        nonSpltRebatediscountDispensingFeeGuarantees.includes("Other - list all exclusions in the text box provided") &&
        (value === undefined || value === "")
      ) {
        return false;
      } else {
        return true;
      }
    }
  ),

  nonrebateProposal: Yup.string().trim().required("This field is required"),
  nonrebateStructure: Yup.string().trim().required("This field is required"),
  nonWholesaleAcquisitionCostStrategy: Yup.string()
    .trim()
    .required("This field is required"),
  InsulinClaims: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Please enter value greater or equal to 0."),
  RetailNonPreferredTier3BrandClaims: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Please enter value greater or equal to 0.")
    ,
  Retail90NonPreferredTier3BrandClaims: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Please enter value greater or equal to 0.")
    ,
  MailNonPreferredTier3BrandClaims: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Please enter value greater or equal to 0.")
    ,
  Sp_MailBrands_AWPDiscounts: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
  Sp_MailBrands_DispensingFees: Yup.number()
    .moreThan(-0.001, "Number must be a valid  positive number.")
    .typeError("Please enter a valid number."),
  Sp_MailBrands_Rebates: Yup.number()
    .moreThan(-0.001, "Number must be a valid  positive number.")
    .typeError("Please enter a valid number."),
  // .required("Please enter Rebates"),
  Sp_MailGenerics_AWPDiscounts: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
  // .required("Please enter AWP Discounts"),
  Sp_MailGenerics_DispensingFees: Yup.number()
    .moreThan(-0.001, "Number must be a valid  positive number.")
    .typeError("Please enter a valid number."),
  // .required("Please enter AWP Discounts"),
  Sp_Retail30Brands_Rebates: Yup.number()
    .moreThan(-0.001, "Number must be a valid  positive number.")
    .typeError("Please enter a valid number."),
  // .required("Please enter Rebates"),
  Sp_Retail30Brands_AWPDiscounts: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
  // .required("Please enter AWP Discounts"),
  Sp_Retail30Brands_DispensingFees: Yup.number()
    .moreThan(-0.001, "Number must be a valid  positive number.")
    .typeError("Please enter a valid number."),
  // .required("Please enter AWP Discounts"),
  Sp_Retail90Brands_Rebates: Yup.number()
    .moreThan(-0.001, "Number must be a valid  positive number.")
    .typeError("Please enter a valid number."),
  // .required("Please enter Rebates"),
  Sp_Retail30Generics_AWPDiscounts: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
  // .required("Please enter AWP Discounts"),
  Sp_Retail30Generics_DispensingFees: Yup.number()
    .moreThan(-0.001, "Number must be a valid  positive number.")
    .typeError("Please enter a valid number."),
  // .required("Please enter AWP Discounts"),
  Sp_Retail90Brands_AWPDiscounts: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
  // .required("Please enter AWP Discounts"),
  Sp_Retail90Brands_DispensingFees: Yup.number()
    .moreThan(-0.001, "Number must be a valid  positive number.")
    .typeError("Please enter a valid number."),
  // .required("Please enter AWP Discounts"),
  Sp_Retail90Generics_AWPDiscounts: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
  // .required("Please enter AWP Discounts"),
  Sp_Retail90Generics_DispensingFees: Yup.number()
    .moreThan(-0.001, "Number must be a valid  positive number.")
    .typeError("Please enter a valid number."),
  // .required("Please enter AWP Discounts"),
  Sp_SpecialtyPharmacyBrands_Rebates: Yup.number()
    .moreThan(-0.001, "Number must be a valid  positive number.")
    .typeError("Please enter a valid number."),
  // .required("Please enter Rebates"),
  spltdiscountDispensingFeeGuarantees: Yup.string()
    .trim()
    .required("This field is required"),
  splState: Yup.string().trim().required("This field is required"),
  spltdiscountDispensingFeeGuaranteesComment: Yup.string().test(
    "match-Fee-Guarantees",
    "This field is required",
    function (value) {
      const { spltdiscountDispensingFeeGuarantees } = this.parent;
      if (
        spltdiscountDispensingFeeGuarantees &&
        spltdiscountDispensingFeeGuarantees.includes("Other - list all exclusions in the text box provided") &&
        (value === undefined || value === "")
      ) {
        return false;
      } else {
        return true;
      }
    }
  ),
  spltRebatediscountDispensingFeeGuarantees: Yup.string()
    .trim()
    .required("This field is required"),
  splRebateState: Yup.string().trim().required("This field is required"),
  spltRebatediscountDispensingFeeGuaranteesComment: Yup.string().test(
    "match-Fee-Guarantees",
    "This field is required",
    function (value) {
      const { spltRebatediscountDispensingFeeGuarantees } = this.parent;
      if (
        spltRebatediscountDispensingFeeGuarantees &&
        spltRebatediscountDispensingFeeGuarantees.includes("Other - list all exclusions in the text box provided") &&
        (value === undefined || value === "")
      ) {
        return false;
      } else {
        return true;
      }
    }
  ),
  splrebateProposal: Yup.string().trim().required("This field is required"),
  splrebateStructure: Yup.string().trim().required("This field is required"),
  splWholesaleAcquisitionCostStrategy: Yup.string()
    .trim()
    .required("This field is required"),
  LimitedDistributionDrugClaims: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Please enter value greater or equal to 0."),
  BiosimilarClaims: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Please enter value greater or equal to 0."),
  HIVClaims: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Please enter value greater or equal to 0."),
  SpecialtyNonPreferredTier3BrandClaims: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Please enter value greater or equal to 0.")
    ,
  SpecialtyRetail90NonPreferredTier3BrandClaims: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Please enter value greater or equal to 0.")
    ,
  SpecialtyMailNonPreferredorTier3BrandClaims: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Please enter value greater or equal to 0.")
    ,
  SpecialtyPBMNonPreferredorTier3BrandPharmacyClaims: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Please enter value greater or equal to 0.")
    ,
  PBMadministrationfeesBasis: Yup.string()
    .trim()
    .required("This field is required"),
  PBMadministrationfeesResponseFormat: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Please enter value greater or equal to 0.")
    .lessThan(10, "Please enter less than $10")
    .test("No-fee", "This field is required", function (value) {
      const { PBMadministrationfeesBasis } = this.parent;
      if (
        PBMadministrationfeesBasis !== "" &&
        PBMadministrationfeesBasis !== undefined
      ) {
        if (
          JSON.parse(PBMadministrationfeesBasis).value !== "No Fee" &&
          value === undefined
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    }),

  PBMtransactionfeesBasis: Yup.string()
    .trim()
    .required("This field is required"),
  PBMtotalpaidrebatesResponseFormat: Yup.number()
    .required("This field is required")
    .typeError("Please enter a valid number.")
    .min(0, "please enter value greater or equal to 0."),
  PBMtransactionfeesResponseFormat: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Please enter value greater or equal to 0.")
    .lessThan(10, "Please enter less than $10")
    .test("No-fee", "This field is required", function (value) {
      const { PBMtransactionfeesBasis } = this.parent;
      if (
        PBMtransactionfeesBasis !== "" &&
        PBMtransactionfeesBasis !== undefined
      ) {
        if (
          !(
            JSON.parse(PBMtransactionfeesBasis).value === "No Fee" ||
            JSON.parse(PBMtransactionfeesBasis).value === "Not Applicable"
          ) &&
          value === undefined
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    }),
  CoalitionorAggregatorfeesBasis: Yup.string()
    .trim()
    .required("This field is required"),
  CoalitionorAggregatorfeesResponseFormat: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Please enter value greater or equal to 0.")
    .test("No-fee", "This field is required", function (value) {
      const { CoalitionorAggregatorfeesBasis } = this.parent;
      if (
        CoalitionorAggregatorfeesBasis !== "" &&
        CoalitionorAggregatorfeesBasis !== undefined
      ) {
        if (
          JSON.parse(CoalitionorAggregatorfeesBasis).value !== "No Fee" &&
          value === undefined
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    })
    .test("flat-fee", "Please enter less than $500000", function (value) {
      const { CoalitionorAggregatorfeesBasis } = this.parent;
      if (
        CoalitionorAggregatorfeesBasis !== "" &&
        CoalitionorAggregatorfeesBasis !== undefined
      ) {
        if (
          JSON.parse(CoalitionorAggregatorfeesBasis).value === "Flat Fee" &&
          value > 500000
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    })
    .test("no-flat-fee", "Please enter less than $10", function (value) {
      const { CoalitionorAggregatorfeesBasis } = this.parent;
      if (
        CoalitionorAggregatorfeesBasis !== "" &&
        CoalitionorAggregatorfeesBasis !== undefined
      ) {
        if (
          JSON.parse(CoalitionorAggregatorfeesBasis).value !== "Flat Fee" &&
          value > 10
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    }),

  onsitePharmacyPBMAdministrationFeeResponseFormat: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Please enter value greater or equal to 0."),
  onsitePharmacyAggregatorAdministrationFeeResponseFormat: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Please enter value greater or equal to 0."),
  retailNetworkPricingStructure: Yup.string().trim().required("This field is required"),
  retailNetworkPricingStructureComment: Yup.string().test(
    "is-required",
    "This field is required",
    function (value) {
      const { retailNetworkPricingStructure } = this.parent;
      let parsedValue = retailNetworkPricingStructure
        ? JSON.parse(retailNetworkPricingStructure)
        : "";
      if (parsedValue?.value === "Other - Explain") {
        return !!value?.trim();
      }
      return true;
    }
  ),
  mailProgramPricingStructure: Yup.string().trim().required("This field is required"),
  mailProgramPricingStructureComment: Yup.string().test(
    "is-required",
    "This field is required",
    function (value) {
      const { mailProgramPricingStructure } = this.parent;
      let parsedValue = mailProgramPricingStructure
        ? JSON.parse(mailProgramPricingStructure)
        : "";
      if (parsedValue?.value === "Other - Explain") {
        return !!value?.trim();
      }
      return true;
    }
  ),
  specialtyProgramPricingStructure: Yup.string().trim().required("This field is required"),
  specialtyProgramPricingStructureComment: Yup.string().test(
    "is-required",
    "This field is required",
    function (value) {
      const { specialtyProgramPricingStructure } = this.parent;
      let parsedValue = specialtyProgramPricingStructure
        ? JSON.parse(specialtyProgramPricingStructure)
        : "";
      if (parsedValue?.value === "Other - Explain") {
        return !!value?.trim();
      }
      return true;
    }
  ),
  rebateProgramPricingStructure: Yup.string().trim().required("This field is required"),
  rebateProgramPricingStructureComment: Yup.string().test(
    "is-required",
    "This field is required",
    function (value) {
      const { rebateProgramPricingStructure } = this.parent;
      let parsedValue = rebateProgramPricingStructure
        ? JSON.parse(rebateProgramPricingStructure)
        : "";
      if (parsedValue?.value === "Other - Explain") {
        return !!value?.trim();
      }
      return true;
    }
  ),
});

const ClientRxInformation = () => {
  const user = useSelector((state) => state.userDetails.value);
  const [clientData, setClientData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoader, setIsLoader] = useState({
    save:false,
    complete:false
  });
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [witchAction, setWitchAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showMoreModal, setShowMoreModal] = useState(false);
  const [isGetData, setIsGetData] = useState(false);
  const buttonRef = useRef(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [pbmList, setPbmList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [showTable, setShowTable] = useState(true);
  const [data, setData] = useState([]);
  const [empoweRxDrugDiscountData,setEmpoweRxDrugDiscountData] = useState([]);
  const [PBMfile, setPBMFile] = useState(null);
  const [HospitalHealthSystemFile, setHospitalHealthSystemFile] =
    useState(null);
  const [PBMClaimsFile, setPBMClaimsFile] = useState(null);
  const [clientStatus, setClientStatus] = useState(null);
  const formikRef = useRef()
  const [errorPreventingModel,setErrorPreventingModel] = useState(false)

  const datetimeString = selectedRowData?.currentContractTerminationDate ?? "";
  const year = datetimeString?.slice(0, 4);
  const month = datetimeString?.slice(5, 7);
  const day = datetimeString?.slice(8, 10);
  const specialtyDrugs =
    selectedRowData && JSON.parse(selectedRowData?.specialtyDrugs);
  const noSpecialtyDrugs =
    selectedRowData && JSON.parse(selectedRowData?.nonSpecialtyDrugs);
  const nonSpecialtySDFPGE =
    selectedRowData && JSON.parse(selectedRowData?.nonSpecialtySDFPGE);
  const nonRebateGuaranteesExclusions =
    selectedRowData &&
    JSON.parse(selectedRowData?.nonRebateGuaranteesExclusions);
  const specialtySDFPGE =
    selectedRowData && JSON.parse(selectedRowData?.specialtySDFPGE);
  const rebateGuaranteesExclusions =
    selectedRowData && JSON.parse(selectedRowData?.rebateGuaranteesExclusions);
  const pbmFeesCredits =
    selectedRowData && JSON.parse(selectedRowData?.pbmFeesCredits);

  const formattedDate = `${month}-${day}-${year}`;
  const location = useLocation();
  const column = [
    { title: "Client Name", field: "clientName", type: "text" },
    { title: "PBM Name", field: "pbmName", type: "text" },
    { title: "Number of Members", field: "numberOfMembers", type: "number", render:(rowData) => rowData.numberOfMembers > 0 ? rowData.numberOfMembers : '' },
    {
      title: "Number of Employees",
      field: "numberOfEmployees",
      type: "number",
      render:(rowData) => rowData.numberOfEmployees > 0 ? rowData.numberOfEmployees : ''
    },
    {
      title: "Current Contract Termination Date",
      field: "currentContractTerminationDate",
      type: "date",
      render: (rowData) => (rowData.currentContractTerminationDate  && rowData.currentContractTerminationDate !== '1900-01-01T00:00:00'? moment(rowData.currentContractTerminationDate).format("MM/DD/YYYY") : null),
    },
    { title: "Retail 30 Network ", field: "retail30Network", type: "number" },
    { title: "Retail 90 Network", field: "retai90Network", type: "number" },
    { title: "Mail Program", field: "mailProgram", type: "text" },
    { title: "Specialty Program", field: "specialtyProgram", type: "text" },
    { title: "Formulary Strategy", field: "formularyStrategy", type: "text" },
    { title: "Clinical Programs", field: "clinicalPrograms", type: "text" },
    {
      title: "Specialty Copay Card",
      field: "specialtyCopayCard",
      type: "text",
    },
    { title: "Alternative Funding", field: "alternativeFunding", type: "text" },
    {
      title: "Accumulator Adjustment Program",
      field: "accumulatorAdjustmentProgram",
      type: "text",
    },
    { title: "Onsite Pharmacy ID", field: "onsitePharmacyID", type: "text" },
    {
      title: "Non Specialty Drugs : MailBrands-AWPDiscounts (%)",
      field: "NonSp_MailBrands_AWPDiscounts",
      type: "number",
      hidden: true,
    },
    {
      title: "Non Specialty Drugs :  MailGenerics-AWPDiscounts (%)",
      field: "NonSp_MailGenerics_AWPDiscounts",
      type: "number",
      hidden: true,
      export: true,
    },
    {
      title: "Non Specialty Drugs :  Retail30Brands-AWPDiscounts (%)",
      field: "NonSp_Retail30Brands_AWPDiscounts",
      type: "number",
      hidden: true,
    },
    {
      title: "Non Specialty Drugs :  Retail30Generics-AWPDiscounts (%)",
      field: "NonSp_Retail30Generics_AWPDiscounts",
      type: "number",
      hidden: true,
    },
    {
      title: "Non Specialty Drugs :  Retail90Brands-AWPDiscounts (%)",
      field: "NonSp_Retail90Brands_AWPDiscounts",
      type: "number",
      hidden: true,
      export: true,
    },
    {
      title: "Non Specialty Drugs : Retail90Generics-AWPDiscounts (%)",
      field: "NonSp_Retail90Generics_AWPDiscounts",
      type: "number",
      hidden: true,
    },
    {
      title: "Non Specialty Drugs : MailBrands DispensingFees ($)",
      field: "NonSp_MailBrands_DispensingFees",
      type: "number",
      hidden: true,
    },
    {
      title: "Non Specialty Drugs : MailGenerics DispensingFees ($)",
      field: "NonSp_MailGenerics_DispensingFees",
      type: "number",
      hidden: true,
      export: true,
    },
    {
      title: "Non Specialty Drugs : Retail30Brands DispensingFees ($)",
      field: "NonSp_Retail30Brands_DispensingFees",
      type: "number",
      hidden: true,
    },
    {
      title: "Non Specialty Drugs : Retail90Brands DispensingFeess ($)",
      field: "NonSp_Retail90Brands_DispensingFees",
      type: "number",
      hidden: true,
    },
    {
      title: "Non Specialty Drugs : Retail30Generics DispensingFees ($)",
      field: "NonSp_Retail30Generics_DispensingFees",
      type: "number",
      hidden: true,
      export: true,
    },
    {
      title: "Non Specialty Drugs : Retail90Generics DispensingFees ($)",
      field: "NonSp_Retail90Generics_DispensingFeess",
      type: "number",
      hidden: true,
    },
    {
      title: "Non Specialty Drugs : MailBrands Rebates ($)",
      field: "NonSp_MailBrands_Rebates",
      type: "number",
      hidden: true,
    },
    {
      title: "Non Specialty Drugs : Retail30Brands Rebates ($)",
      field: "NonSp_Retail30Brands_Rebates",
      type: "number",
      hidden: true,
      export: true,
    },
    {
      title: "Non Specialty Drugs : Retail90Brands Rebates ($)",
      field: "NonSp_Retail90Brands_Rebates",
      type: "number",
      hidden: true,
    },
    {
      title:
        "Non-Specialty AWP-% and Dispensing Fee Price Guarantees and Exclusions : Claim types that are excluded from your guarantees",
      field: "nonSpltdiscountDispensingFeeGuarantees",
      type: "text",
      hidden: true,
    },
    {
      title:
        "Non-Specialty AWP-% and Dispensing Fee Price Guarantees and Exclusions : State",
      field: "nonSplState",
      type: "text",
      hidden: true,
    },
    {
      title:
        "Non-Specialty AWP-% and Dispensing Fee Price Guarantees and Exclusions : Comment",
      field: "nonSpltdiscountDispensingFeeGuaranteesComment",
      type: "text",
      hidden: true,
    },
    {
      title:
        "Rebate Guarantees and Exclusions : Claim types that are excluded from your guarantees",
      field: "nonSpltRebatediscountDispensingFeeGuarantees",
      type: "text",
      hidden: true,
    },
    {
      title: "Rebate Guarantees and Exclusions : State",
      field: "nonRebateSplState",
      type: "text",
      hidden: true,
    },
    {
      title: "Rebate Guarantees and Exclusions : Comment",
      field: "nonSpltRebatediscountDispensingFeeGuaranteesComment",
      type: "text",
      hidden: true,
    },
    {
      title: "Rebate Guarantees and Exclusions : Confirm your rebate proposal",
      field: "nonrebateProposal",
      type: "text",
      hidden: true,
    },
    {
      title: "Rebate Guarantees and Exclusions : Confirm your rebate structure",
      field: "nonrebateStructure",
      type: "text",
      hidden: true,
    },
    {
      title:
        "Rebate Guarantees and Exclusions : all products excluded from rebates due to low Wholesale Acquisition Cost (WAC) strategy",
      field: "nonWholesaleAcquisitionCostStrategy",
      type: "text",
      hidden: true,
    },
    {
      title: "Rebate Guarantees and Exclusions : Insulin claims",
      field: "InsulinClaims",
      type: "number",
      hidden: true,
    },
    {
      title:
        "Rebate Guarantees and Exclusions : Retail Non-preferred or Tier 3 brand claims",
      field: "RetailNonPreferredTier3BrandClaims",
      type: "number",
      hidden: true,
    },
    {
      title:
        "Rebate Guarantees and Exclusions : Retail 90 Non-preferred or Tier 3 brand claims",
      field: "Retail90NonPreferredTier3BrandClaims",
      type: "number",
      hidden: true,
    },
    {
      title:
        "Rebate Guarantees and Exclusions : Mail Non-preferred or Tier 3 brand claims",
      field: "MailNonPreferredTier3BrandClaims",
      type: "number",
      hidden: true,
    },

    {
      title: "Specialty Drugs : MailBrands-AWPDiscounts (%)",
      field: "Sp_MailBrands_AWPDiscounts",
      type: "number",
      hidden: true,
    },
    {
      title: "Specialty Drugs : MailGenerics-AWPDiscounts (%)",
      field: "Sp_MailGenerics_AWPDiscounts",
      type: "number",
      hidden: true,
    },
    {
      title: "Specialty Drugs : Retail30Brands-AWPDiscounts (%)",
      field: "Sp_Retail30Brands_AWPDiscounts",
      type: "number",
      hidden: true,
    },
    {
      title: "Specialty Drugs : Retail90Brands-AWPDiscounts (%)",
      field: "Sp_Retail90Brands_AWPDiscounts",
      type: "number",
      hidden: true,
    },
    {
      title: "Specialty Drugs : Retail30Generics-AWPDiscounts (%)",
      field: "Sp_Retail30Generics_AWPDiscounts",
      type: "number",
      hidden: true,
    },
    {
      title: "Specialty Drugs : Retail90Generics-AWPDiscounts (%)",
      field: "Sp_Retail90Generics_AWPDiscounts",
      type: "number",
      hidden: true,
    },
    {
      title: "Specialty Drugs : MailBrands DispensingFees ($)",
      field: "Sp_MailBrands_DispensingFees",
      type: "number",
      hidden: true,
    },
    {
      title: "Specialty Drugs : MailGenerics DispensingFees ($)",
      field: "Sp_MailGenerics_DispensingFees",
      type: "number",
      hidden: true,
    },
    {
      title: "Specialty Drugs : Retail30Brands DispensingFees ($)",
      field: "Sp_Retail30Brands_DispensingFees",
      type: "number",
      hidden: true,
    },
    {
      title: "Specialty Drugs : Retail90Brands DispensingFees ($)",
      field: "Sp_Retail90Brands_DispensingFees",
      type: "number",
      hidden: true,
    },
    {
      title: "Specialty Drugs : Retail30Generics DispensingFees ($)",
      field: "Sp_Retail30Generics_DispensingFees",
      type: "number",
      hidden: true,
    },
    {
      title: "Specialty Drugs : Retail90Generics DispensingFees ($)",
      field: "Sp_Retail90Generics_DispensingFees",
      type: "number",
      hidden: true,
    },
    {
      title: "Specialty Drugs : MailBrands Rebates ($)",
      field: "Sp_MailBrands_Rebates",
      type: "number",
      hidden: true,
    },
    {
      title: "Specialty Drugs : Retail30Brands Rebates ($)",
      field: "Sp_Retail30Brands_Rebates",
      type: "number",
      hidden: true,
    },
    {
      title: "Specialty Drugs : Retail90Brands Rebates ($)",
      field: "Sp_Retail90Brands_Rebates",
      type: "number",
      hidden: true,
    },
    {
      title: "Specialty Drugs : SpecialtyPharmacyBrands Rebates ($)",
      field: "Sp_SpecialtyPharmacyBrands_Rebates",
      type: "number",
      hidden: true,
    },
    {
      title:
        "Specialty AWP-% and Dispensing Fee Price Guarantees and Exclusions : Claim types that are excluded from your guarantees",
      field: "spltdiscountDispensingFeeGuarantees",
      type: "text",
      hidden: true,
    },
    {
      title:
        "Specialty AWP-% and Dispensing Fee Price Guarantees and Exclusions: State",
      field: "splState",
      type: "text",
      hidden: true,
    },
    {
      title:
        "Specialty AWP-% and Dispensing Fee Price Guarantees and Exclusions : Comment",
      field: "spltdiscountDispensingFeeGuaranteesComment",
      type: "text",
      hidden: true,
    },
    {
      title:
        "Rebate Guarantees and Exclusions : Claim types that are excluded from your guarantees",
      field: "spltRebatediscountDispensingFeeGuarantees",
      type: "text",
      hidden: true,
    },
    {
      title: "Rebate Guarantees and Exclusions : State",
      field: "splRebateState",
      type: "text",
      hidden: true,
    },
    {
      title: "Rebate Guarantees and Exclusions : Comment",
      field: "spltRebatediscountDispensingFeeGuaranteesComment",
      type: "text",
      hidden: true,
    },
    {
      title: "Rebate Guarantees and Exclusions : Confirm your rebate proposal",
      field: "splrebateProposal",
      type: "text",
      hidden: true,
    },
    {
      title: "Rebate Guarantees and Exclusions : Confirm your rebate structure",
      field: "splrebateStructure",
      type: "text",
      hidden: true,
    },
    {
      title:
        "Rebate Guarantees and Exclusions : all products excluded from rebates due to low Wholesale Acquisition Cost (WAC) strategy",
      field: "splWholesaleAcquisitionCostStrategy",
      type: "text",
      hidden: true,
    },
    {
      title:
        "Rebate Guarantees and Exclusions : Limited Distribution Drug claims",
      field: "LimitedDistributionDrugClaims",
      type: "text",
      hidden: true,
    },
    {
      title: "Rebate Guarantees and Exclusions : Biosimilar claims",
      field: "BiosimilarClaims",
      type: "text",
      hidden: true,
    },
    {
      title: "Rebate Guarantees and Exclusions : HIV claims",
      field: "HIVClaims",
      type: "text",
      hidden: true,
    },
    {
      title:
        "Rebate Guarantees and Exclusions : Specialty Retail Non-preferred or Tier 3 brand claims",
      field: "SpecialtyNonPreferredTier3BrandClaims",
      type: "text",
      hidden: true,
    },
    {
      title:
        "Rebate Guarantees and Exclusions : Specialty Retail 90 Non-Preferred Tier 3 Brand claims",
      field: "SpecialtyRetail90NonPreferredTier3BrandClaims",
      type: "text",
      hidden: true,
    },
    {
      title:
        "Rebate Guarantees and Exclusions : Specialty Mail Non-Preferred or Tier 3 Brand Claims",
      field: "SpecialtyMailNonPreferredorTier3BrandClaims",
      type: "text",
      hidden: true,
    },
    {
      title:
        "Rebate Guarantees and Exclusions : Specialty PBM Non-Preferred or Tier 3 Brand Pharmacy Claims",
      field: "SpecialtyPBMNonPreferredorTier3BrandPharmacyClaims",
      type: "text",
      hidden: true,
    },
    {
      title: "PBM administration type",
      field: "PBMadministrationfeesBasis",
      type: "text",
      hidden: true,
    },
    {
      title: "PBM administration fees",
      field: "PBMadministrationfeesResponseFormat",
      type: "number",
      hidden: true,
    },
    {
      title: "PBM total paid rebates",
      field: "PBMtotalpaidrebatesResponseFormat",
      type: "number",
      hidden: true,
    },
    {
      title: "PBM transaction type",
      field: "PBMtransactionfeesBasis",
      type: "text",
      hidden: true,
    },
    {
      title: "PBM transaction fees",
      field: "PBMtransactionfeesResponseFormat",
      type: "number",
      hidden: true,
    },
    {
      title: "Coalition or Aggregator membership type",
      field: "CoalitionorAggregatorfeesBasis",
      type: "text",
      hidden: true,
    },
    {
      title: "Coalition or Aggregator membership fees",
      field: "CoalitionorAggregatorfeesResponseFormat",
      type: "number",
      hidden: true,
    },
    {
      title: "list of other fees",
      field: "listandspecifyallotherfees",
      type: "number",
      hidden: true,
    },
    {
      title: "Onsite Pharmacy PBM Administration type",
      field: "onsitePharmacyPBMAdministrationFeeBasis",
      type: "text",
      hidden: true,
    },
    {
      title: "Onsite Pharmacy PBM Administration Fee",
      field: "onsitePharmacyPBMAdministrationFeeResponseFormat",
      type: "number",
      hidden: true,
    },
    {
      title: "Onsite Pharmacy Aggregator Administration type",
      field: "onsitePharmacyAggregatorAdministrationFeeBasis",
      type: "text",
      hidden: true,
    },
    {
      title: "Onsite Pharmacy Aggregator Administration Fee",
      field: "onsitePharmacyAggregatorAdministrationFeeResponseFormat",
      type: "number",
      hidden: true,
    },
    {
      title: "Status",
      field: "Status",
      type: "text",
      render: (item) => {
        let badgeColor;
        switch (item.status) {
          case "In Progress":
            badgeColor = "warning";
            break;
          case "Complete":
            badgeColor = "primary";
            break;
        }
        return (
          <Badge
            pill
            className="fw-normal py-1 px-3"
            bg={badgeColor}
            style={{ fontSize: "10px" }}
          >
            {(item.status === "Complete" ? 'Completed' :  item.status) || ""}
          </Badge>
        );
      },
    },
    { title: "RFPSent", 
      field: "RFPSent", 
      type: "text",
      hidden: true },
    {
      title: "Actions",
      minWidth: "110px",
      maxWidth: "75px",
      cellStyle: { textAlign: "center" },
      headerStyle: { textAlign: "center" },
      sorting: false,
      render: (rowData) =>
        rowData.status !== "" ? (
          <>
            <IoEyeOutline
              width="11"
              className="m-2 cursor-pointer"
              style={{ fontSize: "15px" }}
              alt="show more"
              onClick={() => {
                setSelectedRowData(rowData);
                setShowMoreModal(true);
                setWitchAction("showMore");
              }}
            />
            {(user?.UserRole === "Pharmacy" || user?.UserRole === "Admin")  && !rowData.rfpSent && (
              <>
                <img
                  src={
                    selectedRow === rowData.tableData.id
                      ? editIconWhite
                      : editIcon
                  }
                  width="11"
                  className="m-2 cursor-pointer"
                  alt="edit icon"
                  onClick={() => {
                    setWitchAction("update");
                    setSelectedRowData(rowData);
                    setShowModal(true);
                  }}
                />
                <img
                  src={
                    selectedRow === rowData.tableData.id
                      ? deletIconWhite
                      : deletIcon
                  }
                  width="11"
                  className="m-2 cursor-pointer"
                  alt="delete icon"
                  onClick={() => {
                    setWitchAction("delete");
                    setSelectedRowData(rowData);
                    setShowModal(true);
                  }}
                />
              </>
            )}
            {(user?.UserRole === "Pharmacy" || user?.UserRole === "Admin")  && rowData.status === 'Complete' && (
              <Button
                   style={{
                    backgroundColor: "transparent",
                    border: "none",
                  }}
                  onClick={() => handleDuplicateClick(rowData.id)}
                >
                  <FaRegClone size={11} color={selectedRow === rowData.tableData.id ? 'white' : 'black'}/>
                </Button>
           )}
          </>
        ) : (
          <div className="m-2" style={{ height: "11px", width: "11px" }}></div>
        ),
    },
  ];

  const DiscountDispensingFeeGuaranteesOption = [
    {
      label: "340B claims",
      value: "340B claims",
      default: true
    },
    {
      label: "Vaccine claims",
      value: "Vaccine claims",
      default: true
    },
    {
      label: "Paper claims",
      value: "Paper claims",
      default: true
    },
    {
      label: "Government claims",
      value: "Government claims",
      default: true
    },
    {
      label: "Coordination of Benefit claims",
      value: "Coordination of Benefit claims",
      default: true
    },
    {
      label: "Over-the-Counter claims",
      value: "Over-the-Counter claims",
      default: false
    },
    {
      label: "Compound claims",
      value: "Compound claims",
      default: true
    },
    {
      label: "COVID-19 related claims",
      value: "COVID-19 related claims",
      default: true
    },
    {
      label: "PCSK9 claims",
      value: "PCSK9 claims",
      default: false
    },
    {
      label: "Medical Supply or Device claims",
      value: "Medical Supply or Device claims",
      default: false
    },
    {
      label: "Insulin claims",
      value: "Insulin claims",
      default: false
    },
    {
      label: "Claims where member cost is 100% of the cost of the claim",
      value: "Claims where member cost is 100% of the cost of the claim",
      default: false
    },
    {
      label: "Multi-source brand claims",
      value: "Multi-source brand claims",
      default: false
    },
    {
      label: "Biosimilar claims",
      value: "Biosimilar claims",
      default: false
    },
    {
      label: "Other - list all exclusions in the text box provided",
      value: "Other - list all exclusions in the text box provided",
      default: false
    },
  ];

  const pricingStructureDropdownOptions = [
    {
      lable: "Pass Through",
      value: "Pass Through",
    },
    {
      lable: "Spread",
      value: "Spread",
    },
    {
      lable: "Other - Explain",
      value: "Other - Explain",
    },
  ];

  const filteredColumn = column.filter((item) => item.title !== "Actions");
  useEffect(() => {
    if (showModal === false) {
      setSelectedRowData(null);
      setClientStatus(null);
    }
    setIsGetData(false);
  }, [showModal]);
 
  useEffect(() => {  
    if (selectedRowData?.clientName) {
      handleClientChange(selectedRowData.clientName);
    }
  }, [selectedRowData]);
  const fetchData = (page, pageSize, search) => {
    return GetAllEmpoweRxDrugDiscountWithPagination(
      user.UD_id,
      page,
      pageSize,
      search
    ).then((result) => {
      const processedData = preprocessDataForExport(
        result?.data?.empoweRxDrugDiscounts
      );
      setEmpoweRxDrugDiscountData(result?.data?.empoweRxDrugDiscounts)
      setData(processedData);
      return {
        data: processedData,
        page,
        totalCount: result.data.totalPages * pageSize,
      };
    });
  };

  useEffect(() => {
    getPBMList();
    getStateList();
  }, []);

  const getStateList = async () => {
    const statesRes = await GetStates();
    const formattedState = statesRes?.data?.map(({ state }) => ({
      value: state,
      label: state,
    }));
    const states = [...formattedState, { value: "N/A", label: "N/A" }];
    setStateList(states);
  };

  const preprocessDataForExport = (data) => {
    return data?.map((item) => {
      let parsedNonSpecialtyDrugs = {};
      let parsedSpecialtyDrugs = {};
      let parseNonSpecialtySDFPGE = {};
      let parseNonRebateGuaranteesExclusions = {};
      let parseSpecialtySDFPGE = {};
      let parseRebateGuaranteesExclusions = {};
      let parsepbmFeesCredits = {};
      try {
        parsedNonSpecialtyDrugs = JSON.parse(item.nonSpecialtyDrugs || "{}");
        parsedSpecialtyDrugs = JSON.parse(item.specialtyDrugs || "{}");
        parseNonSpecialtySDFPGE = JSON.parse(item.nonSpecialtySDFPGE || "{}");
        parseNonRebateGuaranteesExclusions = JSON.parse(
          item.nonRebateGuaranteesExclusions || "{}"
        );
        parseSpecialtySDFPGE = JSON.parse(item.specialtySDFPGE || "{}");
        parseRebateGuaranteesExclusions = JSON.parse(
          item.rebateGuaranteesExclusions || "{}"
        );
        parsepbmFeesCredits = JSON.parse(item.pbmFeesCredits || "{}");
      } catch (error) {
        console.error("JSON parsing error:", error);
      }

      return {
        ...item,
        NonSp_MailBrands_AWPDiscounts:
          parsedNonSpecialtyDrugs?.NonSp_MailBrands_AWPDiscounts || "",
        NonSp_MailGenerics_AWPDiscounts:
          parsedNonSpecialtyDrugs?.NonSp_MailGenerics_AWPDiscounts || "",
        NonSp_Retail30Brands_AWPDiscounts:
          parsedNonSpecialtyDrugs?.NonSp_Retail30Brands_AWPDiscounts || "",
        NonSp_Retail30Generics_AWPDiscounts:
          parsedNonSpecialtyDrugs?.NonSp_Retail30Generics_AWPDiscounts || "",
        NonSp_Retail90Brands_AWPDiscounts:
          parsedNonSpecialtyDrugs?.NonSp_Retail90Brands_AWPDiscounts || "",
        NonSp_Retail90Generics_AWPDiscounts:
          parsedNonSpecialtyDrugs?.NonSp_Retail90Generics_AWPDiscounts || "",
        NonSp_MailBrands_DispensingFees:
          parsedNonSpecialtyDrugs?.NonSp_MailBrands_DispensingFees || "",
        NonSp_MailGenerics_DispensingFees:
          parsedNonSpecialtyDrugs?.NonSp_MailGenerics_DispensingFees || "",
        NonSp_Retail30Brands_DispensingFees:
          parsedNonSpecialtyDrugs?.NonSp_Retail30Brands_DispensingFees || "",
        NonSp_Retail90Brands_DispensingFees:
          parsedNonSpecialtyDrugs?.NonSp_Retail90Brands_DispensingFees || "",
        NonSp_Retail30Generics_DispensingFees:
          parsedNonSpecialtyDrugs?.NonSp_Retail30Generics_DispensingFees || "",
        NonSp_Retail90Generics_DispensingFees:
          parsedNonSpecialtyDrugs?.NonSp_Retail90Generics_DispensingFees || "",
        NonSp_MailBrands_Rebates:
          parsedNonSpecialtyDrugs?.NonSp_MailBrands_Rebates || "",
        NonSp_Retail30Brands_Rebates:
          parsedNonSpecialtyDrugs?.NonSp_Retail30Brands_Rebates || "",
        NonSp_Retail90Brands_Rebates:
          parsedNonSpecialtyDrugs?.NonSp_Retail90Brands_Rebates || "",

        nonSpltdiscountDispensingFeeGuarantees:
          parseNonSpecialtySDFPGE?.nonSpltdiscountDispensingFeeGuarantees || "",
        nonSplState: parseNonSpecialtySDFPGE?.nonSplState || "",
        nonSpltdiscountDispensingFeeGuaranteesComment:
          parseNonSpecialtySDFPGE?.nonSpltdiscountDispensingFeeGuaranteesComment ||
          "",

        nonSpltRebatediscountDispensingFeeGuarantees:
          parseNonRebateGuaranteesExclusions?.nonSpltRebatediscountDispensingFeeGuarantees ||
          "",
        nonRebateSplState:
          parseNonRebateGuaranteesExclusions?.nonRebateSplState || "",
        nonSpltRebatediscountDispensingFeeGuaranteesComment:
          parseNonRebateGuaranteesExclusions?.nonSpltRebatediscountDispensingFeeGuaranteesComment ||
          "",
        nonrebateProposal:
          parseNonRebateGuaranteesExclusions?.nonrebateProposal || "",
        nonrebateStructure:
          parseNonRebateGuaranteesExclusions?.nonrebateStructure || "",
        nonWholesaleAcquisitionCostStrategy:
          parseNonRebateGuaranteesExclusions?.nonWholesaleAcquisitionCostStrategy ||
          "",
        InsulinClaims: parseNonRebateGuaranteesExclusions?.InsulinClaims,
        RetailNonPreferredTier3BrandClaims:
          parseNonRebateGuaranteesExclusions?.RetailNonPreferredTier3BrandClaims,
        Retail90NonPreferredTier3BrandClaims:
          parseNonRebateGuaranteesExclusions?.Retail90NonPreferredTier3BrandClaims,
        MailNonPreferredTier3BrandClaims:
          parseNonRebateGuaranteesExclusions?.MailNonPreferredTier3BrandClaims,

        Sp_MailBrands_AWPDiscounts:
          parsedSpecialtyDrugs?.Sp_MailBrands_AWPDiscounts || "",
        Sp_MailGenerics_AWPDiscounts:
          parsedSpecialtyDrugs?.Sp_MailGenerics_AWPDiscounts || "",
        Sp_Retail30Brands_AWPDiscounts:
          parsedSpecialtyDrugs?.Sp_Retail30Brands_AWPDiscounts || "",
        Sp_Retail90Brands_AWPDiscounts:
          parsedSpecialtyDrugs?.Sp_Retail90Brands_AWPDiscounts || "",
        Sp_Retail30Generics_AWPDiscounts:
          parsedSpecialtyDrugs?.Sp_Retail30Generics_AWPDiscounts || "",
        Sp_Retail90Generics_AWPDiscounts:
          parsedSpecialtyDrugs?.Sp_Retail90Generics_AWPDiscounts || "",
        Sp_MailBrands_DispensingFees:
          parsedSpecialtyDrugs?.Sp_MailBrands_DispensingFees || "",
        Sp_MailGenerics_DispensingFees:
          parsedSpecialtyDrugs?.Sp_MailGenerics_DispensingFees || "",
        Sp_Retail30Brands_DispensingFees:
          parsedSpecialtyDrugs?.Sp_Retail30Brands_DispensingFees || "",
        Sp_Retail90Brands_DispensingFees:
          parsedSpecialtyDrugs?.Sp_Retail90Brands_DispensingFees || "",
        Sp_Retail30Generics_DispensingFees:
          parsedSpecialtyDrugs?.Sp_Retail30Generics_DispensingFees || "",
        Sp_Retail90Generics_DispensingFees:
          parsedSpecialtyDrugs?.Sp_Retail90Generics_DispensingFees || "",
        Sp_MailBrands_Rebates:
          parsedSpecialtyDrugs?.Sp_MailBrands_Rebates || "",
        Sp_Retail30Brands_Rebates:
          parsedSpecialtyDrugs?.Sp_Retail30Brands_Rebates || "",
        Sp_Retail90Brands_Rebates:
          parsedSpecialtyDrugs?.Sp_Retail90Brands_Rebates || "",
        Sp_SpecialtyPharmacyBrands_Rebates:
          parsedSpecialtyDrugs?.Sp_SpecialtyPharmacyBrands_Rebates || "",

        spltdiscountDispensingFeeGuarantees:
          parseSpecialtySDFPGE?.spltdiscountDispensingFeeGuarantees,
        splState: parseSpecialtySDFPGE?.splState,
        spltdiscountDispensingFeeGuaranteesComment:
          parseSpecialtySDFPGE?.spltdiscountDispensingFeeGuaranteesComment,

        spltRebatediscountDispensingFeeGuarantees:
          parseRebateGuaranteesExclusions?.spltRebatediscountDispensingFeeGuarantees ||
          "",
        splRebateState: parseRebateGuaranteesExclusions?.splRebateState || "",
        spltRebatediscountDispensingFeeGuaranteesComment:
          parseRebateGuaranteesExclusions?.spltRebatediscountDispensingFeeGuaranteesComment ||
          "",
        splrebateProposal:
          parseRebateGuaranteesExclusions?.splrebateProposal || "",
        splrebateStructure:
          parseRebateGuaranteesExclusions?.splrebateStructure || "",
        splWholesaleAcquisitionCostStrategy:
          parseRebateGuaranteesExclusions?.splWholesaleAcquisitionCostStrategy ||
          "",
        LimitedDistributionDrugClaims:
          parseRebateGuaranteesExclusions?.LimitedDistributionDrugClaims,
        BiosimilarClaims: parseRebateGuaranteesExclusions?.BiosimilarClaims,
        HIVClaims: parseRebateGuaranteesExclusions?.HIVClaims,
        SpecialtyNonPreferredTier3BrandClaims:
          parseRebateGuaranteesExclusions?.SpecialtyNonPreferredTier3BrandClaims,
        SpecialtyRetail90NonPreferredTier3BrandClaims:
          parseRebateGuaranteesExclusions?.SpecialtyRetail90NonPreferredTier3BrandClaims,
        SpecialtyMailNonPreferredorTier3BrandClaims:
          parseRebateGuaranteesExclusions?.SpecialtyMailNonPreferredorTier3BrandClaims,
        SpecialtyPBMNonPreferredorTier3BrandPharmacyClaims:
          parseRebateGuaranteesExclusions?.SpecialtyPBMNonPreferredorTier3BrandPharmacyClaims,

        PBMadministrationfeesBasis:
          parsepbmFeesCredits?.PBMadministrationfeesBasis || "",
        PBMadministrationfeesResponseFormat:
          parsepbmFeesCredits?.PBMadministrationfeesResponseFormat,
        PBMtotalpaidrebatesResponseFormat:
          parsepbmFeesCredits?.PBMtotalpaidrebatesResponseFormat,
        PBMtransactionfeesBasis:
          parsepbmFeesCredits?.PBMtransactionfeesBasis || "",
        PBMtransactionfeesResponseFormat:
          parsepbmFeesCredits?.PBMtransactionfeesResponseFormat,
        CoalitionorAggregatorfeesBasis:
          parsepbmFeesCredits?.CoalitionorAggregatorfeesBasis || "",
        CoalitionorAggregatorfeesResponseFormat:
          parsepbmFeesCredits?.CoalitionorAggregatorfeesResponseFormat,
        listandspecifyallotherfees:
          parsepbmFeesCredits?.listandspecifyallotherfees || "",
        onsitePharmacyPBMAdministrationFeeBasis:
          parsepbmFeesCredits?.onsitePharmacyPBMAdministrationFeeBasis || "",
        onsitePharmacyPBMAdministrationFeeResponseFormat:
          parsepbmFeesCredits?.onsitePharmacyPBMAdministrationFeeResponseFormat,
        onsitePharmacyAggregatorAdministrationFeeBasis:
          parsepbmFeesCredits?.onsitePharmacyAggregatorAdministrationFeeBasis ||
          "",
        onsitePharmacyAggregatorAdministrationFeeResponseFormat:
          parsepbmFeesCredits?.onsitePharmacyAggregatorAdministrationFeeResponseFormat,
          Status: item?.status || "",
          RFPSent: item?.rfpSent === false ? "No" : item.rfpSent === true ? "Yes" : "",
      };
    });
  };

  const fileName =
    location.pathname.split("/")[location.pathname.split("/").length - 1] +
    "_" +
    (parseInt(new Date().getMonth()) + 1) +
    "_" +
    new Date().getDate() +
    "_" +
    new Date().getFullYear() +
    "_" +
    new Date().getHours() +
    "_" +
    new Date().getMinutes() +
    "_" +
    new Date().getSeconds();

  // Preprocess the data outside the map function
  const preprocessedData = data.map(
    (item) => preprocessDataForExport([item])[0]
  );

  const csvData = [
    filteredColumn.map((item) => item.title),
    ...preprocessedData.map((item) => [
      item.clientName,
      item.pbmName,
      item.numberOfMembers,
      item.numberOfEmployees,
      item.currentContractTerminationDate,
      item.retail30Network,
      item.retai90Network,
      item.mailProgram,
      item.specialtyProgram,
      item.formularyStrategy,
      item.clinicalPrograms,
      item.specialtyCopayCard,
      item.alternativeFunding,
      item.accumulatorAdjustmentProgram,
      item.onsitePharmacyID,
      item.NonSp_MailBrands_AWPDiscounts,
      item.NonSp_MailGenerics_AWPDiscounts,
      item.NonSp_Retail30Brands_AWPDiscounts,
      item.NonSp_Retail30Generics_AWPDiscounts,
      item.NonSp_Retail90Brands_AWPDiscounts,
      item.NonSp_Retail90Generics_AWPDiscounts,
      item.NonSp_MailBrands_DispensingFees,
      item.NonSp_MailGenerics_DispensingFees,
      item.NonSp_Retail30Brands_DispensingFees,
      item.NonSp_Retail90Brands_DispensingFees,
      item.NonSp_Retail30Generics_DispensingFees,
      item.NonSp_Retail90Generics_DispensingFees,
      item.NonSp_MailBrands_Rebates,
      item.NonSp_Retail30Brands_Rebates,
      item.NonSp_Retail90Brands_Rebates,
      item.nonSpltdiscountDispensingFeeGuarantees,
      item.nonSplState,
      item.nonSpltdiscountDispensingFeeGuaranteesComment,
      item.nonSpltRebatediscountDispensingFeeGuarantees,
      item.nonRebateSplState,
      item.nonSpltRebatediscountDispensingFeeGuaranteesComment,
      item.nonrebateProposal,
      item.nonrebateStructure,
      item.nonWholesaleAcquisitionCostStrategy,
      item.InsulinClaims,
      item.RetailNonPreferredTier3BrandClaims,
      item.Retail90NonPreferredTier3BrandClaims,
      item.MailNonPreferredTier3BrandClaims,
      item.Sp_MailBrands_AWPDiscounts,
      item.Sp_MailGenerics_AWPDiscounts,
      item.Sp_Retail30Brands_AWPDiscounts,
      item.Sp_Retail90Brands_AWPDiscounts,
      item.Sp_Retail30Generics_AWPDiscounts,
      item.Sp_Retail90Generics_AWPDiscounts,
      item.Sp_MailBrands_DispensingFees,
      item.Sp_MailGenerics_DispensingFees,
      item.Sp_Retail30Brands_DispensingFees,
      item.Sp_Retail90Brands_DispensingFees,
      item.Sp_Retail30Generics_DispensingFees,
      item.Sp_Retail90Generics_DispensingFees,
      item.Sp_MailBrands_Rebates,
      item.Sp_Retail30Brands_Rebates,
      item.Sp_Retail90Brands_Rebates,
      item.Sp_SpecialtyPharmacyBrands_Rebates,
      item.spltdiscountDispensingFeeGuarantees,
      item.splState,
      item.spltdiscountDispensingFeeGuaranteesComment,
      item.spltRebatediscountDispensingFeeGuarantees,
      item.splRebateState,
      item.spltRebatediscountDispensingFeeGuaranteesComment,
      item.splrebateProposal,
      item.splrebateStructure,
      item.splWholesaleAcquisitionCostStrategy,
      item.LimitedDistributionDrugClaims,
      item.BiosimilarClaims,
      item.HIVClaims,
      item.SpecialtyNonPreferredTier3BrandClaims,
      item.SpecialtyRetail90NonPreferredTier3BrandClaims,
      item.SpecialtyMailNonPreferredorTier3BrandClaims,
      item.SpecialtyPBMNonPreferredorTier3BrandPharmacyClaims,
      item.PBMadministrationfeesBasis,
      item.PBMadministrationfeesResponseFormat,
      item.PBMtotalpaidrebatesResponseFormat,
      item.PBMtransactionfeesBasis,
      item.PBMtransactionfeesResponseFormat,
      item.CoalitionorAggregatorfeesBasis,
      item.CoalitionorAggregatorfeesResponseFormat,
      item.listandspecifyallotherfees,
      item.onsitePharmacyPBMAdministrationFeeBasis,
      item.onsitePharmacyPBMAdministrationFeeResponseFormat,
      item.onsitePharmacyAggregatorAdministrationFeeBasis,
      item.onsitePharmacyAggregatorAdministrationFeeResponseFormat,
      item?.status || "",
      item?.rfpSent === false ? "No" : item.rfpSent === true ? "Yes" : "",
      
    ]),
  ];

  const loadOptions = async (searchQuery, loadedOptions, { page }) => {
    // console.log(searchQuery?.length, "searchQuery?.length");
    if (searchQuery.length > 3 || searchQuery?.length === 0) {
      try {
        let response = await getClientsDatabyPaginationbySearch(
          user.UD_id,
          page,
          searchQuery
        );
        const data = await response.data.clientsDataModelUDid;
        setClientData([...clientData, ...data]);
        const newOptions = data.map((port) => ({
          value: port.clientID,
          label: port.clientName,
        }));
        return {
          options: newOptions,
          hasMore: newOptions.length >= 1,
          additional: {
            page: page + 1,
          },
        };
      } catch (error) {
        console.error("Error fetching data:", error);
        return {
          options: [],
          hasMore: false,
          additional: {
            page: page,
          },
        };
      }
    } else {
      return {
        options: [{ value: 0, label: "Please type at least 4 characters" }],
        hasMore: false,
        additional: {
          page: page,
        },
      };
    }
  };

  const getPBMList = () => {
    GetPBMList()
      .then((res) => {
        if (res?.status === 200 || res?.status === 204) {
          setPbmList(res.data.data);
        }
      })
      .catch((err) => console.log({ err }));
  };
  const handleActions = (values, action) => {
    if(values.client_Name === null){
      toastFile("Select Client Name")
      return;
    }
    setIsLoader({complete:action === "Save" ? false :true ,save:action === "Save" ? true:false})
    buttonRef.current.disabled = true;
    setShowTable(false);
   
    let payload = {
      id: values.id ? values.id : 0,
      pbmName: values?.PBM ? JSON.parse(values?.PBM).Name : '',
      currentContractTerminationDate: values.ContractTermDate || "1900-01-01T00:00:00",
      carrierID: values.CarrierID,
      accountID: values.AccountID,
      groupID: values.GroupID,
      numberOfMembers: +values.NumberOfMembers || 0,
      numberOfEmployees: +values.NumberOfEmployees || 0,
      retail30Network: values.Retail30Network,
      retai90Network: values.Retail90Network,
      mailProgram: values.MailProg || '',
      specialtyProgram: values.SpecialProg || '',
      clinicalPrograms: values.ClinicProg || '',
      formularyStrategy: values.FormularyStrategy || '',
      specialtyCopayCard: values.SpecCopayCard || '',
      alternativeFunding: values.AlternateFund || '',
      accumulatorAdjustmentProgram: values.AccumulatorProgram || '',
      onsitePharmacyID: values.OnsitePharmacyID,
      nonSpecialtyDrugs: JSON.stringify({
        NonSp_MailBrands_AWPDiscounts: values.NonSp_MailBrands_AWPDiscounts,
        NonSp_MailBrands_DispensingFees: values.NonSp_MailBrands_DispensingFees,
        NonSp_MailBrands_Rebates: values.NonSp_MailBrands_Rebates,
        NonSp_MailGenerics_AWPDiscounts: values.NonSp_MailGenerics_AWPDiscounts,
        NonSp_MailGenerics_DispensingFees:
          values.NonSp_MailGenerics_DispensingFees,
        NonSp_Retail30Brands_AWPDiscounts:
          values.NonSp_Retail30Brands_AWPDiscounts,
        NonSp_Retail30Brands_DispensingFees:
          values.NonSp_Retail30Brands_DispensingFees,
        NonSp_Retail30Brands_Rebates: values.NonSp_Retail30Brands_Rebates,
        NonSp_Retail90Brands_AWPDiscounts:
          values.NonSp_Retail90Brands_AWPDiscounts,
        NonSp_Retail90Brands_DispensingFees:
          values.NonSp_Retail90Brands_DispensingFees,
        NonSp_Retail90Brands_Rebates: values.NonSp_Retail90Brands_Rebates,
        NonSp_Retail30Generics_AWPDiscounts:
          values.NonSp_Retail30Generics_AWPDiscounts,
        NonSp_Retail30Generics_DispensingFees:
          values.NonSp_Retail30Generics_DispensingFees,
        NonSp_Retail90Generics_AWPDiscounts:
          values.NonSp_Retail90Generics_AWPDiscounts,
        NonSp_Retail90Generics_DispensingFees:
          values.NonSp_Retail90Generics_DispensingFees,
      }),
      NonSpecialtySDFPGE: JSON.stringify({
        nonSpltdiscountDispensingFeeGuarantees:
          values.nonSpltdiscountDispensingFeeGuarantees,
        nonSplState: values.nonSplState,
        nonSpltdiscountDispensingFeeGuaranteesComment:
          values.nonSpltdiscountDispensingFeeGuaranteesComment,
      }),
      NonRebateGuaranteesExclusions: JSON.stringify({
        nonSpltRebatediscountDispensingFeeGuarantees:
          values.nonSpltRebatediscountDispensingFeeGuarantees,
        nonRebateSplState: values.nonRebateSplState,
        nonSpltRebatediscountDispensingFeeGuaranteesComment:
          values.nonSpltRebatediscountDispensingFeeGuaranteesComment,
        nonrebateProposal: values.nonrebateProposal ? JSON.parse(values.nonrebateProposal).value : null,
        nonrebateStructure: values.nonrebateStructure ? JSON.parse(values.nonrebateStructure).value : null,
        nonWholesaleAcquisitionCostStrategy:
          values.nonWholesaleAcquisitionCostStrategy,
        InsulinClaims: values.InsulinClaims,
        RetailNonPreferredTier3BrandClaims:
          values.RetailNonPreferredTier3BrandClaims,
        Retail90NonPreferredTier3BrandClaims:
          values.Retail90NonPreferredTier3BrandClaims,
        MailNonPreferredTier3BrandClaims:
          values.MailNonPreferredTier3BrandClaims,
      }),
      specialtyDrugs: JSON.stringify({
        Sp_MailBrands_AWPDiscounts: values.Sp_MailBrands_AWPDiscounts,
        Sp_MailBrands_DispensingFees: values.Sp_MailBrands_DispensingFees,
        Sp_MailBrands_Rebates: values.Sp_MailBrands_Rebates,
        Sp_MailGenerics_AWPDiscounts: values.Sp_MailGenerics_AWPDiscounts,
        Sp_MailGenerics_DispensingFees: values.Sp_MailGenerics_DispensingFees,
        Sp_Retail30Brands_AWPDiscounts: values.Sp_Retail30Brands_AWPDiscounts,
        Sp_Retail30Brands_DispensingFees:
          values.Sp_Retail30Brands_DispensingFees,
        Sp_Retail30Brands_Rebates: values.Sp_Retail30Brands_Rebates,
        Sp_Retail90Brands_AWPDiscounts: values.Sp_Retail90Brands_AWPDiscounts,
        Sp_Retail90Brands_DispensingFees:
          values.Sp_Retail90Brands_DispensingFees,
        Sp_Retail90Brands_Rebates: values.Sp_Retail90Brands_Rebates,
        Sp_SpecialtyPharmacyBrands_Rebates:
          values.Sp_SpecialtyPharmacyBrands_Rebates,
        Sp_Retail30Generics_AWPDiscounts:
          values.Sp_Retail30Generics_AWPDiscounts,
        Sp_Retail30Generics_DispensingFees:
          values.Sp_Retail30Generics_DispensingFees,
        Sp_Retail90Generics_AWPDiscounts:
          values.Sp_Retail90Generics_AWPDiscounts,
        Sp_Retail90Generics_DispensingFees:
          values.Sp_Retail90Generics_DispensingFees,
      }),
      SpecialtySDFPGE: JSON.stringify({
        spltdiscountDispensingFeeGuarantees:
          values.spltdiscountDispensingFeeGuarantees,
        splState: values.splState,
        spltdiscountDispensingFeeGuaranteesComment:
          values.spltdiscountDispensingFeeGuaranteesComment,
      }),
      RebateGuaranteesExclusions: JSON.stringify({
        spltRebatediscountDispensingFeeGuarantees:
          values.spltRebatediscountDispensingFeeGuarantees,
        splRebateState: values.splRebateState,
        spltRebatediscountDispensingFeeGuaranteesComment:
          values.spltRebatediscountDispensingFeeGuaranteesComment,
        splrebateProposal: values.splrebateProposal ? JSON.parse(values.splrebateProposal).value :null,
        splrebateStructure: values.splrebateStructure ? JSON.parse(values.splrebateStructure).value :null,
        splWholesaleAcquisitionCostStrategy:
          values.splWholesaleAcquisitionCostStrategy,
        LimitedDistributionDrugClaims: values.LimitedDistributionDrugClaims,
        BiosimilarClaims: values.BiosimilarClaims,
        HIVClaims: values.HIVClaims,
        SpecialtyNonPreferredTier3BrandClaims:
          values.SpecialtyNonPreferredTier3BrandClaims,
        SpecialtyRetail90NonPreferredTier3BrandClaims:
          values.SpecialtyRetail90NonPreferredTier3BrandClaims,
        SpecialtyMailNonPreferredorTier3BrandClaims:
          values.SpecialtyMailNonPreferredorTier3BrandClaims,
        SpecialtyPBMNonPreferredorTier3BrandPharmacyClaims:
          values.SpecialtyPBMNonPreferredorTier3BrandPharmacyClaims,
      }),
      PBMFeesCredits: JSON.stringify({
        PBMadministrationfeesBasis: values.PBMadministrationfeesBasis ? JSON.parse(
          values.PBMadministrationfeesBasis
        ).value : null,
        PBMadministrationfeesResponseFormat:
          values.PBMadministrationfeesResponseFormat,
        PBMtotalpaidrebatesResponseFormat:
          values.PBMtotalpaidrebatesResponseFormat,
        PBMtransactionfeesBasis: values.PBMtransactionfeesBasis ? JSON.parse(values.PBMtransactionfeesBasis)
          .value : null,
        PBMtransactionfeesResponseFormat:
          values.PBMtransactionfeesResponseFormat,
        CoalitionorAggregatorfeesBasis: values.CoalitionorAggregatorfeesBasis ? JSON.parse(
          values.CoalitionorAggregatorfeesBasis
        ).value : null,
        CoalitionorAggregatorfeesResponseFormat:
          values.CoalitionorAggregatorfeesResponseFormat,
        listandspecifyallotherfees: values.listandspecifyallotherfees,
        onsitePharmacyPBMAdministrationFeeBasis:
          values.onsitePharmacyPBMAdministrationFeeBasis !== ""
            ? JSON.parse(values.onsitePharmacyPBMAdministrationFeeBasis).value
            : "",
        onsitePharmacyPBMAdministrationFeeResponseFormat:
          values.onsitePharmacyPBMAdministrationFeeResponseFormat,
        onsitePharmacyAggregatorAdministrationFeeBasis:
          values.onsitePharmacyAggregatorAdministrationFeeBasis !== ""
            ? JSON.parse(values.onsitePharmacyAggregatorAdministrationFeeBasis)
                .value
            : "",
        onsitePharmacyAggregatorAdministrationFeeResponseFormat:
          values.onsitePharmacyAggregatorAdministrationFeeResponseFormat,
      }),
      pbmContractFileUrl: selectedRowData?.pbmContractFileUrl || "",
      hospitalHealthSystemRequirementQuestionnaireFileUrl: selectedRowData?.hospitalHealthSystemRequirementQuestionnaireFileUrl || "",
      pbmClaimsFileUrl: selectedRowData?.pbmClaimsFileUrl || "",

      retailNetworkPricingStructure: values.retailNetworkPricingStructure ? JSON.parse(values.retailNetworkPricingStructure).value : null,
      retailNetworkPricingStructureComment: values.retailNetworkPricingStructureComment,
      mailProgramPricingStructure: values.mailProgramPricingStructure ? JSON.parse(values.mailProgramPricingStructure).value : null,
      mailProgramPricingStructureComment: values.mailProgramPricingStructureComment,
      specialtyProgramPricingStructure: values.specialtyProgramPricingStructure ? JSON.parse(values.specialtyProgramPricingStructure).value : null,
      specialtyProgramPricingStructureComment: values.specialtyProgramPricingStructureComment,
      rebateProgramPricingStructure: values.rebateProgramPricingStructure ? JSON.parse(values.rebateProgramPricingStructure).value : null,
      rebateProgramPricingStructureComment: values.rebateProgramPricingStructureComment,
      userId: user.UD_id,
      clientId: values.client_Name?.value,
      clientName: values.client_Name?.label || '',
      status: action === "Save" ?  "In Progress" : 'Complete', 
    };
 
    if (witchAction === "add") {
      CreateOrUpdateEmpoweRxDrugDiscount(payload)
        .then(async (res) => {
          if (res?.status === 200 || res?.status === 204) {
            let DrugId = res.data.data;
            let response;
            if(DrugId){
              response = await DrugDiscountFileUpload(
                DrugId,
                PBMfile,
                HospitalHealthSystemFile,
                PBMClaimsFile
              );
            }
            if (response && (response?.status === 200 || response?.status === 204)) {
              action === "Save" ? toastFile("create") : toastFile("Completed");
              setPBMFile(null);
              setHospitalHealthSystemFile(null);
              setPBMClaimsFile(null);
              setIsGetData(true);
              setShowModal(false);
             // resetForm();
            } else {
              toastFile(res.data.message, "error");
            }
          }
        })
        .finally((res) => {
          setShowTable(true)
          setIsLoader({save:false, complete:false})
        }
        );
    } else if (witchAction === "update") {
      CreateOrUpdateEmpoweRxDrugDiscount(payload)
        .then(async (res) => {
          const response = await DrugDiscountFileUpload(
            values.id,
            PBMfile,
            HospitalHealthSystemFile,
            PBMClaimsFile
          );
          if (response?.status === 200 || response?.status === 204) {
            action === "Save" ? toastFile("update") : toastFile("Completed");
            setPBMFile(null);
            setHospitalHealthSystemFile(null);
            setPBMClaimsFile(null);
            setIsGetData(true);
            setShowModal(false);
          } else {
            toastFile(res.data.message, "error");
          }
        })
        .finally((res) => {
          setShowTable(true)
          setIsLoader({save:false, complete:false})
    });
    }
   
  };

  const handleDuplicateClick = (id) => {
    setShowTable(false);
    const findedData = empoweRxDrugDiscountData.find((el)=>el.id === id)
    let payload = {
      ...findedData,
      id: 0,
      currentContractTerminationDate: "1900-01-01T00:00:00",
      userId: user.UD_id,
      status: "In Progress",
      rfpSent: false
    };
    CreateOrUpdateEmpoweRxDrugDiscount(payload)
        .then(async (res) => {
          if (res?.status === 200 || res?.status === 204) {
              toastFile("Duplicate created","success");
            } else {
              toastFile(res.data.message, "error");
            }
        })
        .finally(()=> setShowTable(true))
  }

  const handleClientChange = async (clientName) => {  
    const encodedClientName = encodeURIComponent(clientName);
    const response = await CheckBidFileRecordbyClientName(encodedClientName);
    if (response?.data?.data?.length > 0) {
      setClientStatus(true);
    } else {
      setClientStatus(false);
    }
  };
 
  const handleValidationError = async() => {
    const errors = await formikRef.current?.validateForm() ?? {};
    if (Object.keys(errors).length > 0) {
      setTimeout(()=>{
        setErrorPreventingModel(true)
      },[100])
    }else{
      return;
    }
  };
 
 const FileDownloadForClientRxFile = (fileUrl, FileType) => {
    const FileName = fileUrl.split("/").pop();
    let DrugId = selectedRowData.id;
    if(FileType !== DrugfileType.PBMClaims){
      DrugId = parseInt(FileName.split(".")[0].split("_").pop())
    }
    GetPresignedDrugFileURL(DrugId, FileName, FileType).then((res) => {
      if (res.data.issuccess) {
        //   window.open(res.data.data, '_blank');
        const link = document.createElement("a");
        link.href = res.data.data;
        link.setAttribute("download", FileName);
        link.setAttribute("target", "_blank");
        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
      }
    });
  };
  return (
    <div>
      <Modal
        show={errorPreventingModel}
        aria-labelledby="contained-modal-title-vcenter"
        className="mt-4"
      >
        <Modal.Header closeButton onHide={() => setErrorPreventingModel(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading2}
            className="text-warning"
          >
            Warning
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-nowrap text-dark">
            Please complete all required fields and then try again.
          </div>
          <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
            <button style={Fontstyling.cancelbutton} onClick={()=>setErrorPreventingModel(false)}>
            OK
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== "delete"}
        size={witchAction !== "delete" ? "xl" : ""}
      >
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading2}
          >
            {/* {witchAction === "add"
              ? "Add "
              : witchAction === "update"
              ? "Update "
              : "Delete "} */}
            Client and Incumbent Information
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {witchAction === "delete" ? (
            <DeleteModal
              onClickYes={() => {
                setShowTable(false);
                DeleteEmpoweRxDrugDiscount(selectedRowData?.id)
                  .then((res) => {
                    toastFile("delete");
                    setIsGetData(true);
                    setShowModal(false);
                    getPBMList();
                  })
                  .finally((res) => setShowTable(true));
              }}
              onClickNo={() => setShowModal(false)}
            />
          ) :

           ( <Formik
              innerRef={formikRef}
              enableReinitialize
              validationSchema={schema}
              onSubmit={handleActions}
              initialValues={{
                id: selectedRowData?.id ? selectedRowData?.id : 0,
                client_Name: selectedRowData
                  ? {
                      value: selectedRowData?.clientId,
                      label: selectedRowData?.clientName,
                    }
                  : null,
                PBM: selectedRowData?.pbmName
                  ? JSON.stringify(
                      pbmList.find((d) => d.Name == selectedRowData.pbmName)
                    )
                  : "",
                ContractTermDate:
                  selectedRowData?.currentContractTerminationDate 
                  && selectedRowData?.currentContractTerminationDate !== "1900-01-01T00:00:00" 
                    ? selectedRowData?.currentContractTerminationDate.split('T')[0]
                  :null,
                NumberOfMembers: selectedRowData?.numberOfMembers > 0 ? selectedRowData?.numberOfMembers: '',
                CarrierID: selectedRowData?.carrierID,
                AccountID: selectedRowData?.accountID,
                GroupID: selectedRowData?.groupID,
                NumberOfEmployees: selectedRowData?.numberOfEmployees > 0 ? selectedRowData?.numberOfEmployees: '',
                Retail30Network: selectedRowData?.retail30Network,
                Retail90Network: selectedRowData?.retai90Network,
                MailProg: selectedRowData?.mailProgram,
                SpecialProg: selectedRowData?.specialtyProgram,
                ClinicProg: selectedRowData?.clinicalPrograms,
                FormularyStrategy: selectedRowData?.formularyStrategy,
                SpecCopayCard: selectedRowData?.specialtyCopayCard,
                AlternateFund: selectedRowData?.alternativeFunding,
                AccumulatorProgram:
                  selectedRowData?.accumulatorAdjustmentProgram,
                OnsitePharmacyID: selectedRowData?.onsitePharmacyID,

                NonSp_MailBrands_AWPDiscounts:
                  noSpecialtyDrugs?.NonSp_MailBrands_AWPDiscounts,
                NonSp_MailBrands_DispensingFees:
                  noSpecialtyDrugs?.NonSp_MailBrands_DispensingFees,
                NonSp_MailBrands_Rebates:
                  noSpecialtyDrugs?.NonSp_MailBrands_Rebates,
                NonSp_MailGenerics_AWPDiscounts:
                  noSpecialtyDrugs?.NonSp_MailGenerics_AWPDiscounts,
                NonSp_MailGenerics_DispensingFees:
                  noSpecialtyDrugs?.NonSp_MailGenerics_DispensingFees,
                NonSp_Retail30Brands_AWPDiscounts:
                  noSpecialtyDrugs?.NonSp_Retail30Brands_AWPDiscounts,
                NonSp_Retail30Brands_DispensingFees:
                  noSpecialtyDrugs?.NonSp_Retail30Brands_DispensingFees,
                NonSp_Retail30Brands_Rebates:
                  noSpecialtyDrugs?.NonSp_Retail30Brands_Rebates,
                NonSp_Retail90Brands_AWPDiscounts:
                  noSpecialtyDrugs?.NonSp_Retail90Brands_AWPDiscounts,
                NonSp_Retail90Brands_DispensingFees:
                  noSpecialtyDrugs?.NonSp_Retail90Brands_DispensingFees,
                NonSp_Retail90Brands_Rebates:
                  noSpecialtyDrugs?.NonSp_Retail90Brands_Rebates,
                NonSp_Retail30Generics_AWPDiscounts:
                  noSpecialtyDrugs?.NonSp_Retail30Generics_AWPDiscounts,
                NonSp_Retail30Generics_DispensingFees:
                  noSpecialtyDrugs?.NonSp_Retail30Generics_DispensingFees,
                NonSp_Retail90Generics_AWPDiscounts:
                  noSpecialtyDrugs?.NonSp_Retail90Generics_AWPDiscounts,
                NonSp_Retail90Generics_DispensingFees:
                  noSpecialtyDrugs?.NonSp_Retail90Generics_DispensingFees,

                nonSpltdiscountDispensingFeeGuarantees:
                  nonSpecialtySDFPGE?.nonSpltdiscountDispensingFeeGuarantees ?? DiscountDispensingFeeGuaranteesOption.filter(el=>el.default).map(el2 => el2.value).join(","),
                nonSplState: nonSpecialtySDFPGE?.nonSplState,
                nonSpltdiscountDispensingFeeGuaranteesComment:
                  nonSpecialtySDFPGE?.nonSpltdiscountDispensingFeeGuaranteesComment,

                nonSpltRebatediscountDispensingFeeGuarantees:
                  nonRebateGuaranteesExclusions?.nonSpltRebatediscountDispensingFeeGuarantees,
                nonRebateSplState:
                  nonRebateGuaranteesExclusions?.nonRebateSplState,
                nonSpltRebatediscountDispensingFeeGuaranteesComment:
                  nonRebateGuaranteesExclusions?.nonSpltRebatediscountDispensingFeeGuaranteesComment,
                nonrebateProposal:
                  nonRebateGuaranteesExclusions?.nonrebateProposal
                    ? JSON.stringify(
                        [
                          {
                            lable: "per Brand claim",
                            value: "per Brand claim",
                          },
                          {
                            lable: "per formulary (preferred) brand claim",
                            value: "per formulary (preferred) brand claim",
                          },
                        ].find(
                          (d) =>
                            d.value ==
                            nonRebateGuaranteesExclusions?.nonrebateProposal
                        )
                      )
                    : "",
                nonrebateStructure:
                  nonRebateGuaranteesExclusions?.nonrebateStructure
                    ? JSON.stringify(
                        [
                          {
                            lable: "Fixed Rate",
                            value: "Fixed Rate",
                          },
                          {
                            lable: "Minimum Guarantee with Annual True-up",
                            value: "Minimum Guarantee with Annual True-up",
                          },
                        ].find(
                          (d) =>
                            d.value ==
                            nonRebateGuaranteesExclusions?.nonrebateStructure
                        )
                      )
                    : "",
                nonWholesaleAcquisitionCostStrategy:
                  nonRebateGuaranteesExclusions?.nonWholesaleAcquisitionCostStrategy,
                InsulinClaims: nonRebateGuaranteesExclusions?.InsulinClaims,
                RetailNonPreferredTier3BrandClaims:
                  nonRebateGuaranteesExclusions?.RetailNonPreferredTier3BrandClaims,
                Retail90NonPreferredTier3BrandClaims:
                  nonRebateGuaranteesExclusions?.Retail90NonPreferredTier3BrandClaims,
                MailNonPreferredTier3BrandClaims:
                  nonRebateGuaranteesExclusions?.MailNonPreferredTier3BrandClaims,

                Sp_MailBrands_AWPDiscounts:
                  specialtyDrugs?.Sp_MailBrands_AWPDiscounts,
                Sp_MailBrands_DispensingFees:
                  specialtyDrugs?.Sp_MailBrands_DispensingFees,
                Sp_MailBrands_Rebates: specialtyDrugs?.Sp_MailBrands_Rebates,
                Sp_MailGenerics_AWPDiscounts:
                  specialtyDrugs?.Sp_MailGenerics_AWPDiscounts,
                Sp_MailGenerics_DispensingFees:
                  specialtyDrugs?.Sp_MailGenerics_DispensingFees,
                Sp_Retail30Brands_AWPDiscounts:
                  specialtyDrugs?.Sp_Retail30Brands_AWPDiscounts,
                Sp_Retail30Brands_DispensingFees:
                  specialtyDrugs?.Sp_Retail30Brands_DispensingFees,
                Sp_Retail30Brands_Rebates:
                  specialtyDrugs?.Sp_Retail30Brands_Rebates,
                Sp_Retail90Brands_AWPDiscounts:
                  specialtyDrugs?.Sp_Retail90Brands_AWPDiscounts,
                Sp_Retail90Brands_DispensingFees:
                  specialtyDrugs?.Sp_Retail90Brands_DispensingFees,
                Sp_Retail90Brands_Rebates:
                  specialtyDrugs?.Sp_Retail90Brands_Rebates,
                Sp_SpecialtyPharmacyBrands_Rebates:
                  specialtyDrugs?.Sp_SpecialtyPharmacyBrands_Rebates,
                Sp_Retail30Generics_AWPDiscounts:
                  specialtyDrugs?.Sp_Retail30Generics_AWPDiscounts,
                Sp_Retail30Generics_DispensingFees:
                  specialtyDrugs?.Sp_Retail30Generics_DispensingFees,
                Sp_Retail90Generics_AWPDiscounts:
                  specialtyDrugs?.Sp_Retail90Generics_AWPDiscounts,
                Sp_Retail90Generics_DispensingFees:
                  specialtyDrugs?.Sp_Retail90Generics_DispensingFees,

                spltdiscountDispensingFeeGuarantees:
                  specialtySDFPGE?.spltdiscountDispensingFeeGuarantees ??  DiscountDispensingFeeGuaranteesOption.filter(el=>el.default).map(el2 => el2.value).join(","),
                splState: specialtySDFPGE?.splState,
                spltdiscountDispensingFeeGuaranteesComment:
                  specialtySDFPGE?.spltdiscountDispensingFeeGuaranteesComment,

                spltRebatediscountDispensingFeeGuarantees:
                  rebateGuaranteesExclusions?.spltRebatediscountDispensingFeeGuarantees,
                splRebateState: rebateGuaranteesExclusions?.splRebateState,
                spltRebatediscountDispensingFeeGuaranteesComment:
                  rebateGuaranteesExclusions?.spltRebatediscountDispensingFeeGuaranteesComment,

                splrebateProposal: rebateGuaranteesExclusions?.splrebateProposal
                  ? JSON.stringify(
                      [
                        {
                          lable: "per Brand claim",
                          value: "per Brand claim",
                        },
                        {
                          lable: "per formulary (preferred) brand claim",
                          value: "per formulary (preferred) brand claim",
                        },
                      ].find(
                        (d) =>
                          d.value ==
                          rebateGuaranteesExclusions?.splrebateProposal
                      )
                    )
                  : "",
                splrebateStructure:
                  rebateGuaranteesExclusions?.splrebateStructure
                    ? JSON.stringify(
                        [
                          {
                            lable: "Fixed Rate",
                            value: "Fixed Rate",
                          },
                          {
                            lable: "Minimum Guarantee with Annual True-up",
                            value: "Minimum Guarantee with Annual True-up",
                          },
                        ].find(
                          (d) =>
                            d.value ==
                            rebateGuaranteesExclusions?.splrebateStructure
                        )
                      )
                    : "",
                splWholesaleAcquisitionCostStrategy:
                  rebateGuaranteesExclusions?.splWholesaleAcquisitionCostStrategy,
                LimitedDistributionDrugClaims:
                  rebateGuaranteesExclusions?.LimitedDistributionDrugClaims,
                BiosimilarClaims: rebateGuaranteesExclusions?.BiosimilarClaims,
                HIVClaims: rebateGuaranteesExclusions?.HIVClaims,
                SpecialtyNonPreferredTier3BrandClaims:
                  rebateGuaranteesExclusions?.SpecialtyNonPreferredTier3BrandClaims,
                SpecialtyRetail90NonPreferredTier3BrandClaims:
                  rebateGuaranteesExclusions?.SpecialtyRetail90NonPreferredTier3BrandClaims,
                SpecialtyMailNonPreferredorTier3BrandClaims:
                  rebateGuaranteesExclusions?.SpecialtyMailNonPreferredorTier3BrandClaims,
                SpecialtyPBMNonPreferredorTier3BrandPharmacyClaims:
                  rebateGuaranteesExclusions?.SpecialtyPBMNonPreferredorTier3BrandPharmacyClaims,

                PBMadministrationfeesBasis:
                  pbmFeesCredits?.PBMadministrationfeesBasis
                    ? JSON.stringify(
                        [
                          {
                            lable: "per Rx",
                            value: "per Rx",
                          },
                          {
                            lable: "PEPM",
                            value: "PEPM",
                          },
                          {
                            lable: "PMPM",
                            value: "PMPM",
                          },
                          {
                            lable: "No Fee",
                            value: "No Fee",
                          },
                        ].find(
                          (d) =>
                            d.value ==
                            pbmFeesCredits?.PBMadministrationfeesBasis
                        )
                      )
                    : "",
                PBMadministrationfeesResponseFormat:
                  pbmFeesCredits?.PBMadministrationfeesResponseFormat,
                PBMtotalpaidrebatesResponseFormat:
                  pbmFeesCredits?.PBMtotalpaidrebatesResponseFormat,
                PBMtransactionfeesBasis: pbmFeesCredits?.PBMtransactionfeesBasis
                  ? JSON.stringify(
                      [
                        {
                          lable: "per Rx",
                          value: "per Rx",
                        },
                        {
                          lable: "PEPM",
                          value: "PEPM",
                        },
                        {
                          lable: "PMPM",
                          value: "PMPM",
                        },
                        {
                          lable: "No Fee",
                          value: "No Fee",
                        },
                        {
                          lable: "Not Applicable",
                          value: "Not Applicable",
                        },
                      ].find(
                        (d) =>
                          d.value == pbmFeesCredits?.PBMtransactionfeesBasis
                      )
                    )
                  : "",

                PBMtransactionfeesResponseFormat:
                  pbmFeesCredits?.PBMtransactionfeesResponseFormat,

                CoalitionorAggregatorfeesBasis:
                  pbmFeesCredits?.CoalitionorAggregatorfeesBasis
                    ? JSON.stringify(
                        [
                          {
                            lable: "per Rx",
                            value: "per Rx",
                          },
                          {
                            lable: "PEPM",
                            value: "PEPM",
                          },
                          {
                            lable: "PMPM",
                            value: "PMPM",
                          },
                          {
                            lable: "Flat Fee",
                            value: "Flat Fee",
                          },
                          {
                            lable: "No Fee",
                            value: "No Fee",
                          },
                        ].find(
                          (d) =>
                            d.value ==
                            pbmFeesCredits?.CoalitionorAggregatorfeesBasis
                        )
                      )
                    : "",
                CoalitionorAggregatorfeesResponseFormat:
                  pbmFeesCredits?.CoalitionorAggregatorfeesResponseFormat,
                listandspecifyallotherfees:
                  pbmFeesCredits?.listandspecifyallotherfees,

                onsitePharmacyPBMAdministrationFeeBasis:
                  pbmFeesCredits?.onsitePharmacyPBMAdministrationFeeBasis
                    ? JSON.stringify(
                        [
                          {
                            lable: "Per Rx",
                            value: "Per Rx",
                          },
                          {
                            lable: "Per Onsite RX",
                            value: "Per Onsite RX",
                          },
                          {
                            lable: "PEPM",
                            value: "PEPM",
                          },
                          {
                            lable: "PMPM",
                            value: "PMPM",
                          },
                        ].find(
                          (d) =>
                            d.value ==
                            pbmFeesCredits?.onsitePharmacyPBMAdministrationFeeBasis
                        )
                      )
                    : "",

                onsitePharmacyPBMAdministrationFeeResponseFormat:
                  pbmFeesCredits?.onsitePharmacyPBMAdministrationFeeResponseFormat,

                onsitePharmacyAggregatorAdministrationFeeBasis:
                  pbmFeesCredits?.onsitePharmacyAggregatorAdministrationFeeBasis
                    ? JSON.stringify(
                        [
                          {
                            lable: "Per Rx",
                            value: "Per Rx",
                          },
                          {
                            lable: "Per Onsite RX",
                            value: "Per Onsite RX",
                          },
                          {
                            lable: "PEPM",
                            value: "PEPM",
                          },
                          {
                            lable: "PMPM",
                            value: "PMPM",
                          },
                        ].find(
                          (d) =>
                            d.value ==
                            pbmFeesCredits?.onsitePharmacyAggregatorAdministrationFeeBasis
                        )
                      )
                    : "",
                onsitePharmacyAggregatorAdministrationFeeResponseFormat:
                  pbmFeesCredits?.onsitePharmacyAggregatorAdministrationFeeResponseFormat,

                PBMContractFile: selectedRowData?.pbmContractFileUrl
                  ? selectedRowData?.pbmContractFileUrl
                  : "",
                HospitalandHealthSystem:
                  selectedRowData?.hospitalHealthSystemRequirementQuestionnaireFileUrl
                    ? selectedRowData?.hospitalHealthSystemRequirementQuestionnaireFileUrl
                    : "",
                PBMClaims: selectedRowData?.pbmClaimsFileUrl
                  ? selectedRowData?.pbmClaimsFileUrl
                  : "",
                retailNetworkPricingStructure: selectedRowData?.retailNetworkPricingStructure
                ? JSON.stringify(
                  pricingStructureDropdownOptions.find(
                    (d) =>
                      d.value ==
                    selectedRowData?.retailNetworkPricingStructure
                  )
                ) : "",
                retailNetworkPricingStructureComment: selectedRowData?.retailNetworkPricingStructureComment
                ? selectedRowData?.retailNetworkPricingStructureComment
                : "",
                mailProgramPricingStructure: selectedRowData?.mailProgramPricingStructure
                ?  JSON.stringify(
                  pricingStructureDropdownOptions.find(
                    (d) =>
                      d.value ==
                    selectedRowData?.mailProgramPricingStructure
                  )
                ) : "",
                mailProgramPricingStructureComment: selectedRowData?.mailProgramPricingStructureComment
                ? selectedRowData?.mailProgramPricingStructureComment
                : "",
                specialtyProgramPricingStructure: selectedRowData?.specialtyProgramPricingStructure
                ? JSON.stringify(
                  pricingStructureDropdownOptions.find(
                    (d) =>
                      d.value ==
                    selectedRowData?.specialtyProgramPricingStructure
                  )
                ) : "",
                specialtyProgramPricingStructureComment: selectedRowData?.specialtyProgramPricingStructureComment
                ? selectedRowData?.specialtyProgramPricingStructureComment
                : "",
                rebateProgramPricingStructure: selectedRowData?.rebateProgramPricingStructure
                ? JSON.stringify(
                  pricingStructureDropdownOptions.find(
                    (d) =>
                      d.value ==
                    selectedRowData?.rebateProgramPricingStructure
                  )
                ) : "",
                rebateProgramPricingStructureComment: selectedRowData?.rebateProgramPricingStructureComment
                ? selectedRowData?.rebateProgramPricingStructureComment
                : "",
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                setFieldValue,
                values,
                touched,
                isValid,
                errors,
              }) => {
                const handleFormSubmit = async (e) => {
                  await handleSubmit(e);
                  if (Object.keys(errors).length > 0) {
                    const firstErrorField = Object.keys(errors)[0];
                    const errorFieldElement = document.getElementsByName(firstErrorField)[0];
                    if (errorFieldElement) {
                      errorFieldElement.focus();
                    }
                  }
                };
                return (
                <Form
                  onSubmit={handleFormSubmit}
                 
                  style={{ height: "80vh" }}
                  className="overflow-auto p-2"
                >
                  <Row className="mb-2 gap-3">
                    <Col>
                      <Form.Group>
                        <Form.Label style={Fontstyling.label}>
                          Client Name <Required />
                          {clientStatus !== null && (
                          <>
                            <span style={{ marginLeft: '10px'}}></span><span
                              style={{
                                width: '12px',
                                height: '12px',
                                borderRadius: '50%',
                                backgroundColor: clientStatus ? theme.PRIMARY_LIGHT_GREEN : theme.PRIMARY_RED,
                                display: 'inline-block',
                              }}
                            ></span>
                            <span style={{ marginLeft: '5px', fontSize:"10px" }}>
                              {clientStatus ? "Claims data is in CGT" : "Claims data is NOT in CGT"}
                            </span>
                            <span></span>
                          </>
                        )}
                        </Form.Label>
                        <AsyncPaginate
                          value={values.client_Name}
                          loadOptions={loadOptions}
                          debounceTimeout={2500}
                          styles={{
                            ...clientListDrpDwnStyles,
                            control: (base) => ({
                              ...clientListDrpDwnStyles.control(base),
                              border: `1px solid ${
                                errors.client_Name &&
                                touched.client_Name &&
                                !values.client_Name
                                  ? "red"
                                  : "lightgrey"
                              }`,
                            }),
                          }}
                          placeholder="Select Client name"
                          onChange={(option) => {
                            setFieldValue("client_Name", option);
                            handleClientChange(option.label)
                          }}
                          additional={{
                            page: 1,
                          }}
                          isSearchable={true}
                          isOptionDisabled={(e) => e.value === 0}
                        />
                        {errors.client_Name && touched.client_Name && (
                          <p className="invalid-feedback d-block">
                            {errors.client_Name}
                          </p>
                        )}
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="text-start">
                        <Form.Label
                          className="text-nowrap"
                          style={Fontstyling.label}
                        >
                          PBM Name
                          <Required />
                        </Form.Label>
                        <Form.Select
                          className="py-1 rounded-0"
                          style={Fontstyling.label}
                          name="PBM"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={
                            values.PBM === "" && errors.PBM && touched.PBM
                          }
                          value={values.PBM}
                        >
                          <option value={""}>Select PBM</option>
                          {pbmList?.map((item, index) => (
                            <option value={JSON.stringify(item)}>
                              {item.Name}
                            </option>
                          ))}
                        </Form.Select>
                        {errors.PBM && touched.PBM && (
                          <Form.Label style={Fontstyling.errorlabel}>
                            {errors.PBM}
                          </Form.Label>
                        )}
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group
                        controlId="validationFormik02"
                        className="px-2"
                      >
                        <Form.Label style={Fontstyling.label}>
                          Current Contract Termination Date
                          <Required />
                        </Form.Label>
                        <Form.Control
                          className="rounded-0 py-1"
                          style={{
                            ...Fontstyling.label,
                            textTransform: "uppercase",
                          }}
                          type="date"
                          name="ContractTermDate"
                          value={values.ContractTermDate}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={
                            errors.ContractTermDate && touched.ContractTermDate
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.ContractTermDate}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="mb-2 gap-3">
                    <Col>
                      <CustomInputField
                        label="Carrier ID"
                        name="CarrierID"
                        value={values}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        maxLength={10}
                      />
                    </Col>
                    <Col>
                      <CustomInputField
                        label="Account ID"
                        name="AccountID"
                        value={values}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        maxLength={10}
                      />
                    </Col>
                    <Col>
                      <CustomInputField
                        label="Group ID"
                        name="GroupID"
                        value={values}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        maxLength={30}
                        errors={errors}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-2 gap-3">
                  
                        <Col>
                          <CustomInputField
                            label="Number of Members"
                            name="NumberOfMembers"
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            maxLength={10}
                            isRequired
                          />
                        </Col>
                        <Col>
                          <CustomInputField
                            label="Number of Employees"
                            name="NumberOfEmployees"
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            maxLength={10}
                            isRequired
                          />
                        </Col>
                        <Col>
                        <Row>
                          <Form.Group className="text-start">
                            <Form.Label
                              className="text-wrap"
                              style={Fontstyling.label}
                            >
                              Retail Network Pricing Structure
                              <Required />
                            </Form.Label>
                            <Form.Select
                              className="py-1 rounded-0"
                              style={Fontstyling.label}
                              name="retailNetworkPricingStructure"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                values.retailNetworkPricingStructure === "" &&
                                errors.retailNetworkPricingStructure &&
                                touched.retailNetworkPricingStructure
                              }
                              value={values.retailNetworkPricingStructure}
                            >
                              <option value={""}>Select Retail Network Pricing Structure</option>
                              {pricingStructureDropdownOptions?.map((item, index) => (
                                <option value={JSON.stringify(item)}>
                                  {item.lable}
                                </option>
                              ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                              {
                                errors.retailNetworkPricingStructure
                              }
                            </Form.Control.Feedback>
                          </Form.Group>
                          </Row>

                          <Row className={`${values.retailNetworkPricingStructure && JSON.parse(values.retailNetworkPricingStructure)?.value === "Other - Explain" ? 'd-block' : 'd-none'} mt-2 gap-3`}>
                          <Form.Group>
                            <Form.Control
                              as="textarea"
                              className="rounded-0"
                              name="retailNetworkPricingStructureComment"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                errors.retailNetworkPricingStructureComment &&
                                touched.retailNetworkPricingStructureComment
                              }
                              placeholder={"Comment here"}
                              style={Fontstyling.label}
                              value={
                                values.retailNetworkPricingStructureComment
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              {
                                errors.retailNetworkPricingStructureComment
                              }
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Row>
                        </Col>
                      
                    
                  </Row>
                  <Row className="mb-2 gap-3">
                    <Col>
                      <Row>
                          <Form.Group className="text-start">
                            <Form.Label
                              className="text-wrap"
                              style={Fontstyling.label}
                            >
                              Mail Program Pricing Structure
                              <Required />
                            </Form.Label>
                            <Form.Select
                              className="py-1 rounded-0"
                              style={Fontstyling.label}
                              name="mailProgramPricingStructure"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                values.mailProgramPricingStructure === "" &&
                                errors.mailProgramPricingStructure &&
                                touched.mailProgramPricingStructure
                              }
                              value={values.mailProgramPricingStructure}
                            >
                              <option value={""}>Select Mail Program Pricing Structure</option>
                              {pricingStructureDropdownOptions?.map((item, index) => (
                                <option value={JSON.stringify(item)}>
                                  {item.lable}
                                </option>
                              ))}
                            </Form.Select>
                            {errors.mailProgramPricingStructure &&
                              touched.mailProgramPricingStructure && (
                                <Form.Label style={Fontstyling.errorlabel}>
                                  {errors.mailProgramPricingStructure}
                                </Form.Label>
                              )}
                          </Form.Group>
                       </Row>
                        <Row className={`${values.mailProgramPricingStructure && JSON.parse(values.mailProgramPricingStructure)?.value === "Other - Explain" ? 'd-block' : 'd-none'} mt-2 gap-3`}>
                          <Form.Group>
                            <Form.Control
                              as="textarea"
                              className="rounded-0"
                              name="mailProgramPricingStructureComment"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                errors.mailProgramPricingStructureComment &&
                                touched.mailProgramPricingStructureComment
                              }
                              placeholder={"Comment here"}
                              style={Fontstyling.label}
                              value={
                                values.mailProgramPricingStructureComment
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              {
                                errors.mailProgramPricingStructureComment
                              }
                            </Form.Control.Feedback>
                          </Form.Group>
                      </Row>
                    </Col>
                    <Col>
                      <Row> 
                          <Form.Group className="text-start"> 
                            <Form.Label
                              className="text-wrap"
                              style={Fontstyling.label}
                            >
                              Specialty Program Pricing Structure
                              <Required />
                            </Form.Label>
                            <Form.Select
                              className="py-1 rounded-0"
                              style={Fontstyling.label}
                              name="specialtyProgramPricingStructure"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                values.specialtyProgramPricingStructure === "" &&
                                errors.specialtyProgramPricingStructure &&
                                touched.specialtyProgramPricingStructure
                              }
                              value={values.specialtyProgramPricingStructure}
                            >
                              <option value={""}>Select Specialty Program Pricing Structure</option>
                              {pricingStructureDropdownOptions?.map((item, index) => (
                                <option value={JSON.stringify(item)}>
                                  {item.lable}
                                </option>
                              ))}
                            </Form.Select>
                            {errors.specialtyProgramPricingStructure &&
                              touched.specialtyProgramPricingStructure && (
                                <Form.Label style={Fontstyling.errorlabel}>
                                  {errors.specialtyProgramPricingStructure}
                                </Form.Label>
                              )}
                          </Form.Group>
                        </Row>
                        <Row className={`${values.specialtyProgramPricingStructure && JSON.parse(values.specialtyProgramPricingStructure)?.value === "Other - Explain" ? 'd-block' : 'd-none'} mt-2 gap-3`}>
                          <Form.Group>
                            <Form.Control
                              as="textarea"
                              className="rounded-0"
                              name="specialtyProgramPricingStructureComment"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                errors.specialtyProgramPricingStructureComment &&
                                touched.specialtyProgramPricingStructureComment
                              }
                              placeholder={"Comment here"}
                              style={Fontstyling.label}
                              value={
                                values.specialtyProgramPricingStructureComment
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              {
                                errors.specialtyProgramPricingStructureComment
                              }
                            </Form.Control.Feedback>
                          </Form.Group>
                      </Row>
                    </Col>
                 
                    <Col>
                      <Row>
                          <Form.Group className="text-start">
                            <Form.Label
                              className="text-wrap"
                              style={Fontstyling.label}
                            >
                              Rebate Program Pricing Structure
                              <Required />
                            </Form.Label>
                            <Form.Select
                              className="py-1 rounded-0"
                              style={Fontstyling.label}
                              name="rebateProgramPricingStructure"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                values.rebateProgramPricingStructure === "" &&
                                errors.rebateProgramPricingStructure &&
                                touched.rebateProgramPricingStructure
                              }
                              value={values.rebateProgramPricingStructure}
                            >
                              <option value={""}>Select Rebate Program Pricing Structure</option>
                              {pricingStructureDropdownOptions?.map((item, index) => (
                                <option value={JSON.stringify(item)}>
                                  {item.lable}
                                </option>
                              ))}
                            </Form.Select>
                            {errors.rebateProgramPricingStructure &&
                              touched.rebateProgramPricingStructure && (
                                <Form.Label style={Fontstyling.errorlabel}>
                                  {errors.rebateProgramPricingStructure}
                                </Form.Label>
                              )}
                          </Form.Group>
                        </Row>
                        <Row className={`${values.rebateProgramPricingStructure && JSON.parse(values.rebateProgramPricingStructure)?.value === "Other - Explain" ? 'd-block' : 'd-none'} mt-2 gap-3`}>
                          <Form.Group>
                            <Form.Control
                              as="textarea"
                              className="rounded-0"
                              name="rebateProgramPricingStructureComment"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                errors.rebateProgramPricingStructureComment &&
                                touched.rebateProgramPricingStructureComment
                              }
                              placeholder={"Comment here"}
                              style={Fontstyling.label}
                              value={
                                values.rebateProgramPricingStructureComment
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              {
                                errors.rebateProgramPricingStructureComment
                              }
                            </Form.Control.Feedback>
                          </Form.Group>
                      </Row>
                    </Col>
                    </Row>
                      <Row className="gap-3">
                        <Col>
                          <CustomInputField
                            label="Retail 30 Network"
                            name="Retail30Network"
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            maxLength={30}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                        <Col>
                          <CustomInputField
                            label="Retail 90 Network"
                            name="Retail90Network"
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            maxLength={30}
                            isRequired
                          />
                        </Col>
                      </Row>
                  <Row className="mt-2 gap-3">
                    <Col>
                      <CustomInputField
                        label="Mail Program"
                        name="MailProg"
                        value={values}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        maxLength={30}
                        isRequired
                      />
                    </Col>
                    <Col>
                      <CustomInputField
                        label="Specialty Program"
                        name="SpecialProg"
                        value={values}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        maxLength={30}
                        isRequired
                      />
                    </Col>
                    <Col>
                      <Form.Group className="text-start">
                        <Form.Label
                          className="text-nowrap"
                          style={Fontstyling.label}
                        >
                          Clinical Programs
                          <Required />
                        </Form.Label>
                        <img
                          data-tip="Prior Authorization, Quality Limits, Generic Step Therapy, Specialty Step Therapy, Adherence, Fraud Waste & Abuse programs"
                          src={require("../../../assets/icon/Question_mark_back.png")}
                          style={{ height: 15, marginLeft: 3 }}
                        />
                        <ReactTooltip
                          className="border-2 border-info p-3"
                          border
                          backgroundColor="white"
                          textColor="black"
                        />
                        <Form.Control
                          name="ClinicProg"
                          type="text"
                          className="py-1 rounded-0"
                          style={Fontstyling.label}
                          value={values.ClinicProg}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.ClinicProg && errors.ClinicProg}
                          placeholder="Clinical Programs"
                          maxLength={30}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.ClinicProg}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col>
                      <CustomInputField
                        label="Formulary Strategy"
                        name="FormularyStrategy"
                        value={values}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        maxLength={30}
                        isRequired
                      />
                    </Col>
                  </Row>
                  <Row className="gap-3">
                    <Col>
                      <CustomInputField
                        label="Specialty Copay Card"
                        name="SpecCopayCard"
                        value={values}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        maxLength={30}
                        isRequired
                      />
                    </Col>
                    <Col>
                      <CustomInputField
                        label="Alternative Funding"
                        name="AlternateFund"
                        value={values}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        maxLength={30}
                        isRequired
                      />
                    </Col>
                    <Col>
                      <CustomInputField
                        label="Accumulator Adjustment Program"
                        name="AccumulatorProgram"
                        value={values}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        maxLength={30}
                        isRequired
                      />
                    </Col>
                    <Col>
                      <Form.Group className="text-start">
                        <Form.Label
                          className="text-nowrap"
                          style={Fontstyling.label}
                        >
                          Onsite Pharmacy ID
                        </Form.Label>
                        <img
                          data-tip="List all Onsite Pharmacy IDs, separated by comma"
                          src={require("../../../assets/icon/Question_mark_back.png")}
                          style={{ height: 15, marginLeft: 3 }}
                        />
                        <ReactTooltip
                          className="border-2 border-info p-3"
                          border
                          backgroundColor="white"
                          textColor="black"
                        />
                        <Form.Control
                          name="OnsitePharmacyID"
                          type="text"
                          className="py-1 rounded-0"
                          style={Fontstyling.label}
                          value={values.OnsitePharmacyID}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={
                            touched.OnsitePharmacyID && errors.OnsitePharmacyID
                          }
                          placeholder="Onsite Pharmacy ID"
                          maxLength={500}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.OnsitePharmacyID}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <label className="mt-4 fw-bold" style={Fontstyling.label}>
                    Non-Specialty Drugs
                  </label>
                  <div className="container p-0 mt-2">
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead className="thead-dark">
                          <tr className="text-center">
                            <th colspan="2" style={Fontstyling.label}>
                              AWP-% Discounts (e.g., enter 0.25 for 25%)
                            </th>
                            <th colspan="2" style={Fontstyling.label}>
                              Dispensing Fees
                            </th>
                            <th colspan="2" style={Fontstyling.label}>
                              Rebates
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style={Fontstyling.label}>Mail Brands</td>
                            <td>
                              <InputGroup>
                                <Form.Control
                                  name="NonSp_MailBrands_AWPDiscounts"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={values.NonSp_MailBrands_AWPDiscounts}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={
                                    !!errors.NonSp_MailBrands_AWPDiscounts
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.NonSp_MailBrands_AWPDiscounts}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                            <td style={Fontstyling.label}>Mail Brands</td>
                            <td>
                              <InputGroup>
                                <InputGroup.Text className="py-0 fw-bold">
                                  $
                                </InputGroup.Text>
                                <Form.Control
                                  name="NonSp_MailBrands_DispensingFees"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={values.NonSp_MailBrands_DispensingFees}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  maxLength={10}
                                  isInvalid={
                                    !!errors.NonSp_MailBrands_DispensingFees
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.NonSp_MailBrands_DispensingFees}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                            <td style={Fontstyling.label}>Mail Brands</td>
                            <td>
                              <InputGroup>
                                <InputGroup.Text className="py-0 fw-bold">
                                  $
                                </InputGroup.Text>
                                <Form.Control
                                  name="NonSp_MailBrands_Rebates"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={values.NonSp_MailBrands_Rebates}
                                  onChange={(e) => {                                    
                                    handleChange(e);
                                    if (values.nonrebateProposal) {
                                      const parsedProposal = JSON.parse(values.nonrebateProposal);
                                     
                                      if (parsedProposal.value === "per Brand claim") {
                                        setFieldValue('MailNonPreferredTier3BrandClaims', e.target.value);
                                      }
                                    }                                                                     
                                  }}
                                  onBlur={handleBlur}
                                  maxLength={10}
                                  isInvalid={!!errors.NonSp_MailBrands_Rebates}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.NonSp_MailBrands_Rebates}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                          </tr>
                          <tr>
                            <td style={Fontstyling.label}>Mail Generics</td>
                            <td>
                              <InputGroup>
                                <Form.Control
                                  name="NonSp_MailGenerics_AWPDiscounts"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={values.NonSp_MailGenerics_AWPDiscounts}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={
                                    !!errors.NonSp_MailGenerics_AWPDiscounts
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.NonSp_MailGenerics_AWPDiscounts}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                            <td style={Fontstyling.label}>Mail Generics</td>
                            <td>
                              <InputGroup>
                                <InputGroup.Text className="py-0 fw-bold">
                                  $
                                </InputGroup.Text>
                                <Form.Control
                                  name="NonSp_MailGenerics_DispensingFees"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={
                                    values.NonSp_MailGenerics_DispensingFees
                                  }
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  type="text"
                                  maxLength={10}
                                  isInvalid={
                                    !!errors.NonSp_MailGenerics_DispensingFees
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.NonSp_MailGenerics_DispensingFees}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                            <td style={Fontstyling.label}>Retail 30 Brands</td>
                            <td>
                              <InputGroup>
                                <InputGroup.Text className="py-0 fw-bold">
                                  $
                                </InputGroup.Text>
                                <Form.Control
                                  name="NonSp_Retail30Brands_Rebates"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={values.NonSp_Retail30Brands_Rebates}
                                  onChange={(e) => {                                    
                                    handleChange(e);
                                    if (values.nonrebateProposal) {
                                      const parsedProposal = JSON.parse(values.nonrebateProposal);
                                     
                                      if (parsedProposal.value === "per Brand claim") {
                                        setFieldValue('RetailNonPreferredTier3BrandClaims', e.target.value);
                                      }
                                    }                                                                     
                                  }}
                                  onBlur={handleBlur}
                                  type="text"
                                  maxLength={10}
                                  isInvalid={
                                    !!errors.NonSp_Retail30Brands_Rebates
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.NonSp_Retail30Brands_Rebates}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                          </tr>
                          <tr>
                            <td style={Fontstyling.label}>Retail 30 Brands</td>
                            <td>
                              <InputGroup>
                                <Form.Control
                                  name="NonSp_Retail30Brands_AWPDiscounts"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={
                                    values.NonSp_Retail30Brands_AWPDiscounts
                                  }
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={
                                    !!errors.NonSp_Retail30Brands_AWPDiscounts
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.NonSp_Retail30Brands_AWPDiscounts}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                            <td style={Fontstyling.label}>Retail 30 Brands</td>
                            <td>
                              <InputGroup>
                                <InputGroup.Text className="py-0 fw-bold">
                                  $
                                </InputGroup.Text>
                                <Form.Control
                                  name="NonSp_Retail30Brands_DispensingFees"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={
                                    values.NonSp_Retail30Brands_DispensingFees
                                  }
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  type="text"
                                  maxLength={10}
                                  isInvalid={
                                    !!errors.NonSp_Retail30Brands_DispensingFees
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.NonSp_Retail30Brands_DispensingFees}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                            <td style={Fontstyling.label}>Retail 90 Brands</td>
                            <td>
                              <InputGroup>
                                <InputGroup.Text className="py-0 fw-bold">
                                  $
                                </InputGroup.Text>
                                <Form.Control
                                  name="NonSp_Retail90Brands_Rebates"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={values.NonSp_Retail90Brands_Rebates}
                                  onChange={(e) => {                                    
                                    handleChange(e);
                                    if (values.nonrebateProposal) {
                                      const parsedProposal = JSON.parse(values.nonrebateProposal);
                                     
                                      if (parsedProposal.value === "per Brand claim") {
                                        setFieldValue('Retail90NonPreferredTier3BrandClaims', e.target.value);
                                      }
                                    }                                                                     
                                  }}
                                  onBlur={handleBlur}
                                  type="text"
                                  maxLength={10}
                                  isInvalid={
                                    !!errors.NonSp_Retail90Brands_Rebates
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.NonSp_Retail90Brands_Rebates}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                          </tr>
                          <tr className="border-0">
                            <td style={Fontstyling.label} className="border">
                              Retail 30 Generics
                            </td>
                            <td className="border">
                              <InputGroup>
                                <Form.Control
                                  name="NonSp_Retail30Generics_AWPDiscounts"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={
                                    values.NonSp_Retail30Generics_AWPDiscounts
                                  }
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={
                                    !!errors.NonSp_Retail30Generics_AWPDiscounts
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.NonSp_Retail30Generics_AWPDiscounts}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                            <td style={Fontstyling.label} className="border">
                              Retail 30 Generics
                            </td>
                            <td className="border">
                              <InputGroup>
                                <InputGroup.Text className="py-0 fw-bold">
                                  $
                                </InputGroup.Text>
                                <Form.Control
                                  name="NonSp_Retail30Generics_DispensingFees"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={
                                    values.NonSp_Retail30Generics_DispensingFees
                                  }
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  type="text"
                                  maxLength={10}
                                  isInvalid={
                                    !!errors.NonSp_Retail30Generics_DispensingFees
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.NonSp_Retail30Generics_DispensingFees}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                          </tr>
                          <tr className="border-0">
                            <td style={Fontstyling.label} className="border">
                              Retail 90 Brands
                            </td>
                            <td className="border">
                              <InputGroup>
                                <Form.Control
                                  name="NonSp_Retail90Brands_AWPDiscounts"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={
                                    values.NonSp_Retail90Brands_AWPDiscounts
                                  }
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={
                                    !!errors.NonSp_Retail90Brands_AWPDiscounts
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.NonSp_Retail90Brands_AWPDiscounts}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                            <td style={Fontstyling.label} className="border">
                              Retail 90 Brands
                            </td>
                            <td className="border">
                              <InputGroup>
                                <InputGroup.Text className="py-0 fw-bold">
                                  $
                                </InputGroup.Text>
                                <Form.Control
                                  name="NonSp_Retail90Brands_DispensingFees"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={
                                    values.NonSp_Retail90Brands_DispensingFees
                                  }
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  type="text"
                                  maxLength={10}
                                  isInvalid={
                                    !!errors.NonSp_Retail90Brands_DispensingFees
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.NonSp_Retail90Brands_DispensingFees}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                          </tr>
                          <tr className="border-0">
                            <td style={Fontstyling.label} className="border">
                              Retail 90 Generics
                            </td>
                            <td className="border">
                              <InputGroup>
                                <Form.Control
                                  name="NonSp_Retail90Generics_AWPDiscounts"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={
                                    values.NonSp_Retail90Generics_AWPDiscounts
                                  }
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={
                                    !!errors.NonSp_Retail90Generics_AWPDiscounts
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.NonSp_Retail90Generics_AWPDiscounts}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                            <td style={Fontstyling.label} className="border">
                              Retail 90 Generics
                            </td>
                            <td className="border">
                              <InputGroup>
                                <InputGroup.Text className="py-0 fw-bold">
                                  $
                                </InputGroup.Text>
                                <Form.Control
                                  name="NonSp_Retail90Generics_DispensingFees"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={
                                    values.NonSp_Retail90Generics_DispensingFees
                                  }
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  type="text"
                                  maxLength={10}
                                  isInvalid={
                                    !!errors.NonSp_Retail90Generics_DispensingFees
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.NonSp_Retail90Generics_DispensingFees}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <label className="mt-4 fw-bold" style={Fontstyling.label}>
                      Non-Specialty AWP-% and Dispensing Fee Price Guarantees
                      and Exclusions
                    </label>
                    <Row className="gap-3">
                      <Col>
                        <Form.Group className="text-start">
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            Select all claim types that are excluded from your
                            guarantees:
                            <Required />
                          </Form.Label>
                          <Select
                            name="nonSpltdiscountDispensingFeeGuarantees"
                            isMulti
                            value={
                              values.nonSpltdiscountDispensingFeeGuarantees
                                ? values.nonSpltdiscountDispensingFeeGuarantees
                                    ?.split(",")
                                    .map((item) => ({
                                      value: item,
                                      label: item,
                                    }))
                                : values.nonSpltdiscountDispensingFeeGuarantees
                            }
                            className="py-0 rounded-0"
                            options={DiscountDispensingFeeGuaranteesOption}
                            onChange={(selectedOption) => {
                              let option = selectedOption
                                .map((item) => item.value)
                                .join(",");
                              setFieldValue(
                                "nonSpltdiscountDispensingFeeGuarantees",
                                option
                              );
                              if (
                                selectedOption.some(
                                  (item) => item.value === "Other - list all exclusions in the text box provided"
                                )
                              ) {
                                setFieldValue("nonSpltdiscountDispensingFeeGuaranteesComment", "");
                              }
                            }}
                            styles={{
                              control: (base, { isDisabled }) => ({
                                ...Fontstyling.primaryparagraph,
                                display: "flex",
                                alignItems: "center",
                                border:
                                  errors.nonSpltdiscountDispensingFeeGuarantees &&
                                  touched.nonSpltdiscountDispensingFeeGuarantees
                                    ? "1px solid red"
                                    : "1px solid #ced4da",
                                width: "auto",
                                // maxHeight: "30px",
                                height: "auto",
                                textAlign: "left",
                                backgroundColor: isDisabled ? "#e9ecef" : "",
                              }),
                              option: (
                                styles,
                                { data, isDisabled, isFocused, isSelected }
                              ) => {
                                return {
                                  ...styles,
                                  ...Fontstyling.primaryparagraph,
                                  textAlign: "left",
                                };
                              },
                              menu: (styles) => {
                                return {
                                  ...styles,
                                  zIndex: "5",
                                };
                              },
                            }}
                          />
                          {errors.nonSpltdiscountDispensingFeeGuarantees &&
                            touched.nonSpltdiscountDispensingFeeGuarantees && (
                              <div
                                className="fw-regular mt-1"
                                style={Fontstyling.errorlabel}
                              >
                                {errors.nonSpltdiscountDispensingFeeGuarantees}
                              </div>
                            )}
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-start">
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            State
                            <Required />
                          </Form.Label>
                          <img
                            data-tip="Select from the list provided any Most Favored Nations States excluded from guarantees.  If Most Favored Nations are not an exclusion to guarantees, please select N/A."
                            src={require("../../../assets/icon/Question_mark_back.png")}
                            style={{ height: 15, marginLeft: 3 }}
                          />
                          <ReactTooltip
                            className="border-2 border-info p-3"
                            border
                            backgroundColor="white"
                            textColor="black"
                          />
                          <Select
                            name="nonSplState"
                            isMulti
                            value={
                              values.nonSplState
                                ? values.nonSplState
                                    ?.split(",")
                                    .map((item) => ({
                                      value: item,
                                      label: item,
                                    }))
                                : values.nonSplState
                            }
                            className="py-0 rounded-0"
                            options={stateList}
                            onChange={(selectedOption) => {
                              let option = selectedOption
                                .map((item) => item.value)
                                .join(",");
                              setFieldValue("nonSplState", option);
                            }}
                            styles={{
                              control: (base, { isDisabled }) => ({
                                ...Fontstyling.primaryparagraph,
                                display: "flex",
                                alignItems: "center",
                                border:
                                  errors.nonSplState && touched.nonSplState
                                    ? "1px solid red"
                                    : "1px solid #ced4da",
                                width: "auto",
                                // maxHeight: "30px",
                                height: "auto",
                                textAlign: "left",
                                backgroundColor: isDisabled ? "#e9ecef" : "",
                              }),
                              option: (
                                styles,
                                { data, isDisabled, isFocused, isSelected }
                              ) => {
                                return {
                                  ...styles,
                                  ...Fontstyling.primaryparagraph,
                                  textAlign: "left",
                                };
                              },
                              menu: (styles) => {
                                return {
                                  ...styles,
                                  zIndex: "5",
                                };
                              },
                            }}
                          />
                          {errors.nonSplState && touched.nonSplState && (
                            <div
                              className="fw-regular mt-2"
                              style={Fontstyling.errorlabel}
                            >
                              {errors.nonSplState}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="col-6 mt-2 ">
                      <Col>
                        <Form.Group>
                          <Form.Control
                            as="textarea"
                            className="rounded-0"
                            name="nonSpltdiscountDispensingFeeGuaranteesComment"
                            hidden={
                              !(
                                values.nonSpltdiscountDispensingFeeGuarantees &&
                                values.nonSpltdiscountDispensingFeeGuarantees.includes(
                                  "Other - list all exclusions in the text box provided"
                                )
                              )
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              errors.nonSpltdiscountDispensingFeeGuaranteesComment &&
                              touched.nonSpltdiscountDispensingFeeGuaranteesComment
                            }
                            placeholder={"Claim types that are excluded"}
                            style={Fontstyling.label}
                            value={
                              values.nonSpltdiscountDispensingFeeGuaranteesComment
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {
                              errors.nonSpltdiscountDispensingFeeGuaranteesComment
                            }
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <label className="mt-4 fw-bold" style={Fontstyling.label}>
                      Rebate Guarantees and Exclusions
                    </label>
                    <Row className="gap-3">
                      <Col>
                        <Form.Group className="text-start">
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            Select all claim types that are excluded from your
                            guarantees:
                            <Required />
                          </Form.Label>
                          <Select
                            name="nonSpltRebatediscountDispensingFeeGuarantees"
                            isMulti
                            value={
                              values.nonSpltRebatediscountDispensingFeeGuarantees
                                ? values.nonSpltRebatediscountDispensingFeeGuarantees
                                    ?.split(",")
                                    .map((item) => ({
                                      value: item,
                                      label: item,
                                    }))
                                : values.nonSpltRebatediscountDispensingFeeGuarantees
                            }
                            className="py-0 rounded-0"
                            options={DiscountDispensingFeeGuaranteesOption}
                            onChange={(selectedOption) => {
                              let option = selectedOption
                                .map((item) => item.value)
                                .join(",");
                              setFieldValue(
                                "nonSpltRebatediscountDispensingFeeGuarantees",
                                option
                              );
                              if (
                                selectedOption.some(
                                  (item) => item.value === "Other - list all exclusions in the text box provided"
                                )
                              ) {
                                setFieldValue("nonSpltRebatediscountDispensingFeeGuaranteesComment", "");
                              }
                            }}
                            styles={{
                              control: (base, { isDisabled }) => ({
                                ...Fontstyling.primaryparagraph,
                                display: "flex",
                                alignItems: "center",
                                border:
                                  errors.nonSpltRebatediscountDispensingFeeGuarantees &&
                                  touched.nonSpltRebatediscountDispensingFeeGuarantees
                                    ? "1px solid red"
                                    : "1px solid #ced4da",
                                width: "auto",
                                // maxHeight: "30px",
                                height: "auto",
                                textAlign: "left",
                                backgroundColor: isDisabled ? "#e9ecef" : "",
                              }),
                              option: (
                                styles,
                                { data, isDisabled, isFocused, isSelected }
                              ) => {
                                return {
                                  ...styles,
                                  ...Fontstyling.primaryparagraph,
                                  textAlign: "left",
                                };
                              },
                              menu: (styles) => {
                                return {
                                  ...styles,
                                  zIndex: "5",
                                };
                              },
                            }}
                          />
                          {errors.nonSpltRebatediscountDispensingFeeGuarantees &&
                            touched.nonSpltRebatediscountDispensingFeeGuarantees && (
                              <div
                                className="fw-regular mt-2"
                                style={Fontstyling.errorlabel}
                              >
                                {
                                  errors.nonSpltRebatediscountDispensingFeeGuarantees
                                }
                              </div>
                            )}
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-start">
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            State
                            <Required />
                          </Form.Label>
                          <img
                            data-tip="Select from the list provided any Most Favored Nations States excluded from guarantees.  If Most Favored Nations are not an exclusion to guarantees, please select N/A."
                            src={require("../../../assets/icon/Question_mark_back.png")}
                            style={{ height: 15, marginLeft: 3 }}
                          />
                          <ReactTooltip
                            className="border-2 border-info p-3"
                            border
                            backgroundColor="white"
                            textColor="black"
                          />
                          <Select
                            name="nonRebateSplState"
                            isMulti
                            value={
                              values.nonRebateSplState
                                ? values.nonRebateSplState
                                    ?.split(",")
                                    .map((item) => ({
                                      value: item,
                                      label: item,
                                    }))
                                : values.nonRebateSplState
                            }
                            className="py-0 rounded-0"
                            options={stateList}
                            onChange={(selectedOption) => {
                              let option = selectedOption
                                .map((item) => item.value)
                                .join(",");
                              setFieldValue("nonRebateSplState", option);
                            }}
                            styles={{
                              control: (base, { isDisabled }) => ({
                                ...Fontstyling.primaryparagraph,
                                display: "flex",
                                alignItems: "center",
                                border:
                                  errors.nonRebateSplState &&
                                  touched.nonRebateSplState
                                    ? "1px solid red"
                                    : "1px solid #ced4da",
                                width: "auto",
                                // maxHeight: "30px",
                                height: "auto",
                                textAlign: "left",
                                backgroundColor: isDisabled ? "#e9ecef" : "",
                              }),
                              option: (
                                styles,
                                { data, isDisabled, isFocused, isSelected }
                              ) => {
                                return {
                                  ...styles,
                                  ...Fontstyling.primaryparagraph,
                                  textAlign: "left",
                                };
                              },
                              menu: (styles) => {
                                return {
                                  ...styles,
                                  zIndex: "5",
                                };
                              },
                            }}
                          />
                          {errors.nonRebateSplState &&
                            touched.nonRebateSplState && (
                              <div
                                className="fw-regular mt-2"
                                style={Fontstyling.errorlabel}
                              >
                                {errors.nonRebateSplState}
                              </div>
                            )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="col-6 mt-2 ">
                      <Col>
                        <Form.Group>
                          <Form.Control
                            as="textarea"
                            className="rounded-0"
                            name={
                              "nonSpltRebatediscountDispensingFeeGuaranteesComment"
                            }
                            hidden={
                              !(
                                values.nonSpltRebatediscountDispensingFeeGuarantees &&
                                values.nonSpltRebatediscountDispensingFeeGuarantees.includes(
                                  "Other - list all exclusions in the text box provided"
                                )
                              )
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              errors.nonSpltRebatediscountDispensingFeeGuaranteesComment &&
                              touched.nonSpltRebatediscountDispensingFeeGuaranteesComment
                            }
                            placeholder={"Claim types that are excluded"}
                            style={Fontstyling.label}
                            value={
                              values.nonSpltRebatediscountDispensingFeeGuaranteesComment
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {
                              errors.nonSpltRebatediscountDispensingFeeGuaranteesComment
                            }
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="gap-3 mt-2">
                      <Col>
                        <Form.Group className="text-start">
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            Confirm the claim type basis for your rebate
                            proposal
                            <Required />
                          </Form.Label>
                          <Form.Select
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            name="nonrebateProposal"
                            onChange={(e) => {
                              handleChange(e);
                              let { value } = e.target;
                              console.log("nonrebateProposal:", values.nonrebateProposal);
                              if (value) {
                                const parsedValue = JSON.parse(value);
                                if (parsedValue?.value === "per formulary (preferred) brand claim") {
                                  setFieldValue('RetailNonPreferredTier3BrandClaims', "");
                                  setFieldValue('Retail90NonPreferredTier3BrandClaims', "");
                                  setFieldValue('MailNonPreferredTier3BrandClaims', "");
                                }
                                if (parsedValue?.value === "per Brand claim") {
                                  setFieldValue('MailNonPreferredTier3BrandClaims', values.NonSp_MailBrands_Rebates);
                                  setFieldValue('RetailNonPreferredTier3BrandClaims', values.NonSp_Retail30Brands_Rebates);
                                  setFieldValue('Retail90NonPreferredTier3BrandClaims', values.NonSp_Retail90Brands_Rebates);
                                }
                              }
                            }}
                            onBlur={handleBlur}
                            isInvalid={
                              values.nonrebateProposal === "" &&
                              errors.nonrebateProposal &&
                              touched.nonrebateProposal
                            }
                            value={values.nonrebateProposal}
                          >
                            <option value={""}>Select rebate proposal</option>
                            {[
                              {
                                lable: "per Brand claim",
                                value: "per Brand claim",
                              },
                              {
                                lable: "per formulary (preferred) brand claim",
                                value: "per formulary (preferred) brand claim",
                              },
                            ]?.map((item, index) => (
                              <option value={JSON.stringify(item)}>
                                {item.lable}
                              </option>
                            ))}
                          </Form.Select>
                          {errors.nonrebateProposal &&
                            touched.nonrebateProposal && (
                              <Form.Label style={Fontstyling.errorlabel}>
                                {errors.nonrebateProposal}
                              </Form.Label>
                            )}
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-start">
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            Confirm your rebate structure
                            <Required />
                          </Form.Label>
                          <Form.Select
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            name="nonrebateStructure"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              values.nonrebateStructure === "" &&
                              errors.nonrebateStructure &&
                              touched.nonrebateStructure
                            }
                            value={values.nonrebateStructure}
                          >
                            <option value={""}>Select rebate structure</option>
                            {[
                              {
                                lable: "Fixed Rate",
                                value: "Fixed Rate",
                              },
                              {
                                lable: "Minimum Guarantee with Annual True-up",
                                value: "Minimum Guarantee with Annual True-up",
                              },
                            ]?.map((item, index) => (
                              <option value={JSON.stringify(item)}>
                                {item.lable}
                              </option>
                            ))}
                          </Form.Select>
                          {errors.nonrebateStructure &&
                            touched.nonrebateStructure && (
                              <Form.Label style={Fontstyling.errorlabel}>
                                {errors.nonrebateStructure}
                              </Form.Label>
                            )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Form.Group className="text-start">
                      <Row className="mt-4 gap-3">
                        <Col className="">
                          <Form.Label style={Fontstyling.label}>
                            Please specify all products excluded from rebates
                            due to low Wholesale Acquisition Cost (WAC) strategy
                            <Required />
                          </Form.Label>
                        </Col>
                        <Col className="">
                          <Form.Control
                            as="textarea"
                            className="rounded-0"
                            name="nonWholesaleAcquisitionCostStrategy"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              errors.nonWholesaleAcquisitionCostStrategy &&
                              touched.nonWholesaleAcquisitionCostStrategy
                            }
                            placeholder={"Comment here"}
                            style={Fontstyling.label}
                            value={values.nonWholesaleAcquisitionCostStrategy}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.nonWholesaleAcquisitionCostStrategy}
                          </Form.Control.Feedback>
                        </Col>
                      </Row>
                    </Form.Group>
                    <Row className="gap-3 mt-2">
                      <Col>
                        <Form.Group className="text-nowrap">
                          <Form.Label
                            style={Fontstyling.label}
                            className="text-start"
                          >
                            Insulin claims
                          </Form.Label>
                          <Form.Control
                            name="InsulinClaims"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.InsulinClaims}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            type="text"
                            placeholder="InsulinClaims"
                            maxLength={10}
                            isInvalid={errors.InsulinClaims}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.InsulinClaims}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-nowrap">
                          <Form.Label
                            style={Fontstyling.label}
                            className="text-start"
                          >
                            Retail Non-preferred or Tier 3 brand claims
                          </Form.Label>
                          <Form.Control
                            name="RetailNonPreferredTier3BrandClaims"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.RetailNonPreferredTier3BrandClaims}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            type="text"
                            placeholder="Retail Non-preferred or Tier 3 brand claims"
                            maxLength={10}
                            isInvalid={
                              errors.RetailNonPreferredTier3BrandClaims
                            }
                            disabled={values?.nonrebateProposal && JSON.parse(values?.nonrebateProposal)?.value === "per formulary (preferred) brand claim"}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.RetailNonPreferredTier3BrandClaims}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="gap-3 mt-2">
                      <Col>
                        <Form.Group className="text-nowrap">
                          <Form.Label
                            style={Fontstyling.label}
                            className="text-start"
                          >
                            Retail 90 Non-preferred or Tier 3 brand claims
                          </Form.Label>
                          <Form.Control
                            name="Retail90NonPreferredTier3BrandClaims"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.Retail90NonPreferredTier3BrandClaims}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            type="text"
                            placeholder="Retail 90 Non-preferred or Tier 3 brand claims"
                            maxLength={10}
                            isInvalid={
                              errors.Retail90NonPreferredTier3BrandClaims
                            }
                            disabled={values?.nonrebateProposal && JSON.parse(values.nonrebateProposal).value === "per formulary (preferred) brand claim"}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.Retail90NonPreferredTier3BrandClaims}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-nowrap">
                          <Form.Label
                            style={Fontstyling.label}
                            className="text-start"
                          >
                            Mail Non-preferred or Tier 3 brand claims
                          </Form.Label>
                          <Form.Control
                            name="MailNonPreferredTier3BrandClaims"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.MailNonPreferredTier3BrandClaims}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            type="text"
                            placeholder="Mail Non-preferred or Tier 3 brand claims"
                            maxLength={10}
                            isInvalid={errors.MailNonPreferredTier3BrandClaims}
                            disabled={values?.nonrebateProposal && JSON.parse(values.nonrebateProposal).value === "per formulary (preferred) brand claim"}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.MailNonPreferredTier3BrandClaims}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>

                  <label className="mt-4 fw-bold" style={Fontstyling.label}>
                    Specialty Drugs
                  </label>
                  <div className="container p-0 mt-2">
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead className="thead-dark">
                          <tr className="text-center">
                            <th colspan="2" style={Fontstyling.label}>
                              AWP-% Discounts (e.g., enter 0.25 for 25%)
                            </th>
                            <th colspan="2" style={Fontstyling.label}>
                              Dispensing Fees
                            </th>
                            <th colspan="2" style={Fontstyling.label}>
                              Rebates
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style={Fontstyling.label}>Mail Brands</td>
                            <td>
                              <InputGroup>
                                <Form.Control
                                  name="Sp_MailBrands_AWPDiscounts"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={values.Sp_MailBrands_AWPDiscounts}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={
                                    !!errors.Sp_MailBrands_AWPDiscounts
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.Sp_MailBrands_AWPDiscounts}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                            <td style={Fontstyling.label}>Mail Brands</td>
                            <td>
                              <InputGroup>
                                <InputGroup.Text className="py-0 fw-bold">
                                  $
                                </InputGroup.Text>
                                <Form.Control
                                  name="Sp_MailBrands_DispensingFees"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={values.Sp_MailBrands_DispensingFees}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  maxLength={10}
                                  isInvalid={
                                    !!errors.Sp_MailBrands_DispensingFees
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.Sp_MailBrands_DispensingFees}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                            <td style={Fontstyling.label}>Mail Brands</td>
                            <td>
                              <InputGroup>
                                <InputGroup.Text className="py-0 fw-bold">
                                  $
                                </InputGroup.Text>
                                <Form.Control
                                  name="Sp_MailBrands_Rebates"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={values.Sp_MailBrands_Rebates}
                                  onChange={(e) => {                                    
                                    handleChange(e);
                                    if (values.splrebateProposal) {
                                      const parsedProposal = JSON.parse(values.splrebateProposal);
                                     
                                      if (parsedProposal.value === "per Brand claim") {
                                        setFieldValue('SpecialtyMailNonPreferredorTier3BrandClaims', e.target.value);
                                      }
                                    }                                                                     
                                  }}
                                  onBlur={handleBlur}
                                  maxLength={10}
                                  isInvalid={!!errors.Sp_MailBrands_Rebates}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.Sp_MailBrands_Rebates}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                          </tr>
                          <tr>
                            <td style={Fontstyling.label}>Mail Generics</td>
                            <td>
                              <InputGroup>
                                <Form.Control
                                  name="Sp_MailGenerics_AWPDiscounts"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={values.Sp_MailGenerics_AWPDiscounts}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={
                                    !!errors.Sp_MailGenerics_AWPDiscounts
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.Sp_MailGenerics_AWPDiscounts}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                            <td style={Fontstyling.label}>Mail Generics</td>
                            <td>
                              <InputGroup>
                                <InputGroup.Text className="py-0 fw-bold">
                                  $
                                </InputGroup.Text>
                                <Form.Control
                                  name="Sp_MailGenerics_DispensingFees"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={values.Sp_MailGenerics_DispensingFees}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  type="text"
                                  maxLength={10}
                                  isInvalid={
                                    !!errors.Sp_MailGenerics_DispensingFees
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.Sp_MailGenerics_DispensingFees}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                            <td style={Fontstyling.label}>Retail 30 Brands</td>
                            <td>
                              <InputGroup>
                                <InputGroup.Text className="py-0 fw-bold">
                                  $
                                </InputGroup.Text>
                                <Form.Control
                                  name="Sp_Retail30Brands_Rebates"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={values.Sp_Retail30Brands_Rebates}
                                  onChange={(e) => {                                    
                                    handleChange(e);
                                    if (values.splrebateProposal) {
                                      const parsedProposal = JSON.parse(values.splrebateProposal);
                                     
                                      if (parsedProposal.value === "per Brand claim") {
                                        setFieldValue('SpecialtyNonPreferredTier3BrandClaims', e.target.value);
                                      }
                                    }                                                                     
                                  }}
                                  onBlur={handleBlur}
                                  type="text"
                                  maxLength={10}
                                  isInvalid={!!errors.Sp_Retail30Brands_Rebates}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.Sp_Retail30Brands_Rebates}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                          </tr>
                          <tr>
                            <td style={Fontstyling.label}>Retail 30 Brands</td>
                            <td>
                              <InputGroup>
                                <Form.Control
                                  name="Sp_Retail30Brands_AWPDiscounts"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={values.Sp_Retail30Brands_AWPDiscounts}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={
                                    !!errors.Sp_Retail30Brands_AWPDiscounts
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.Sp_Retail30Brands_AWPDiscounts}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                            <td style={Fontstyling.label}>Retail 30 Brands</td>
                            <td>
                              <InputGroup>
                                <InputGroup.Text className="py-0 fw-bold">
                                  $
                                </InputGroup.Text>
                                <Form.Control
                                  name="Sp_Retail30Brands_DispensingFees"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={
                                    values.Sp_Retail30Brands_DispensingFees
                                  }
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  type="text"
                                  maxLength={10}
                                  isInvalid={
                                    !!errors.Sp_Retail30Brands_DispensingFees
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.Sp_Retail30Brands_DispensingFees}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                            <td style={Fontstyling.label}>Retail 90 Brands</td>
                            <td>
                              <InputGroup>
                                <InputGroup.Text className="py-0 fw-bold">
                                  $
                                </InputGroup.Text>
                                <Form.Control
                                  name="Sp_Retail90Brands_Rebates"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={values.Sp_Retail90Brands_Rebates}
                                  onChange={(e) => {                                    
                                    handleChange(e);
                                    if (values.splrebateProposal) {
                                      const parsedProposal = JSON.parse(values.splrebateProposal);
                                     
                                      if (parsedProposal.value === "per Brand claim") {
                                        setFieldValue('SpecialtyRetail90NonPreferredTier3BrandClaims', e.target.value);
                                      }
                                    }                                                                     
                                  }}
                                  onBlur={handleBlur}
                                  type="text"
                                  maxLength={10}
                                  isInvalid={!!errors.Sp_Retail90Brands_Rebates}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.Sp_Retail90Brands_Rebates}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                          </tr>
                          <tr className="border-0">
                            <td style={Fontstyling.label} className="border">
                              Retail 30 Generics
                            </td>
                            <td className="border">
                              <InputGroup>
                                <Form.Control
                                  name="Sp_Retail30Generics_AWPDiscounts"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={
                                    values.Sp_Retail30Generics_AWPDiscounts
                                  }
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={
                                    !!errors.Sp_Retail30Generics_AWPDiscounts
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.Sp_Retail30Generics_AWPDiscounts}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                            <td style={Fontstyling.label} className="border">
                              Retail 30 Generics
                            </td>
                            <td className="border">
                              <InputGroup>
                                <InputGroup.Text className="py-0 fw-bold">
                                  $
                                </InputGroup.Text>
                                <Form.Control
                                  name="Sp_Retail30Generics_DispensingFees"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={
                                    values.Sp_Retail30Generics_DispensingFees
                                  }
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={
                                    !!errors.Sp_Retail30Generics_DispensingFees
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.Sp_Retail30Generics_DispensingFees}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                            <td style={Fontstyling.label} className="border">
                              Specialty Pharmacy Brands
                            </td>
                            <td className="border">
                              <InputGroup>
                                <InputGroup.Text className="py-0 fw-bold">
                                  $
                                </InputGroup.Text>
                                <Form.Control
                                  name="Sp_SpecialtyPharmacyBrands_Rebates"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={
                                    values.Sp_SpecialtyPharmacyBrands_Rebates
                                  }
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  type="text"
                                  maxLength={10}
                                  isInvalid={
                                    !!errors.Sp_SpecialtyPharmacyBrands_Rebates
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.Sp_SpecialtyPharmacyBrands_Rebates}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                          </tr>
                          <tr className="border-0">
                            <td style={Fontstyling.label} className="border">
                              Retail 90 Brands
                            </td>
                            <td className="border">
                              <InputGroup>
                                <Form.Control
                                  name="Sp_Retail90Brands_AWPDiscounts"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={values.Sp_Retail90Brands_AWPDiscounts}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={
                                    !!errors.Sp_Retail90Brands_AWPDiscounts
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.Sp_Retail90Brands_AWPDiscounts}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                            <td style={Fontstyling.label} className="border">
                              Retail 90 Brands
                            </td>
                            <td className="border">
                              <InputGroup>
                                <InputGroup.Text className="py-0 fw-bold">
                                  $
                                </InputGroup.Text>
                                <Form.Control
                                  name="Sp_Retail90Brands_DispensingFees"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={
                                    values.Sp_Retail90Brands_DispensingFees
                                  }
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  type="text"
                                  maxLength={10}
                                  isInvalid={
                                    !!errors.Sp_Retail90Brands_DispensingFees
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.Sp_Retail90Brands_DispensingFees}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                          </tr>
                          <tr className="border-0">
                            <td style={Fontstyling.label} className="border">
                              Retail 90 Generics
                            </td>
                            <td className="border">
                              <InputGroup>
                                <Form.Control
                                  name="Sp_Retail90Generics_AWPDiscounts"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={
                                    values.Sp_Retail90Generics_AWPDiscounts
                                  }
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={
                                    !!errors.Sp_Retail90Generics_AWPDiscounts
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.Sp_Retail90Generics_AWPDiscounts}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                            <td style={Fontstyling.label} className="border">
                              Retail 90 Generics
                            </td>
                            <td className="border">
                              <InputGroup>
                                <InputGroup.Text className="py-0 fw-bold">
                                  $
                                </InputGroup.Text>
                                <Form.Control
                                  name="Sp_Retail90Generics_DispensingFees"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={
                                    values.Sp_Retail90Generics_DispensingFees
                                  }
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  type="text"
                                  maxLength={10}
                                  isInvalid={
                                    !!errors.Sp_Retail90Generics_DispensingFees
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.Sp_Retail90Generics_DispensingFees}
                                </Form.Control.Feedback>
                              </InputGroup>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <label className="mt-4 fw-bold" style={Fontstyling.label}>
                      Specialty AWP-% and Dispensing Fee Price Guarantees and
                      Exclusions (All Day Supply)
                    </label>
                    <Row className="gap-3">
                      <Col>
                        <Form.Group className="text-start">
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            Select all claim types that are excluded from your
                            guarantees:
                            <Required />
                          </Form.Label>
                          <Select
                            name="spltdiscountDispensingFeeGuarantees"
                            isMulti
                            value={
                              values.spltdiscountDispensingFeeGuarantees
                                ? values.spltdiscountDispensingFeeGuarantees
                                    ?.split(",")
                                    .map((item) => ({
                                      value: item,
                                      label: item,
                                    }))
                                : values.spltdiscountDispensingFeeGuarantees
                            }
                            className="py-0 rounded-0"
                            options={DiscountDispensingFeeGuaranteesOption}
                            onChange={(selectedOption) => {
                              let option = selectedOption
                                .map((item) => item.value)
                                .join(",");
                              setFieldValue(
                                "spltdiscountDispensingFeeGuarantees",
                                option
                              );
                              if (
                                selectedOption.some(
                                  (item) => item.value === "Other - list all exclusions in the text box provided"
                                )
                              ) {
                                setFieldValue("spltdiscountDispensingFeeGuaranteesComment", "");
                              }
                            }}
                            styles={{
                              control: (base, { isDisabled }) => ({
                                ...Fontstyling.primaryparagraph,
                                display: "flex",
                                alignItems: "center",
                                border:
                                  errors.spltdiscountDispensingFeeGuarantees &&
                                  touched.spltdiscountDispensingFeeGuarantees
                                    ? "1px solid red"
                                    : "1px solid #ced4da",
                                width: "auto",
                                // maxHeight: "30px",
                                height: "auto",
                                textAlign: "left",
                                backgroundColor: isDisabled ? "#e9ecef" : "",
                              }),
                              option: (
                                styles,
                                { data, isDisabled, isFocused, isSelected }
                              ) => {
                                return {
                                  ...styles,
                                  ...Fontstyling.primaryparagraph,
                                  textAlign: "left",
                                };
                              },
                              menu: (styles) => {
                                return {
                                  ...styles,
                                  zIndex: "5",
                                };
                              },
                            }}
                          />
                          {errors.spltdiscountDispensingFeeGuarantees &&
                            touched.spltdiscountDispensingFeeGuarantees && (
                              <div
                                className="fw-regular mt-2"
                                style={Fontstyling.errorlabel}
                              >
                                {errors.spltdiscountDispensingFeeGuarantees}
                              </div>
                            )}
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-start">
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            State
                            <Required />
                          </Form.Label>
                          <img
                            data-tip="Select from the list provided any Most Favored Nations States excluded from guarantees.  If Most Favored Nations are not an exclusion to guarantees, please select N/A."
                            src={require("../../../assets/icon/Question_mark_back.png")}
                            style={{ height: 15, marginLeft: 3 }}
                          />
                          <ReactTooltip
                            className="border-2 border-info p-3"
                            border
                            backgroundColor="white"
                            textColor="black"
                          />
                          <Select
                            name="splState"
                            isMulti
                            value={
                              values.splState
                                ? values.splState?.split(",").map((item) => ({
                                    value: item,
                                    label: item,
                                  }))
                                : values.splState
                            }
                            className="py-0 rounded-0"
                            options={stateList}
                            onChange={(selectedOption) => {
                              let option = selectedOption
                                .map((item) => item.value)
                                .join(",");
                              setFieldValue("splState", option);
                            }}
                            styles={{
                              control: (base, { isDisabled }) => ({
                                ...Fontstyling.primaryparagraph,
                                display: "flex",
                                alignItems: "center",
                                border:
                                  errors.splState && touched.splState
                                    ? "1px solid red"
                                    : "1px solid #ced4da",
                                width: "auto",
                                // maxHeight: "30px",
                                height: "auto",
                                textAlign: "left",
                                backgroundColor: isDisabled ? "#e9ecef" : "",
                              }),
                              option: (
                                styles,
                                { data, isDisabled, isFocused, isSelected }
                              ) => {
                                return {
                                  ...styles,
                                  ...Fontstyling.primaryparagraph,
                                  textAlign: "left",
                                };
                              },
                              menu: (styles) => {
                                return {
                                  ...styles,
                                  zIndex: "5",
                                };
                              },
                            }}
                          />
                          {errors.splState && touched.splState && (
                            <div
                              className="fw-regular mt-2"
                              style={Fontstyling.errorlabel}
                            >
                              {errors.splState}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="col-6 mt-2 ">
                      <Col>
                        <Form.Group>
                          <Form.Control
                            as="textarea"
                            className="rounded-0"
                            name="spltdiscountDispensingFeeGuaranteesComment"
                            hidden={
                              !(
                                values.spltdiscountDispensingFeeGuarantees &&
                                values.spltdiscountDispensingFeeGuarantees.includes(
                                  "Other - list all exclusions in the text box provided"
                                )
                              )
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              errors.spltdiscountDispensingFeeGuaranteesComment &&
                              touched.spltdiscountDispensingFeeGuaranteesComment
                            }
                            placeholder={"Claim types that are excluded"}
                            style={Fontstyling.label}
                            value={
                              values.spltdiscountDispensingFeeGuaranteesComment
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.spltdiscountDispensingFeeGuaranteesComment}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <label className="mt-4 fw-bold" style={Fontstyling.label}>
                      Rebate Guarantees and Exclusions
                    </label>
                    <Row className="gap-3">
                      <Col>
                        <Form.Group className="text-start">
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            Select all claim types that are excluded from your
                            guarantees:
                            <Required />
                          </Form.Label>
                          <Select
                            name="spltRebatediscountDispensingFeeGuarantees"
                            isMulti
                            value={
                              values.spltRebatediscountDispensingFeeGuarantees
                                ? values.spltRebatediscountDispensingFeeGuarantees
                                    ?.split(",")
                                    .map((item) => ({
                                      value: item,
                                      label: item,
                                    }))
                                : values.spltRebatediscountDispensingFeeGuarantees
                            }
                            className="py-0 rounded-0"
                            options={DiscountDispensingFeeGuaranteesOption}
                            onChange={(selectedOption) => {
                              let option = selectedOption
                                .map((item) => item.value)
                                .join(",");
                              setFieldValue(
                                "spltRebatediscountDispensingFeeGuarantees",
                                option
                              );
                              if (
                                selectedOption.some(
                                  (item) => item.value === "Other - list all exclusions in the text box provided"
                                )
                              ) {
                                setFieldValue("spltRebatediscountDispensingFeeGuaranteesComment", "");
                              }
                            }}
                            styles={{
                              control: (base, { isDisabled }) => ({
                                ...Fontstyling.primaryparagraph,
                                display: "flex",
                                alignItems: "center",
                                border:
                                  errors.spltRebatediscountDispensingFeeGuarantees &&
                                  touched.spltRebatediscountDispensingFeeGuarantees
                                    ? "1px solid red"
                                    : "1px solid #ced4da",
                                width: "auto",
                                // maxHeight: "30px",
                                height: "auto",
                                textAlign: "left",
                                backgroundColor: isDisabled ? "#e9ecef" : "",
                              }),
                              option: (
                                styles,
                                { data, isDisabled, isFocused, isSelected }
                              ) => {
                                return {
                                  ...styles,
                                  ...Fontstyling.primaryparagraph,
                                  textAlign: "left",
                                };
                              },
                              menu: (styles) => {
                                return {
                                  ...styles,
                                  zIndex: "5",
                                };
                              },
                            }}
                          />
                          {errors.spltRebatediscountDispensingFeeGuarantees &&
                            touched.spltRebatediscountDispensingFeeGuarantees && (
                              <div
                                className="fw-regular mt-2"
                                style={Fontstyling.errorlabel}
                              >
                                {
                                  errors.spltRebatediscountDispensingFeeGuarantees
                                }
                              </div>
                            )}
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-start">
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            State
                            <Required />
                          </Form.Label>
                          <img
                            data-tip="Select from the list provided any Most Favored Nations States excluded from guarantees.  If Most Favored Nations are not an exclusion to guarantees, please select N/A."
                            src={require("../../../assets/icon/Question_mark_back.png")}
                            style={{ height: 15, marginLeft: 3 }}
                          />
                          <ReactTooltip
                            className="border-2 border-info p-3"
                            border
                            backgroundColor="white"
                            textColor="black"
                          />
                          <Select
                            name="splRebateState"
                            isMulti
                            value={
                              values.splRebateState
                                ? values.splRebateState
                                    ?.split(",")
                                    .map((item) => ({
                                      value: item,
                                      label: item,
                                    }))
                                : values.splRebateState
                            }
                            className="py-0 rounded-0"
                            options={stateList}
                            onChange={(selectedOption) => {
                              let option = selectedOption
                                .map((item) => item.value)
                                .join(",");
                              setFieldValue("splRebateState", option);
                            }}
                            styles={{
                              control: (base, { isDisabled }) => ({
                                ...Fontstyling.primaryparagraph,
                                display: "flex",
                                alignItems: "center",
                                border:
                                  errors.splRebateState &&
                                  touched.splRebateState
                                    ? "1px solid red"
                                    : "1px solid #ced4da",
                                width: "auto",
                                // maxHeight: "30px",
                                height: "auto",
                                textAlign: "left",
                                backgroundColor: isDisabled ? "#e9ecef" : "",
                              }),
                              option: (
                                styles,
                                { data, isDisabled, isFocused, isSelected }
                              ) => {
                                return {
                                  ...styles,
                                  ...Fontstyling.primaryparagraph,
                                  textAlign: "left",
                                };
                              },
                              menu: (styles) => {
                                return {
                                  ...styles,
                                  zIndex: "5",
                                };
                              },
                            }}
                          />
                          {errors.splRebateState && touched.splRebateState && (
                            <div
                              className="fw-normal mt-2"
                              style={Fontstyling.errorlabel}
                            >
                              {errors.splRebateState}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="col-6 mt-2 ">
                      <Col>
                        <Form.Group>
                          <Form.Control
                            as="textarea"
                            className="rounded-0"
                            name="spltRebatediscountDispensingFeeGuaranteesComment"
                            hidden={
                              !(
                                values.spltRebatediscountDispensingFeeGuarantees &&
                                values.spltRebatediscountDispensingFeeGuarantees.includes(
                                  "Other - list all exclusions in the text box provided"
                                )
                              )
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              errors.spltRebatediscountDispensingFeeGuaranteesComment &&
                              touched.spltRebatediscountDispensingFeeGuaranteesComment
                            }
                            placeholder={"Claim types that are excluded"}
                            style={Fontstyling.label}
                            value={
                              values.spltRebatediscountDispensingFeeGuaranteesComment
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {
                              errors.spltRebatediscountDispensingFeeGuaranteesComment
                            }
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="gap-3 mt-2">
                      <Col>
                        <Form.Group className="text-start">
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            Confirm the claim type basis for your rebate
                            proposal
                            <Required />
                          </Form.Label>
                          <Form.Select
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            name="splrebateProposal"                           
                            onChange={(e) => {
                              handleChange(e);
                              let { value } = e.target;
                              if (value) {
                                const parsedValue = JSON.parse(value);
                                if (parsedValue?.value === "per formulary (preferred) brand claim") {
                                  setFieldValue('SpecialtyNonPreferredTier3BrandClaims', "");
                                  setFieldValue('SpecialtyRetail90NonPreferredTier3BrandClaims', "");
                                  setFieldValue('SpecialtyMailNonPreferredorTier3BrandClaims', "");
                                  setFieldValue('SpecialtyPBMNonPreferredorTier3BrandPharmacyClaims', "");
                                }
                                if (parsedValue?.value === "per Brand claim") {
                                  setFieldValue('SpecialtyMailNonPreferredorTier3BrandClaims', values.Sp_MailBrands_Rebates);
                                  setFieldValue('SpecialtyNonPreferredTier3BrandClaims', values.Sp_Retail30Brands_Rebates);
                                  setFieldValue('SpecialtyRetail90NonPreferredTier3BrandClaims', values.Sp_Retail90Brands_Rebates);
                               
                                }
                              }
                            }}
                            onBlur={handleBlur}
                            isInvalid={
                              values.splrebateProposal === "" &&
                              errors.splrebateProposal &&
                              touched.splrebateProposal
                            }
                            value={values.splrebateProposal}
                          >
                            <option value={""}>Select rebate proposal</option>
                            {[
                              {
                                lable: "per Brand claim",
                                value: "per Brand claim",
                              },
                              {
                                lable: "per formulary (preferred) brand claim",
                                value: "per formulary (preferred) brand claim",
                              },
                            ]?.map((item, index) => (
                              <option value={JSON.stringify(item)}>
                                {item.lable}
                              </option>
                            ))}
                          </Form.Select>
                          {errors.splrebateProposal &&
                            touched.splrebateProposal && (
                              <Form.Label style={Fontstyling.errorlabel}>
                                {errors.splrebateProposal}
                              </Form.Label>
                            )}
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-start">
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            Confirm your rebate structure
                            <Required />
                          </Form.Label>
                          <Form.Select
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            name="splrebateStructure"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              values.splrebateStructure === "" &&
                              errors.splrebateStructure &&
                              touched.splrebateStructure
                            }
                            value={values.splrebateStructure}
                          >
                            <option value={""}>Select rebate structure</option>
                            {[
                              {
                                lable: "Fixed Rate",
                                value: "Fixed Rate",
                              },
                              {
                                lable: "Minimum Guarantee with Annual True-up",
                                value: "Minimum Guarantee with Annual True-up",
                              },
                            ]?.map((item, index) => (
                              <option value={JSON.stringify(item)}>
                                {item.lable}
                              </option>
                            ))}
                          </Form.Select>
                          {errors.splrebateStructure &&
                            touched.splrebateStructure && (
                              <Form.Label style={Fontstyling.errorlabel}>
                                {errors.splrebateStructure}
                              </Form.Label>
                            )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Form.Group className="text-start">
                      <Row className="mt-4 gap-3">
                        <Col>
                          <Form.Label style={Fontstyling.label}>
                            Please specify all products excluded from rebates
                            due to low Wholesale Acquisition Cost (WAC) strategy
                            <Required />
                          </Form.Label>
                        </Col>
                        <Col>
                          <Form.Control
                            as="textarea"
                            className="rounded-0"
                            name="splWholesaleAcquisitionCostStrategy"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              errors.splWholesaleAcquisitionCostStrategy &&
                              touched.splWholesaleAcquisitionCostStrategy
                            }
                            placeholder={"Comment here"}
                            style={Fontstyling.label}
                            value={values.splWholesaleAcquisitionCostStrategy}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.splWholesaleAcquisitionCostStrategy}
                          </Form.Control.Feedback>
                        </Col>
                      </Row>
                    </Form.Group>
                    <Row className="gap-3 mt-2">
                      <Col>
                        <Form.Group className="text-nowrap">
                          <Form.Label
                            style={Fontstyling.label}
                            className="text-start"
                          >
                            Limited Distribution Drug claims
                          </Form.Label>
                          <Form.Control
                            name="LimitedDistributionDrugClaims"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.LimitedDistributionDrugClaims}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            type="text"
                            placeholder="Limited Distribution Drug claims"
                            maxLength={10}
                            isInvalid={errors.LimitedDistributionDrugClaims}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.LimitedDistributionDrugClaims}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-nowrap">
                          <Form.Label
                            style={Fontstyling.label}
                            className="text-start"
                          >
                            Biosimilar claims
                          </Form.Label>
                          <Form.Control
                            name="BiosimilarClaims"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.BiosimilarClaims}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            type="text"
                            placeholder="Biosimilar claims"
                            maxLength={10}
                            isInvalid={errors.BiosimilarClaims}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.BiosimilarClaims}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-nowrap">
                          <Form.Label
                            style={Fontstyling.label}
                            className="text-start"
                          >
                            HIV claims
                          </Form.Label>
                          <Form.Control
                            name="HIVClaims"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.HIVClaims}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            type="text"
                            placeholder="HIV claims"
                            maxLength={10}
                            isInvalid={errors.HIVClaims}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.HIVClaims}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="gap-3 mt-2">
                      <Col>
                        <Form.Group className="text-nowrap">
                          <Form.Label
                            style={Fontstyling.label}
                            className="text-start"
                          >
                            Specialty Retail Non-preferred or Tier 3 brand claims
                          </Form.Label>
                          <Form.Control
                            name="SpecialtyNonPreferredTier3BrandClaims"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.SpecialtyNonPreferredTier3BrandClaims}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            type="text"
                            placeholder="Specialty Retail Non-preferred or Tier 3 brand claims"
                            maxLength={10}
                            isInvalid={
                              errors.SpecialtyNonPreferredTier3BrandClaims
                            }
                            disabled={values?.splrebateProposal && JSON.parse(values?.splrebateProposal)?.value === "per formulary (preferred) brand claim"}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.SpecialtyNonPreferredTier3BrandClaims}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-nowrap">
                          <Form.Label
                            style={Fontstyling.label}
                            className="text-start"
                          >
                            Specialty Retail 90 Non-Preferred Tier 3 Brand claims
                          </Form.Label>
                          <Form.Control
                            name="SpecialtyRetail90NonPreferredTier3BrandClaims"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={
                              values.SpecialtyRetail90NonPreferredTier3BrandClaims
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            type="text"
                            placeholder="Specialty Retail 90 Non-Preferred Tier 3 Brand claims"
                            maxLength={10}
                            isInvalid={
                              errors.SpecialtyRetail90NonPreferredTier3BrandClaims
                            }
                            disabled={values?.splrebateProposal && JSON.parse(values?.splrebateProposal)?.value === "per formulary (preferred) brand claim"}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.SpecialtyRetail90NonPreferredTier3BrandClaims}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-nowrap">
                          <Form.Label
                            style={Fontstyling.label}
                            className="text-start"
                          >
                            Specialty Mail Non-Preferred or Tier 3 Brand Claims
                          </Form.Label>
                          <Form.Control
                            name="SpecialtyMailNonPreferredorTier3BrandClaims"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={
                              values.SpecialtyMailNonPreferredorTier3BrandClaims
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            type="text"
                            placeholder="Specialty Mail Non-Preferred or Tier 3 Brand Claims"
                            maxLength={10}
                            isInvalid={
                              errors.SpecialtyMailNonPreferredorTier3BrandClaims
                            }
                            disabled={values?.splrebateProposal && JSON.parse(values?.splrebateProposal)?.value === "per formulary (preferred) brand claim"}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.SpecialtyMailNonPreferredorTier3BrandClaims}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="col-4">
                        <Form.Group className="text-nowrap">
                          <Form.Label
                            style={Fontstyling.label}
                            className="text-start"
                          >
                            Specialty PBM Non-Preferred or Tier 3 Brand Pharmacy Claims
                            
                          </Form.Label>
                          <Form.Control
                            name="SpecialtyPBMNonPreferredorTier3BrandPharmacyClaims"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={
                              values.SpecialtyPBMNonPreferredorTier3BrandPharmacyClaims
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            type="text"
                            placeholder="Specialty PBM Non-Preferred or Tier 3 Brand Pharmacy Claims"
                            maxLength={10}
                            isInvalid={
                              errors.SpecialtyPBMNonPreferredorTier3BrandPharmacyClaims
                            }
                            disabled={values?.splrebateProposal && JSON.parse(values?.splrebateProposal)?.value === "per formulary (preferred) brand claim"}
                          />
                          <Form.Control.Feedback type="invalid">
                            {
                              errors.SpecialtyPBMNonPreferredorTier3BrandPharmacyClaims
                            }
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                  <div>
                    <label className="mt-4 fw-bold" style={Fontstyling.label}>
                      PBM Fees and Credits
                    </label>

                    <Row>
                      <Col className="col-4"></Col>
                      <Col className="col-3 text-center">
                        <Form.Label
                          style={Fontstyling.label}
                          className="fw-bold"
                        >
                          Basis
                          <Required />
                        </Form.Label>
                      </Col>
                      <Col className="col-3 text-center">
                        <Form.Label
                          style={Fontstyling.label}
                          className="fw-bold"
                        >
                          Fee ($)
                          <Required />
                        </Form.Label>
                      </Col>
                    </Row>
                    <Form.Group>
                      <Row className="mb-2 gap-3">
                        <Col>
                          <Form.Label
                            style={Fontstyling.label}
                            className="text-start"
                          >
                            PBM administration fees
                            <Required />
                          </Form.Label>
                        </Col>
                        <Col>
                          <Form.Select
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            name="PBMadministrationfeesBasis"
                            onChange={(e) => {
                              handleChange(e);
                              if (
                                e.target.value !== "" &&
                                JSON.parse(e.target.value).value === "No Fee"
                              ) {
                                setFieldValue(
                                  "PBMadministrationfeesResponseFormat",
                                  0
                                );
                              } else {
                                setFieldValue(
                                  "PBMadministrationfeesResponseFormat",
                                  ""
                                );
                              }
                            }}
                            onBlur={handleBlur}
                            isInvalid={
                              values.PBMadministrationfeesBasis === "" &&
                              errors.PBMadministrationfeesBasis &&
                              touched.PBMadministrationfeesBasis
                            }
                            value={values.PBMadministrationfeesBasis}
                          >
                            <option value={""}> -- Select --</option>
                            {[
                              {
                                lable: "per Rx",
                                value: "per Rx",
                              },
                              {
                                lable: "PEPM",
                                value: "PEPM",
                              },
                              {
                                lable: "PMPM",
                                value: "PMPM",
                              },
                              {
                                lable: "No Fee",
                                value: "No Fee",
                              },
                            ]?.map((item, index) => (
                              <option value={JSON.stringify(item)}>
                                {item.lable}
                              </option>
                            ))}
                          </Form.Select>
                          {errors.PBMadministrationfeesBasis &&
                            touched.PBMadministrationfeesBasis && (
                              <Form.Label style={Fontstyling.errorlabel}>
                                {errors.PBMadministrationfeesBasis}
                              </Form.Label>
                            )}
                        </Col>
                        <Col>
                          <Form.Control
                            name="PBMadministrationfeesResponseFormat"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.PBMadministrationfeesResponseFormat}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            type="text"
                            disabled={
                              !(
                                values.PBMadministrationfeesBasis === "" ||
                                values.PBMadministrationfeesBasis === undefined
                              )
                                ? JSON.parse(values.PBMadministrationfeesBasis)
                                    .value === "No Fee"
                                : false
                            }
                            placeholder="Number"
                            maxLength={10}
                            isInvalid={
                              errors.PBMadministrationfeesResponseFormat
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.PBMadministrationfeesResponseFormat}
                          </Form.Control.Feedback>
                        </Col>
                      </Row>
                    </Form.Group>
                    <Form.Group>
                      <Row className="mb-2 gap-3">
                        <Col>
                          <Form.Label
                            style={Fontstyling.label}
                            className="text-start"
                          >
                            PBM total paid rebates
                            <Required />
                          </Form.Label>
                        </Col>
                        <Col></Col>
                        <Col>
                          <Form.Control
                            name="PBMtotalpaidrebatesResponseFormat"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.PBMtotalpaidrebatesResponseFormat}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            type="text"
                            placeholder="Number"
                            maxLength={10}
                            isInvalid={errors.PBMtotalpaidrebatesResponseFormat && touched.PBMtotalpaidrebatesResponseFormat}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.PBMtotalpaidrebatesResponseFormat}
                          </Form.Control.Feedback>
                        </Col>
                      </Row>
                      <Row className="mb-2 gap-3">
                        <Col>
                          <Form.Label
                            style={Fontstyling.label}
                            className="text-start"
                          >
                            PBM transaction fees
                            <Required />
                          </Form.Label>
                        </Col>
                        <Col>
                          <Form.Select
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            name="PBMtransactionfeesBasis"
                            onChange={(e) => {
                              handleChange(e);
                              if (
                                e.target.value !== "" &&
                                (JSON.parse(e.target.value).value ===
                                  "No Fee" ||
                                  JSON.parse(e.target.value).value ===
                                    "Not Applicable")
                              ) {
                                setFieldValue(
                                  "PBMtransactionfeesResponseFormat",
                                  0
                                );
                              } else {
                                setFieldValue(
                                  "PBMtransactionfeesResponseFormat",
                                  ""
                                );
                              }
                            }}
                            onBlur={handleBlur}
                            isInvalid={
                              values.PBMtransactionfeesBasis === "" &&
                              errors.PBMtransactionfeesBasis &&
                              touched.PBMtransactionfeesBasis
                            }
                            value={values.PBMtransactionfeesBasis}
                          >
                            <option value={""}> -- Select --</option>
                            {[
                              {
                                lable: "per Rx",
                                value: "per Rx",
                              },
                              {
                                lable: "PEPM",
                                value: "PEPM",
                              },
                              {
                                lable: "PMPM",
                                value: "PMPM",
                              },
                              {
                                lable: "No Fee",
                                value: "No Fee",
                              },
                              {
                                lable: "Not Applicable",
                                value: "Not Applicable",
                              },
                            ]?.map((item, index) => (
                              <option value={JSON.stringify(item)}>
                                {item.lable}
                              </option>
                            ))}
                          </Form.Select>
                          {errors.PBMtransactionfeesBasis &&
                            touched.PBMtransactionfeesBasis && (
                              <Form.Label style={Fontstyling.errorlabel}>
                                {errors.PBMtransactionfeesBasis}
                              </Form.Label>
                            )}
                        </Col>
                        <Col>
                          <Form.Control
                            name="PBMtransactionfeesResponseFormat"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.PBMtransactionfeesResponseFormat}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            disabled={
                              !(
                                values.PBMtransactionfeesBasis === "" ||
                                values.PBMtransactionfeesBasis === undefined
                              )
                                ? JSON.parse(values.PBMtransactionfeesBasis)
                                    .value === "No Fee" ||
                                  JSON.parse(values.PBMtransactionfeesBasis)
                                    .value === "Not Applicable"
                                : false
                            }
                            type="text"
                            placeholder="Number"
                            maxLength={10}
                            isInvalid={errors.PBMtransactionfeesResponseFormat}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.PBMtransactionfeesResponseFormat}
                          </Form.Control.Feedback>
                        </Col>
                      </Row>
                    </Form.Group>
                    <Form.Group>
                      <Row className="mb-2 gap-3">
                        <Col>
                          <Form.Label
                            style={Fontstyling.label}
                            className="text-start"
                          >
                            Coalition or Aggregator membership fees
                            <Required />
                          </Form.Label>
                        </Col>
                        <Col>
                          <Form.Select
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            name="CoalitionorAggregatorfeesBasis"
                            onChange={(e) => {
                              handleChange(e);
                              if (
                                e.target.value !== "" &&
                                JSON.parse(e.target.value).value === "No Fee"
                              ) {
                                setFieldValue(
                                  "CoalitionorAggregatorfeesResponseFormat",
                                  0
                                );
                              } else {
                                setFieldValue(
                                  "CoalitionorAggregatorfeesResponseFormat",
                                  ""
                                );
                              }
                            }}
                            onBlur={handleBlur}
                            isInvalid={
                              values.CoalitionorAggregatorfeesBasis === "" &&
                              errors.CoalitionorAggregatorfeesBasis &&
                              touched.CoalitionorAggregatorfeesBasis
                            }
                            value={values.CoalitionorAggregatorfeesBasis}
                          >
                            <option value={""}> -- Select --</option>
                            {[
                              {
                                lable: "per Rx",
                                value: "per Rx",
                              },
                              {
                                lable: "PEPM",
                                value: "PEPM",
                              },
                              {
                                lable: "PMPM",
                                value: "PMPM",
                              },
                              {
                                lable: "Flat Fee",
                                value: "Flat Fee",
                              },
                              {
                                lable: "No Fee",
                                value: "No Fee",
                              },
                            ]?.map((item, index) => (
                              <option value={JSON.stringify(item)}>
                                {item.lable}
                              </option>
                            ))}
                          </Form.Select>
                          {errors.CoalitionorAggregatorfeesBasis &&
                            touched.CoalitionorAggregatorfeesBasis && (
                              <Form.Label style={Fontstyling.errorlabel}>
                                {errors.CoalitionorAggregatorfeesBasis}
                              </Form.Label>
                            )}
                        </Col>
                        <Col>
                          <Form.Control
                            name="CoalitionorAggregatorfeesResponseFormat"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={
                              values.CoalitionorAggregatorfeesResponseFormat
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            disabled={
                              !(
                                values.CoalitionorAggregatorfeesBasis === "" ||
                                values.CoalitionorAggregatorfeesBasis ===
                                  undefined
                              )
                                ? JSON.parse(
                                    values.CoalitionorAggregatorfeesBasis
                                  ).value === "No Fee"
                                : false
                            }
                            type="text"
                            placeholder="Number"
                            maxLength={10}
                            isInvalid={
                              errors.CoalitionorAggregatorfeesResponseFormat
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.CoalitionorAggregatorfeesResponseFormat}
                          </Form.Control.Feedback>
                        </Col>
                      </Row>
                    </Form.Group>
                    <Form.Group>
                      <Row className="mb-2 gap-3">
                        <Col>
                          <Form.Label
                            style={Fontstyling.label}
                            className="text-start"
                          >
                            Please list and specify all other fees related to
                            your program bid including % of Savings, PEPM, etc.
                            fees.
                          </Form.Label>
                        </Col>
                        <Col>
                          <Form.Control
                            as="textarea"
                            className="rounded-0"
                            name="listandspecifyallotherfees"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              errors.listandspecifyallotherfees &&
                              touched.listandspecifyallotherfees
                            }
                            placeholder="Please list and specify all other fees related to your program bid including % of Savings, PEPM, etc. fees."
                            style={Fontstyling.label}
                            value={values.listandspecifyallotherfees}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.listandspecifyallotherfees}
                          </Form.Control.Feedback>
                        </Col>
                      </Row>
                    </Form.Group>
                    <Form.Group>
                      <Row className="mb-2 gap-3">
                        <Col>
                          <Form.Label
                            style={Fontstyling.label}
                            className="text-start"
                          >
                            Onsite Pharmacy PBM Administration Fee
                          </Form.Label>
                        </Col>
                        <Col>
                          <Form.Select
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            name="onsitePharmacyPBMAdministrationFeeBasis"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              values.onsitePharmacyPBMAdministrationFeeBasis ===
                                "" &&
                              errors.onsitePharmacyPBMAdministrationFeeBasis &&
                              touched.onsitePharmacyPBMAdministrationFeeBasis
                            }
                            value={
                              values.onsitePharmacyPBMAdministrationFeeBasis
                            }
                          >
                            <option value={""}> -- Select --</option>
                            {[
                              {
                                lable: "Per Rx",
                                value: "Per Rx",
                              },
                              {
                                lable: "Per Onsite RX",
                                value: "Per Onsite RX",
                              },
                              {
                                lable: "PEPM",
                                value: "PEPM",
                              },
                              {
                                lable: "PMPM",
                                value: "PMPM",
                              },
                            ]?.map((item, index) => (
                              <option value={JSON.stringify(item)}>
                                {item.lable}
                              </option>
                            ))}
                          </Form.Select>
                        </Col>
                        <Col>
                          <Form.Control
                            name="onsitePharmacyPBMAdministrationFeeResponseFormat"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={
                              values.onsitePharmacyPBMAdministrationFeeResponseFormat
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            type="text"
                            placeholder="Number"
                            maxLength={10}
                            isInvalid={
                              errors.onsitePharmacyPBMAdministrationFeeResponseFormat
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {
                              errors.onsitePharmacyPBMAdministrationFeeResponseFormat
                            }
                          </Form.Control.Feedback>
                        </Col>
                      </Row>
                    </Form.Group>
                    <Form.Group>
                      <Row className="mb-2 gap-3">
                        <Col>
                          <Form.Label
                            style={Fontstyling.label}
                            className="text-start"
                          >
                            Onsite Pharmacy Aggregator Administration Fee
                          </Form.Label>
                        </Col>
                        <Col>
                          <Form.Select
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            name="onsitePharmacyAggregatorAdministrationFeeBasis"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              values.onsitePharmacyAggregatorAdministrationFeeBasis ===
                                "" &&
                              errors.onsitePharmacyAggregatorAdministrationFeeBasis &&
                              touched.onsitePharmacyAggregatorAdministrationFeeBasis
                            }
                            value={
                              values.onsitePharmacyAggregatorAdministrationFeeBasis
                            }
                          >
                            <option value={""}> -- Select --</option>
                            {[
                              {
                                lable: "Per Rx",
                                value: "Per Rx",
                              },
                              {
                                lable: "Per Onsite RX",
                                value: "Per Onsite RX",
                              },
                              {
                                lable: "PEPM",
                                value: "PEPM",
                              },
                              {
                                lable: "PMPM",
                                value: "PMPM",
                              },
                            ]?.map((item, index) => (
                              <option value={JSON.stringify(item)}>
                                {item.lable}
                              </option>
                            ))}
                          </Form.Select>
                        </Col>
                        <Col>
                          <Form.Control
                            name="onsitePharmacyAggregatorAdministrationFeeResponseFormat"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={
                              values.onsitePharmacyAggregatorAdministrationFeeResponseFormat
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            type="text"
                            placeholder="Number"
                            maxLength={10}
                            isInvalid={
                              errors.onsitePharmacyAggregatorAdministrationFeeResponseFormat
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {
                              errors.onsitePharmacyAggregatorAdministrationFeeResponseFormat
                            }
                          </Form.Control.Feedback>
                        </Col>
                      </Row>
                    </Form.Group>
                  </div>
                  <div className="mt-5">
                    <Row className="mb-2 gap-3 w-50">
                      <Col>
                        <Form.Group>
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            PBM Contract
                          </Form.Label>
                          <Form.Control
                            type="file"
                            accept=".csv, .docx, .doc, .xlxs, .xls, .txt, .pdf, .rtx, .zip, .rar"
                            className="py-1 rounded-0"
                            style={{
                              ...Fontstyling.label,
                            }}
                            name="PBMContractFile"
                            onChange={(event) => {
                              setPBMFile(event.target.files[0]);
                              const file = event.currentTarget.files[0];
                              setFieldValue("PBMContractFile", file);
                            }}
                            onBlur={handleBlur}
                            isInvalid={
                              errors.PBMContractFile && touched.PBMContractFile
                            }
                          ></Form.Control>
                          {!PBMfile &&
                            values.PBMContractFile !== undefined &&
                            values.PBMContractFile !== "" &&
                            values.PBMContractFile !== null && (
                              <div
                                className="text-primary mt-2 cursor-pointer"
                                style={{
                                  fontSize: "12px",
                                  fontFamily: "Arial",
                                }}
                                onClick={() =>
                                  FileDownloadForClientRxFile(
                                    values.PBMContractFile, DrugfileType.PBMContract
                                  )
                                }
                              >
                                {values.PBMContractFile.name ? values.PBMContractFile.name : values.PBMContractFile?.split("/").pop()}
                              </div>
                            )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-2 gap-3 w-50">
                      <Col>
                        <Form.Group>
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            Hospital and Health System Requirement Questionnaire
                          </Form.Label>
                          <Form.Control
                            type="file"
                            accept=".csv, .docx, .doc, .xlxs, .xls, .txt, .pdf, .rtx, .zip, .rar"
                            className="py-1 rounded-0"
                            style={{
                              ...Fontstyling.label,
                            }}
                            name="HospitalandHealthSystem"
                            onChange={(event) => {
                              setHospitalHealthSystemFile(
                                event.target.files[0]
                              );
                              const file = event.currentTarget.files[0];
                              setFieldValue("HospitalandHealthSystem", file);
                            }}
                            onBlur={handleBlur}
                            isInvalid={
                              errors.HospitalandHealthSystem &&
                              touched.HospitalandHealthSystem
                            }
                          ></Form.Control>
                          {!HospitalHealthSystemFile &&
                            values.HospitalandHealthSystem !== undefined &&
                            values.HospitalandHealthSystem !== "" &&
                            values.HospitalandHealthSystem !== null && (
                              <div
                                className="text-primary mt-2 cursor-pointer"
                                style={Fontstyling.label}
                                onClick={() =>
                                  FileDownloadForClientRxFile(
                                    values.HospitalandHealthSystem, DrugfileType.HospitalHealth
                                  )
                                }
                              >
                                {values.HospitalandHealthSystem.name ? values.HospitalandHealthSystem.name : values.HospitalandHealthSystem?.split(
                                  "/"
                                ).pop()}
                              </div>
                            )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-2 gap-3 w-50">
                      <Col>
                        <Form.Group>
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            PBM Claims
                          </Form.Label>
                          <Form.Control
                            type="file"
                            accept=".csv"
                            className="py-1 rounded-0"
                            style={{
                              ...Fontstyling.label,
                            }}
                            name="PBMClaims"
                            onChange={(event) => {
                              setPBMClaimsFile(event.target.files[0]);
                              const file = event.currentTarget.files[0];
                              setFieldValue("PBMClaims", file);
                            }}
                            onBlur={handleBlur}
                            isInvalid={errors.PBMClaims && touched.PBMClaims}
                          ></Form.Control>
                          {!PBMClaimsFile &&
                            values.PBMClaims !== undefined &&
                            values.PBMClaims !== "" &&
                            values.PBMClaims !== null && (
                              <div
                                className="text-primary mt-2 cursor-pointer"
                                style={Fontstyling.label}
                                onClick={() =>
                                  FileDownloadForClientRxFile(
                                    values.PBMClaims, DrugfileType.PBMClaims
                                  )
                                }
                              >
                                {values?.PBMClaims.name ? values?.PBMClaims.name :values?.PBMClaims?.split("/").pop()}
                              </div>
                            )}
                        </Form.Group>
                        {values?.PBMClaims === "" && (
                          <div className="">
                            <a
                              className=" text-decoration-none"
                              href="/samplefile/PBMClaims_Template.csv"
                              style={Fontstyling.label}
                              download
                            >
                              Download PBM Claims Template
                            </a>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </div>
                  <div className="d-flex align-items-center justify-content-end gap-3 my-4"> 
                                      
                    <button
                      style={Fontstyling.savebutton}
                      type="button"
                      className="d-flex align-items-center"
                      onClick={() => {
                        handleActions(values, "Save");
                      }}
                    >
                      
                   {isLoader.save && <Loader className="me-2" />}
                      Save
                    
                    </button>
                    <button
                      ref={buttonRef}
                      style={Fontstyling.savebutton}
                      className="d-flex align-items-center"
                      type="submit"
                      onClick={handleValidationError}
                    >{isLoader.complete && <Loader className="me-2" />}
                      Complete
                    </button>
                  </div>
                </Form>
              )}}
            </Formik>)
            
          }
        </Modal.Body>
      </Modal>
      <Modal
        show={showMoreModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== "delete"}
        size={witchAction !== "delete" ? "xl" : ""}
      >
        <Modal.Header
          closeButton
          onHide={() => {
            setShowMoreModal(false);
            setSelectedRowData(null);
          }}
        >
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading2}
          >
            Client and Incumbent Information
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "80vh" }} className="overflow-auto">
          <div className="">
            <Row className="gap-2">
              <Col>
                <p style={Fontstyling.label}>
                  <strong>Client Name:</strong>
                  <span
                    style={{
                      marginLeft: '10px',
                      marginRight: '8px',
                      width: '12px',
                      height: '12px',
                      borderRadius: '50%',
                      backgroundColor: clientStatus ? theme.PRIMARY_LIGHT_GREEN : theme.PRIMARY_RED,
                      display: 'inline-block',
                    }}
                    onClick={() => handleClientChange(selectedRowData?.clientName)}
                  />
                  {selectedRowData?.clientName}
                </p>              
              </Col>
              <Col>
                <p style={Fontstyling.label}>
                  <strong>PBM Name:</strong> {selectedRowData?.pbmName}
                </p>
              </Col>
              <Col>
                <p style={Fontstyling.label}>
                  <strong>Current Contract Termination Date:</strong>{" "}
                  {formattedDate !== "01-01-1900" && formattedDate}
                </p>
              </Col>
            </Row>
            <Row className="gap-2">
              <Col>
                <p style={Fontstyling.label}>
                  <strong>Carrier ID:</strong> {selectedRowData?.carrierID}
                </p>
              </Col>
              <Col>
                <p style={Fontstyling.label}>
                  <strong>Account ID:</strong> {selectedRowData?.accountID}
                </p>
              </Col>
              <Col>
                <p style={Fontstyling.label}>
                  <strong>Group ID:</strong> {selectedRowData?.groupID}
                </p>
              </Col>
            </Row>
            <Row className="gap-2">
              <Col>
                <p style={Fontstyling.label}>
                  <strong>Number of Members :</strong>{" "}
                  {selectedRowData?.numberOfMembers}
                </p>
              </Col>
              <Col>
                {" "}
                <p style={Fontstyling.label}>
                  <strong>Number of Employees :</strong>{" "}
                  {selectedRowData?.numberOfEmployees}
                </p>
              </Col>
              <Col>
              <Row>
                {" "}
                <p style={Fontstyling.label}>
                  <strong>Retail Network Pricing Structure : </strong>{" "}
                  {selectedRowData?.retailNetworkPricingStructure}
                </p>
              </Row>
              <Row>
                {" "}
                {selectedRowData?.retailNetworkPricingStructure === "Other - Explain" && <p style={Fontstyling.label}>
                  <strong>Retail Network Pricing Structure Comment : </strong>{" "}
                  {selectedRowData?.retailNetworkPricingStructureComment}
                </p>}
                </Row>
              </Col>
            </Row>
            <Row className="gap-2">
            <Col>
            <Row>

                {" "}
                <p style={Fontstyling.label}>
                  <strong>Mail Program Pricing Structure : </strong>{" "}
                  {selectedRowData?.mailProgramPricingStructure}
                </p>
            </Row>
            <Row>
                {" "}
                {selectedRowData?.mailProgramPricingStructure === "Other - Explain" && <p style={Fontstyling.label}>
                  <strong>Mail Program Pricing Structure Comment : </strong>{" "}
                  {selectedRowData?.mailProgramPricingStructureComment}
                </p>}

            </Row>
              
              </Col>
              <Col>
              <Row>

                {" "}
                <p style={Fontstyling.label}>
                  <strong>Specialty Program Pricing Structure : </strong>{" "}
                  {selectedRowData?.specialtyProgramPricingStructure}
                </p>
              </Row>
              <Row>

                {" "}
                {selectedRowData?.specialtyProgramPricingStructure === "Other - Explain" && <p style={Fontstyling.label}>
                  <strong>Specialty Program Pricing Structure Comment : </strong>{" "}
                  {selectedRowData?.specialtyProgramPricingStructureComment}
                </p>}
              </Row>
              
              </Col>
            <Col>
            <Row>
                {" "}
                <p style={Fontstyling.label}>
                  <strong>Rebate Program Pricing Structure : </strong>{" "}
                  {selectedRowData?.rebateProgramPricingStructure}
                </p>
              </Row>
              <Row>
                {" "}
                {selectedRowData?.rebateProgramPricingStructure === "Other - Explain" && <p style={Fontstyling.label}>
                  <strong>Rebate Program Pricing Structure Comment : </strong>{" "}
                  {selectedRowData?.rebateProgramPricingStructureComment}
                </p>}
              </Row>
            </Col>
            </Row>
            <Row className="gap-2">
              <Col>
                {" "}
                <p style={Fontstyling.label}>
                  <strong>Retail 30 Network : </strong>{" "}
                  {selectedRowData?.retail30Network}
                </p>
              </Col>
              <Col>
                <p style={Fontstyling.label}>
                  <strong>Retail 90 Network : </strong>
                  {selectedRowData?.retai90Network}
                </p>
              </Col>
              <Col>
                <p style={Fontstyling.label}>
                  <strong>Mail Program :</strong> {selectedRowData?.mailProgram}
                </p>
              </Col>
              </Row>
              <Row className="gap-2">
              <Col>
                {" "}
                <p style={Fontstyling.label}>
                  <strong>Specialty Program :</strong>{" "}
                  {selectedRowData?.specialtyProgram}
                </p>
              </Col>
              <Col>
                {" "}
                <p style={Fontstyling.label}>
                  <strong>Clinical Programs :</strong>{" "}
                  {selectedRowData?.clinicalPrograms}
                </p>
              </Col>
              <Col>
                {" "}
                <p style={Fontstyling.label}>
                  <strong>Formulary Strategy :</strong>{" "}
                  {selectedRowData?.formularyStrategy}
                </p>
              </Col>
            </Row>
            <Row className="gap-2">
              <Col>
                {" "}
                <p style={Fontstyling.label}>
                  <strong>Specialty Copay Card :</strong>{" "}
                  {selectedRowData?.specialtyCopayCard}
                </p>
              </Col>
              <Col>
                {" "}
                <p style={Fontstyling.label}>
                  <strong>Alternative Funding :</strong>{" "}
                  {selectedRowData?.alternativeFunding}
                </p>
              </Col>
              <Col>
                <p style={Fontstyling.label}>
                  <strong>Accumulator Adjustment Program :</strong>{" "}
                  {selectedRowData?.accumulatorAdjustmentProgram}
                </p>
              </Col>
              
            </Row>
            <Row>
            <Col>
                {" "}
                <p style={Fontstyling.label}>
                  <strong>Onsite Pharmacy ID :</strong>{" "}
                  {selectedRowData?.onsitePharmacyID}
                </p>
              </Col>
            </Row>
          </div>
          <label className="mt-2 fw-bold" style={Fontstyling.label_14}>
            Non-Specialty Drugs
          </label>
          <div className="container  p-0">
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead className="thead-dark">
                  <tr className="text-center">
                    <th colspan="2" style={Fontstyling.label}>
                      AWP-% Discounts
                    </th>
                    <th colspan="2" style={Fontstyling.label}>
                      Dispensing Fees
                    </th>
                    <th colspan="2" style={Fontstyling.label}>
                      Rebates
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={Fontstyling.label}>
                    <td style={Fontstyling.label}>Mail Brands</td>
                    <td>
                      {+noSpecialtyDrugs?.NonSp_MailBrands_AWPDiscounts
                        ? (
                            noSpecialtyDrugs?.NonSp_MailBrands_AWPDiscounts *
                            AWPDiscounts
                          ).toFixed(2)
                        : 0}
                      {AWPPercentage}
                    </td>
                    <td style={Fontstyling.label}>Mail Brands</td>
                    <td>
                      {dollerIcon}
                      {noSpecialtyDrugs?.NonSp_MailBrands_DispensingFees
                        ? noSpecialtyDrugs?.NonSp_MailBrands_DispensingFees
                        : 0}
                    </td>
                    <td style={Fontstyling.label}>Mail Brands</td>
                    <td>
                      {dollerIcon}
                      {noSpecialtyDrugs?.NonSp_MailBrands_Rebates
                        ? noSpecialtyDrugs?.NonSp_MailBrands_Rebates
                        : 0}
                    </td>
                  </tr>
                  <tr style={Fontstyling.label}>
                    <td style={Fontstyling.label}>Mail Generics</td>
                    <td>
                      {+noSpecialtyDrugs?.NonSp_MailGenerics_AWPDiscounts
                        ? (
                            noSpecialtyDrugs?.NonSp_MailGenerics_AWPDiscounts *
                            AWPDiscounts
                          ).toFixed(2)
                        : 0}
                      {AWPPercentage}
                    </td>
                    <td style={Fontstyling.label}>Mail Generics</td>
                    <td>
                      {dollerIcon}
                      {noSpecialtyDrugs?.NonSp_MailGenerics_DispensingFees
                        ? noSpecialtyDrugs?.NonSp_MailGenerics_DispensingFees
                        : 0}
                    </td>
                    <td style={Fontstyling.label}>Retail 30 Brands</td>
                    <td>
                      {dollerIcon}
                      {noSpecialtyDrugs?.NonSp_Retail30Brands_Rebates
                        ? noSpecialtyDrugs?.NonSp_Retail30Brands_Rebates
                        : 0}
                    </td>
                  </tr>
                  <tr style={Fontstyling.label}>
                    <td style={Fontstyling.label}>Retail 30 Brands</td>
                    <td>
                      {+noSpecialtyDrugs?.NonSp_Retail30Brands_AWPDiscounts
                        ? (
                            noSpecialtyDrugs?.NonSp_Retail30Brands_AWPDiscounts *
                            AWPDiscounts
                          ).toFixed(2)
                        : 0}
                      {AWPPercentage}
                    </td>
                    <td style={Fontstyling.label}>Retail 30 Brands</td>
                    <td>
                      {dollerIcon}
                      {noSpecialtyDrugs?.NonSp_Retail30Brands_DispensingFees
                        ? noSpecialtyDrugs?.NonSp_Retail30Brands_DispensingFees
                        : 0}
                    </td>
                    <td style={Fontstyling.label}>Retail 90 Brands</td>
                    <td>
                      {dollerIcon}
                      {noSpecialtyDrugs?.NonSp_Retail90Brands_Rebates
                        ? noSpecialtyDrugs?.NonSp_Retail90Brands_Rebates
                        : 0}
                    </td>
                  </tr>
                  <tr className="border-0 " style={Fontstyling.label}>
                    <td style={Fontstyling.label} className="border">
                      Retail 30 Generics
                    </td>
                    <td className="border">
                      {+noSpecialtyDrugs?.NonSp_Retail30Generics_AWPDiscounts
                        ? (
                            noSpecialtyDrugs?.NonSp_Retail30Generics_AWPDiscounts *
                            AWPDiscounts
                          ).toFixed(2)
                        : 0}
                      {AWPPercentage}
                    </td>
                    <td style={Fontstyling.label} className="border">
                      Retail 30 Generics
                    </td>
                    <td className="border">
                      {dollerIcon}
                      {noSpecialtyDrugs?.NonSp_Retail30Generics_DispensingFees
                        ? noSpecialtyDrugs?.NonSp_Retail30Generics_DispensingFees
                        : 0}
                    </td>
                  </tr>
                  <tr className="border-0" style={Fontstyling.label}>
                    <td style={Fontstyling.label} className="border">
                      Retail 90 Brands
                    </td>
                    <td className="border">
                      {+noSpecialtyDrugs?.NonSp_Retail90Brands_AWPDiscounts
                        ? (
                            noSpecialtyDrugs?.NonSp_Retail90Brands_AWPDiscounts *
                            AWPDiscounts
                          ).toFixed(2)
                        : 0}
                      {AWPPercentage}
                    </td>
                    <td style={Fontstyling.label} className="border">
                      Retail 90 Brands
                    </td>
                    <td className="border">
                      {dollerIcon}
                      {noSpecialtyDrugs?.NonSp_Retail90Brands_DispensingFees
                        ? noSpecialtyDrugs?.NonSp_Retail90Brands_DispensingFees
                        : 0}
                    </td>
                  </tr>
                  <tr className="border-0" style={Fontstyling.label}>
                    <td style={Fontstyling.label} className="border">
                      Retail 90 Generics
                    </td>
                    <td className="border">
                      {+noSpecialtyDrugs?.NonSp_Retail90Generics_AWPDiscounts
                        ? (
                            noSpecialtyDrugs?.NonSp_Retail90Generics_AWPDiscounts *
                            AWPDiscounts
                          ).toFixed(2)
                        : 0}
                      {AWPPercentage}
                    </td>
                    <td style={Fontstyling.label} className="border">
                      Retail 90 Generics
                    </td>
                    <td className="border">
                      {dollerIcon}
                      {noSpecialtyDrugs?.NonSp_Retail90Generics_DispensingFees
                        ? noSpecialtyDrugs?.NonSp_Retail90Generics_DispensingFees
                        : 0}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <label className="mt-2 fw-bold mb-2 " style={Fontstyling.label_14}>
            Non-Specialty AWP-% and Dispensing Fee Price Guarantees and
            Exclusions
          </label>
          <Row>
            <Col>
              <p style={Fontstyling.label}>
                <strong>
                  Select all claim types that are excluded from your guarantees
                  :
                </strong>{" "}
                {nonSpecialtySDFPGE?.nonSpltdiscountDispensingFeeGuarantees}
              </p>
            </Col>
            <Col>
              <p style={Fontstyling.label}>
                <strong>State :</strong> {nonSpecialtySDFPGE?.nonSplState}
              </p>
            </Col>
          </Row>
          {nonSpecialtySDFPGE?.nonSpltdiscountDispensingFeeGuaranteesComment && (
            <Row>
              <Col>
                <p style={Fontstyling.label}>
                  <strong>Comment :</strong>{" "}
                </p>
              </Col>
              <Col>
                <p style={Fontstyling.label}>
                  {
                    nonSpecialtySDFPGE?.nonSpltdiscountDispensingFeeGuaranteesComment
                  }
                </p>
              </Col>
            </Row>
          )}

          <label className="mt-2 fw-bold mb-2 " style={Fontstyling.label_14}>
            Rebate Guarantees and Exclusions
          </label>
          <Row>
            <Col>
              <p style={Fontstyling.label}>
                <strong>
                  Select all claim types that are excluded from your guarantees
                  :
                </strong>{" "}
                {
                  nonRebateGuaranteesExclusions?.nonSpltRebatediscountDispensingFeeGuarantees
                }
              </p>
            </Col>
            <Col>
              <p style={Fontstyling.label}>
                <strong>State :</strong>{" "}
                {nonRebateGuaranteesExclusions?.nonRebateSplState}
              </p>
            </Col>
          </Row>
          {nonRebateGuaranteesExclusions?.nonSpltRebatediscountDispensingFeeGuaranteesComment && (
            <Row>
              <Col>
                <p style={Fontstyling.label}>
                  <strong>Comment :</strong>{" "}
                </p>
              </Col>
              <Col>
                <p style={Fontstyling.label}>
                  {
                    nonRebateGuaranteesExclusions?.nonSpltRebatediscountDispensingFeeGuaranteesComment
                  }
                </p>
              </Col>
            </Row>
          )}
          <Row>
            <Col>
              <p style={Fontstyling.label}>
                <strong>
                  Confirm the claim type basis for your rebate proposal :
                </strong>{" "}
                {nonRebateGuaranteesExclusions?.nonrebateProposal}
              </p>
            </Col>
            <Col>
              <p style={Fontstyling.label}>
                <strong>Confirm your rebate structure :</strong>{" "}
                {nonRebateGuaranteesExclusions?.nonrebateStructure}
              </p>
            </Col>
          </Row>
          <Row>
            <Col>
              <p style={Fontstyling.label}>
                <strong>
                  Please specify all products excluded from rebates due to low
                  Wholesale Acquisition Cost (WAC) strategy :
                </strong>{" "}
              </p>
            </Col>
            <Col>
              <p style={Fontstyling.label}>
                {
                  nonRebateGuaranteesExclusions?.nonWholesaleAcquisitionCostStrategy
                }
              </p>
            </Col>
          </Row>
          <Row>
            <Col>
              <p style={Fontstyling.label}>
                <strong>Insulin claims :</strong>{" "}
                {nonRebateGuaranteesExclusions?.InsulinClaims}
              </p>
            </Col>
            {nonRebateGuaranteesExclusions?.nonrebateProposal !== "per formulary (preferred) brand claim" &&
            <Col>
              <p style={Fontstyling.label}>
                <strong>Retail Non-preferred or Tier 3 brand claims :</strong>{" "}
                {
                  nonRebateGuaranteesExclusions?.RetailNonPreferredTier3BrandClaims
                }
              </p>
            </Col>}
          </Row>
          {nonRebateGuaranteesExclusions?.nonrebateProposal !== "per formulary (preferred) brand claim" &&<Row>
            <Col>
              <p style={Fontstyling.label}>
                <strong>
                  Retail 90 Non-preferred or Tier 3 brand claims :
                </strong>{" "}
                {
                  nonRebateGuaranteesExclusions?.Retail90NonPreferredTier3BrandClaims
                }
              </p>
            </Col>
            <Col>
              <p style={Fontstyling.label}>
                <strong>Mail Non-preferred or Tier 3 brand claims :</strong>{" "}
                {
                  nonRebateGuaranteesExclusions?.MailNonPreferredTier3BrandClaims
                }
              </p>
            </Col>
          </Row>}
          <label className="my-2 fw-bold" style={Fontstyling.label_14}>
            Specialty Drugs
          </label>
          <div className="container  p-0">
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead className="thead-dark">
                  <tr className="text-center">
                    <th colspan="2" style={Fontstyling.label}>
                      AWP-% Discounts
                    </th>
                    <th colspan="2" style={Fontstyling.label}>
                      Dispensing Fees
                    </th>
                    <th colspan="2" style={Fontstyling.label}>
                      Rebates
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={Fontstyling.label}>
                    <td style={Fontstyling.label}>Mail Brands</td>
                    <td>
                      {+specialtyDrugs?.Sp_MailBrands_AWPDiscounts
                        ? (
                            specialtyDrugs?.Sp_MailBrands_AWPDiscounts *
                            AWPDiscounts
                          ).toFixed(2)
                        : 0}
                      {AWPPercentage}
                    </td>
                    <td style={Fontstyling.label}>Mail Brands</td>
                    <td>
                      {dollerIcon}
                      {specialtyDrugs?.Sp_MailBrands_DispensingFees
                        ? specialtyDrugs?.Sp_MailBrands_DispensingFees
                        : 0}
                    </td>
                    <td style={Fontstyling.label}>Mail Brands</td>
                    <td>
                      {dollerIcon}
                      {specialtyDrugs?.Sp_MailBrands_Rebates
                        ? specialtyDrugs?.Sp_MailBrands_Rebates
                        : 0}
                    </td>
                  </tr>
                  <tr style={Fontstyling.label}>
                    <td style={Fontstyling.label}>Mail Generics</td>
                    <td>
                      {+specialtyDrugs?.Sp_MailGenerics_AWPDiscounts
                        ? (
                            specialtyDrugs?.Sp_MailGenerics_AWPDiscounts *
                            AWPDiscounts
                          ).toFixed(2)
                        : 0}
                      {AWPPercentage}
                    </td>
                    <td style={Fontstyling.label}>Mail Generics</td>
                    <td>
                      {dollerIcon}
                      {specialtyDrugs?.Sp_MailGenerics_DispensingFees
                        ? specialtyDrugs?.Sp_MailGenerics_DispensingFees
                        : 0}
                    </td>
                    <td style={Fontstyling.label}>Retail 30 Brands</td>
                    <td>
                      {dollerIcon}
                      {specialtyDrugs?.Sp_Retail30Brands_Rebates
                        ? specialtyDrugs?.Sp_Retail30Brands_Rebates
                        : 0}
                    </td>
                  </tr>
                  <tr style={Fontstyling.label}>
                    <td style={Fontstyling.label}>Retail 30 Brands</td>
                    <td>
                      {+specialtyDrugs?.Sp_Retail30Brands_AWPDiscounts
                        ? (
                            specialtyDrugs?.Sp_Retail30Brands_AWPDiscounts *
                            AWPDiscounts
                          ).toFixed(2)
                        : 0}
                      {AWPPercentage}
                    </td>
                    <td style={Fontstyling.label}>Retail 30 Brands</td>
                    <td>
                      {dollerIcon}
                      {specialtyDrugs?.Sp_Retail30Brands_DispensingFees
                        ? specialtyDrugs?.Sp_Retail30Brands_DispensingFees
                        : 0}
                    </td>
                    <td style={Fontstyling.label}>Retail 90 Brands</td>
                    <td>
                      {dollerIcon}
                      {specialtyDrugs?.Sp_Retail90Brands_Rebates
                        ? specialtyDrugs?.Sp_Retail90Brands_Rebates
                        : 0}
                    </td>
                  </tr>
                  <tr style={Fontstyling.label}>
                    <td style={Fontstyling.label}>Retail 30 Generics</td>
                    <td>
                      {+specialtyDrugs?.Sp_Retail30Generics_AWPDiscounts
                        ? (
                            specialtyDrugs?.Sp_Retail30Generics_AWPDiscounts *
                            AWPDiscounts
                          ).toFixed(2)
                        : 0}
                      {AWPPercentage}
                    </td>
                    <td style={Fontstyling.label}>Retail 30 Generics</td>
                    <td>
                      {dollerIcon}
                      {specialtyDrugs?.Sp_Retail30Generics_DispensingFees
                        ? specialtyDrugs?.Sp_Retail30Generics_DispensingFees
                        : 0}
                    </td>
                    <td style={Fontstyling.label}>Specialty Pharmacy Brands</td>
                    <td>
                      {dollerIcon}
                      {specialtyDrugs?.Sp_SpecialtyPharmacyBrands_Rebates
                        ? specialtyDrugs?.Sp_SpecialtyPharmacyBrands_Rebates
                        : 0}
                    </td>
                  </tr>
                  <tr className="border-0" style={Fontstyling.label}>
                    <td style={Fontstyling.label} className="border">
                      Retail 90 Brands
                    </td>
                    <td className="border">
                      {+specialtyDrugs?.Sp_Retail90Brands_AWPDiscounts
                        ? (
                            specialtyDrugs?.Sp_Retail90Brands_AWPDiscounts *
                            AWPDiscounts
                          ).toFixed(2)
                        : 0}
                      {AWPPercentage}
                    </td>
                    <td style={Fontstyling.label} className="border">
                      Retail 90 Brands
                    </td>
                    <td className="border">
                      {dollerIcon}
                      {specialtyDrugs?.Sp_Retail90Brands_DispensingFees
                        ? specialtyDrugs?.Sp_Retail90Brands_DispensingFees
                        : 0}
                    </td>
                  </tr>
                  <tr className="border-0" style={Fontstyling.label}>
                    <td style={Fontstyling.label} className="border">
                      Retail 90 Generics
                    </td>
                    <td className="border">
                      {+specialtyDrugs?.Sp_Retail90Generics_AWPDiscounts
                        ? (
                            specialtyDrugs?.Sp_Retail90Generics_AWPDiscounts *
                            AWPDiscounts
                          ).toFixed(2)
                        : 0}
                      {AWPPercentage}
                    </td>
                    <td style={Fontstyling.label} className="border">
                      Retail 90 Generics
                    </td>
                    <td className="border">
                      {dollerIcon}
                      {specialtyDrugs?.Sp_Retail90Generics_DispensingFees
                        ? specialtyDrugs?.Sp_Retail90Generics_DispensingFees
                        : 0}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <label className="my-2 fw-bold" style={Fontstyling.label_14}>
            Specialty AWP-% and Dispensing Fee Price Guarantees and Exclusions
            (All Day Supply)
          </label>
          <Row>
            <Col>
              <p style={Fontstyling.label}>
                <strong>
                  Select all claim types that are excluded from your guarantees
                  :
                </strong>{" "}
                {specialtySDFPGE?.spltdiscountDispensingFeeGuarantees}
              </p>
            </Col>
            <Col>
              <p style={Fontstyling.label}>
                <strong>State :</strong> {specialtySDFPGE?.splState}
              </p>
            </Col>
          </Row>
          {specialtySDFPGE?.spltdiscountDispensingFeeGuaranteesComment && (
            <Row>
              <Col>
                <p style={Fontstyling.label}>
                  <strong>Comment :</strong>{" "}
                </p>
              </Col>
              <Col>
                <p style={Fontstyling.label}>
                  {specialtySDFPGE?.spltdiscountDispensingFeeGuaranteesComment}
                </p>
              </Col>
            </Row>
          )}

          <label className="mt-2 fw-bold mb-2 " style={Fontstyling.label_14}>
            Rebate Guarantees and Exclusions
          </label>
          <Row>
            <Col>
              <p style={Fontstyling.label}>
                <strong>
                  Select all claim types that are excluded from your guarantees
                  :
                </strong>{" "}
                {
                  rebateGuaranteesExclusions?.spltRebatediscountDispensingFeeGuarantees
                }
              </p>
            </Col>
            <Col>
              <p style={Fontstyling.label}>
                <strong>State :</strong>{" "}
                {rebateGuaranteesExclusions?.splRebateState}
              </p>
            </Col>
          </Row>
          {rebateGuaranteesExclusions?.spltRebatediscountDispensingFeeGuaranteesComment && (
            <Row>
              <Col>
                <p style={Fontstyling.label}>
                  <strong>Comment :</strong>{" "}
                </p>
              </Col>
              <Col>
                <p style={Fontstyling.label}>
                  {
                    rebateGuaranteesExclusions?.spltRebatediscountDispensingFeeGuaranteesComment
                  }
                </p>
              </Col>
            </Row>
          )}
          <Row>
            <Col>
              <p style={Fontstyling.label}>
                <strong>
                  Confirm the claim type basis for your rebate proposal :
                </strong>{" "}
                {rebateGuaranteesExclusions?.splrebateProposal}
              </p>
            </Col>
            <Col>
              <p style={Fontstyling.label}>
                <strong>Confirm your rebate structure :</strong>{" "}
                {rebateGuaranteesExclusions?.splrebateStructure}
              </p>
            </Col>
          </Row>
          <Row>
            <Col>
              <p style={Fontstyling.label}>
                <strong>
                  Please specify all products excluded from rebates due to low
                  Wholesale Acquisition Cost (WAC) strategy :
                </strong>{" "}
              </p>
            </Col>
            <Col>
              <p style={Fontstyling.label}>
                {
                  rebateGuaranteesExclusions?.splWholesaleAcquisitionCostStrategy
                }
              </p>
            </Col>
          </Row>
          <Row>
            <Col>
              <p style={Fontstyling.label}>
                <strong>Limited Distribution Drug claims :</strong>{" "}
                {rebateGuaranteesExclusions?.LimitedDistributionDrugClaims}
              </p>
            </Col>
            <Col>
              <p style={Fontstyling.label}>
                <strong>Biosimilar claims :</strong>{" "}
                {rebateGuaranteesExclusions?.BiosimilarClaims}
              </p>
            </Col>
            <Col>
              <p style={Fontstyling.label}>
                <strong>HIV claims :</strong>{" "}
                {rebateGuaranteesExclusions?.HIVClaims}
              </p>
            </Col>
          </Row>
         {rebateGuaranteesExclusions?.splrebateProposal !== "per formulary (preferred) brand claim" && <Row>
            <Col>
              <p style={Fontstyling.label}>
                <strong>
                  Specialty Retail Non-preferred or Tier 3 brand claims :
                </strong>{" "}
                {
                  rebateGuaranteesExclusions?.SpecialtyNonPreferredTier3BrandClaims
                }
              </p>
            </Col>
            <Col>
              <p style={Fontstyling.label}>
                <strong>
                  Specialty Retail 90 Non-Preferred Tier 3 Brand claims :
                </strong>{" "}
                {
                  rebateGuaranteesExclusions?.SpecialtyRetail90NonPreferredTier3BrandClaims
                }
              </p>
            </Col>
            <Col>
              <p style={Fontstyling.label}>
                <strong>
                  Specialty Mail Non-Preferred or Tier 3 Brand Claims :
                </strong>{" "}
                {
                  rebateGuaranteesExclusions?.SpecialtyMailNonPreferredorTier3BrandClaims
                }
              </p>
            </Col>
            <Col>
              <p style={Fontstyling.label}>
                <strong>
                  Specialty PBM Non-Preferred or Tier 3 Brand Pharmacy Claims :
                </strong>{" "}
                {
                  rebateGuaranteesExclusions?.SpecialtyPBMNonPreferredorTier3BrandPharmacyClaims
                }
              </p>
            </Col>
          </Row>}
          <label className="mt-2 fw-bold mb-2 " style={Fontstyling.label_14}>
            PBM Fees and Credits
          </label>
          <Row>
            <Col className="col-4"></Col>
            <Col className="col-3 text-center">
              <Form.Label style={Fontstyling.label} className="fw-bold">
                Basis
              </Form.Label>
            </Col>
            <Col className="col-3 text-center">
              <Form.Label style={Fontstyling.label} className="fw-bold">
                Fee ($)
              </Form.Label>
            </Col>
          </Row>
          <Row>
            <Col className="col-4">
              <p style={Fontstyling.label}>
                <strong>PBM administration fees :</strong>{" "}
              </p>
            </Col>
            <Col className="col-3 text-center">
              <Form.Label style={Fontstyling.label}>
                {pbmFeesCredits?.PBMadministrationfeesBasis}
              </Form.Label>
            </Col>
            <Col className="col-3 text-center">
              <Form.Label style={Fontstyling.label}>
                {pbmFeesCredits?.PBMadministrationfeesResponseFormat}
              </Form.Label>
            </Col>
          </Row>
          <Row>
            <Col className="col-4">
              <p style={Fontstyling.label}>
                <strong>PBM total paid rebates :</strong>{" "}
              </p>
            </Col>
            <Col className="col-3 text-center"></Col>
            <Col className="col-3 text-center">
              <Form.Label style={Fontstyling.label}>
                {pbmFeesCredits?.PBMtotalpaidrebatesResponseFormat}
              </Form.Label>
            </Col>
          </Row>
          <Row>
            <Col className="col-4">
              <p style={Fontstyling.label}>
                <strong>PBM transaction fees :</strong>{" "}
              </p>
            </Col>
            <Col className="col-3 text-center">
              <Form.Label style={Fontstyling.label}>
                {pbmFeesCredits?.PBMtransactionfeesBasis}
              </Form.Label>
            </Col>
            <Col className="col-3 text-center">
              <Form.Label style={Fontstyling.label}>
                {pbmFeesCredits?.PBMtransactionfeesResponseFormat}
              </Form.Label>
            </Col>
          </Row>
          <Row>
            <Col className="col-4">
              <p style={Fontstyling.label}>
                <strong>Coalition or Aggregator membership fees :</strong>{" "}
              </p>
            </Col>
            <Col className="col-3 text-center">
              <Form.Label style={Fontstyling.label}>
                {pbmFeesCredits?.CoalitionorAggregatorfeesBasis}
              </Form.Label>
            </Col>
            <Col className="col-3 text-center">
              <Form.Label style={Fontstyling.label}>
                {pbmFeesCredits?.CoalitionorAggregatorfeesResponseFormat}
              </Form.Label>
            </Col>
          </Row>
          <Row>
            <Col>
              <p style={Fontstyling.label}>
                <strong>
                  Please list and specify all other fees related to your program
                  bid including % of Savings, PEPM, etc. fees. :
                </strong>{" "}
              </p>
            </Col>
            <Col>
              <p style={Fontstyling.label}>
                {pbmFeesCredits?.listandspecifyallotherfees}
              </p>
            </Col>
          </Row>
          <Row>
            <Col className="col-4">
              <p style={Fontstyling.label}>
                <strong>Onsite Pharmacy PBM Administration Fee :</strong>{" "}
              </p>
            </Col>
            <Col className="col-3 text-center">
              <Form.Label style={Fontstyling.label}>
                {pbmFeesCredits?.onsitePharmacyPBMAdministrationFeeBasis}
              </Form.Label>
            </Col>
            <Col className="col-3 text-center">
              <Form.Label style={Fontstyling.label}>
                {
                  pbmFeesCredits?.onsitePharmacyPBMAdministrationFeeResponseFormat
                }
              </Form.Label>
            </Col>
          </Row>
          <Row>
            <Col className="col-4">
              <p style={Fontstyling.label}>
                <strong>Onsite Pharmacy Aggregator Administration Fee :</strong>{" "}
              </p>
            </Col>
            <Col className="col-3 text-center">
              <Form.Label style={Fontstyling.label}>
                {pbmFeesCredits?.onsitePharmacyAggregatorAdministrationFeeBasis}
              </Form.Label>
            </Col>
            <Col className="col-3 text-center">
              <Form.Label style={Fontstyling.label}>
                {
                  pbmFeesCredits?.onsitePharmacyAggregatorAdministrationFeeResponseFormat
                }
              </Form.Label>
            </Col>
          </Row>
          {selectedRowData?.pbmContractFileUrl !== undefined &&
            selectedRowData?.pbmContractFileUrl !== "" &&
            selectedRowData.pbmContractFileUrl !== null && (
              <Row className="mt-5">
                <Col>
                  <p style={Fontstyling.label}>
                    <strong>PBM Contract :</strong>{" "}
                    <div
                      className="text-primary mt-2 cursor-pointer"
                      style={{ fontSize: "12px", fontFamily: "Arial" }}
                      onClick={() =>
                        FileDownloadForClientRxFile(
                          selectedRowData?.pbmContractFileUrl, DrugfileType.PBMContract
                        )
                      }
                    >
                      {selectedRowData?.pbmContractFileUrl.split("/").pop()}
                    </div>
                  </p>
                </Col>
              </Row>
            )}
          {selectedRowData?.hospitalHealthSystemRequirementQuestionnaireFileUrl !==
            undefined &&
            selectedRowData?.hospitalHealthSystemRequirementQuestionnaireFileUrl !==
              "" &&
            selectedRowData.hospitalHealthSystemRequirementQuestionnaireFileUrl !==
              null && (
              <Row className="mt-2">
                <Col>
                  <p style={Fontstyling.label}>
                    <strong>
                      Hospital and Health System Requirement Questionnaire :
                    </strong>{" "}
                    <div
                      className="text-primary mt-2 cursor-pointer"
                      style={{ fontSize: "12px", fontFamily: "Arial" }}
                      onClick={() =>
                        FileDownloadForClientRxFile(
                          selectedRowData?.hospitalHealthSystemRequirementQuestionnaireFileUrl, DrugfileType.HospitalHealth
                        )
                      }
                    >
                      {selectedRowData?.hospitalHealthSystemRequirementQuestionnaireFileUrl
                        .split("/")
                        .pop()}
                    </div>
                  </p>
                </Col>
              </Row>
            )}
          {selectedRowData?.pbmClaimsFileUrl !== undefined &&
            selectedRowData?.pbmClaimsFileUrl !== "" &&
            selectedRowData.pbmClaimsFileUrl !== null && (
              <Row className="mt-2">
                <Col>
                  <p style={Fontstyling.label}>
                    <strong>PBM Claims :</strong>{" "}
                    <div
                      className="text-primary mt-2 cursor-pointer"
                      style={{ fontSize: "12px", fontFamily: "Arial" }}
                      onClick={() =>
                        FileDownloadForClientRxFile(
                          selectedRowData?.pbmClaimsFileUrl, DrugfileType.PBMClaims
                        )
                      }
                    >
                      {selectedRowData?.pbmClaimsFileUrl.split("/").pop()}
                    </div>
                  </p>
                </Col>
              </Row>
            )}
        </Modal.Body>
      </Modal>
      <div style={Fontstyling.errorlabel} className="w-full fw-bold  mb-3 ">
        The information in whole or in part contained herein is confidential and
        proprietary. Sharing any information element by any mode of transmission
        without express written permission from the incumbent PBM to the any
        recipient is prohibited.
      </div>
      <div className="d-flex align-item-center justify-content-between py-3 border-bottom">
        <div className="p-0 m-0" style={Fontstyling.heading}>
          List of Client Rx Information Baseline
        </div>
        {(user?.UserRole === "Pharmacy" || user?.UserRole === "Admin") && (
          <CustomButton
            onClick={() => {
              setWitchAction("add");
              setShowModal(true);
            }}
          >
            Add Client Rx Information Baseline
          </CustomButton>
        )}
      </div>
      {csvData.length >= 1 &&
        (user?.UserRole === "Pharmacy" || user?.UserRole === "Admin") && (
          <CustomButton className="text-nowrap d-flex align-items-center mt-2">
            <SaveAltIcon
              className="me-2"
              style={{ opacity: csvData.length <= 1 ? 0.5 : 1 }}
            />
            <CSVLink
              filename={fileName}
              data={csvData}
              style={{ color: "white", textDecoration: "none" }}
            >
              Export to CSV
            </CSVLink>
          </CustomButton>
        )}
      {showTable && (
        <CustomMaterialTable
          overrideColumn={column}
          data={(query) =>
            new Promise((resolve, reject) => {
              fetchData(query?.page, query?.pageSize, query?.search)
                .then((data) => {
                  resolve(data);
                })
                .catch((error) => {
                  reject(error);
                });
            })
          }
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          setWitchAction={setWitchAction}
          setSelectedRowData={setSelectedRowData}
          setShowModal={setShowModal}
          isLoading={isLoading}
          isExport={false}
        />
      )}
    </div>
  );
};

export default ClientRxInformation;